import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date without a time in the format of "2020-05-15" */
  Date: string;
  /** A date with a time in UTC like "2020-05-15T12:15:33.123Z" */
  DateTime: string;
  /** Helper for returning void from a mutation */
  Void: void;
};

export type ActivateBoxKeyReturn = {
  __typename: 'ActivateBoxKeyReturn';
  boxKeyOrSwabCode: Scalars['String'];
  isVetAffiliate: Scalars['Boolean'];
  pets: Array<Pet>;
  productSkuPrefix: Maybe<Scalars['String']>;
};

export type ActivateContributeToResearchInput = {
  petNum: Scalars['Int'];
  shouldContributeToResearch: Scalars['Boolean'];
};

export type ActivateHowDidYouHearInput = {
  howDidYouHearAboutEmbark?: InputMaybe<HowHeardAboutUsOptions>;
  petNum: Scalars['Int'];
  pleaseSpecifyPodcastOrOther?: InputMaybe<Scalars['String']>;
};

export type ActivateKitMutation = {
  __typename: 'ActivateKitMutation';
  activateBoxKeyOrSwabCode: ActivateBoxKeyReturn;
  activateContributeToResearch: Maybe<Scalars['Void']>;
  activateHowDidYouHear: Maybe<Scalars['Void']>;
  activateSelectDog: ActivateSelectDogReturn;
};


export type ActivateKitMutationActivateBoxKeyOrSwabCodeArgs = {
  boxKeyOrSwabCode: Scalars['String'];
};


export type ActivateKitMutationActivateContributeToResearchArgs = {
  input: ActivateContributeToResearchInput;
};


export type ActivateKitMutationActivateHowDidYouHearArgs = {
  input: ActivateHowDidYouHearInput;
};


export type ActivateKitMutationActivateSelectDogArgs = {
  boxKeyOrSwabCode: Scalars['String'];
  petNum: Scalars['Int'];
  practiceId: InputMaybe<Scalars['String']>;
};

export type ActivateSelectDogReturn = {
  __typename: 'ActivateSelectDogReturn';
  boxKey: Maybe<Scalars['String']>;
  pet: Pet;
  productSkuPrefix: Maybe<Scalars['String']>;
  swabCode: Maybe<Scalars['String']>;
  testType: TestType;
};

export type ActivateSwabInput = {
  /** boxKey and swabCode are mutually exclusive. Only provide one of them to activate a swab */
  boxKey?: InputMaybe<Scalars['String']>;
  petNum: Scalars['Int'];
  /** boxKey and swabCode are mutually exclusive. Only provide one of them to activate a swab */
  swabCode?: InputMaybe<Scalars['String']>;
  vetActivationDetails?: InputMaybe<VetActivationDetails>;
};

export type AddressComponent = {
  long_name: Scalars['String'];
  short_name: Scalars['String'];
  types: Array<Scalars['String']>;
};

export type AddressComponentsType = {
  __typename: 'AddressComponentsType';
  longName: Scalars['String'];
  shortName: Scalars['String'];
  types: Array<Scalars['String']>;
};

/** This type can be extended with `extend type AdminMutation` to add administrator only mutations in other graphql files */
export type AdminMutation = {
  __typename: 'AdminMutation';
  addSurvey: Survey;
  addSurveyCategory: SurveyCategory;
  updateSurvey: Survey;
  updateSurveyCategory: SurveyCategory;
};


/** This type can be extended with `extend type AdminMutation` to add administrator only mutations in other graphql files */
export type AdminMutationAddSurveyArgs = {
  survey: SurveyInput;
};


/** This type can be extended with `extend type AdminMutation` to add administrator only mutations in other graphql files */
export type AdminMutationAddSurveyCategoryArgs = {
  category: SurveyCategoryInput;
};


/** This type can be extended with `extend type AdminMutation` to add administrator only mutations in other graphql files */
export type AdminMutationUpdateSurveyArgs = {
  survey: SurveyInput;
  surveyId: Scalars['String'];
};


/** This type can be extended with `extend type AdminMutation` to add administrator only mutations in other graphql files */
export type AdminMutationUpdateSurveyCategoryArgs = {
  category: SurveyCategoryInput;
  surveyCategoryId: Scalars['String'];
};

/** This type can be extended with `extend type AdminQuery` to add administrator only queries in other graphql files */
export type AdminQuery = {
  __typename: 'AdminQuery';
  getAllSurveyCategories: Array<SurveyCategory>;
  getAllSurveys: Array<Survey>;
  getSurvey: Maybe<Survey>;
  getSurveyCategory: Maybe<SurveyCategory>;
};


/** This type can be extended with `extend type AdminQuery` to add administrator only queries in other graphql files */
export type AdminQueryGetSurveyArgs = {
  surveyId: Scalars['String'];
};


/** This type can be extended with `extend type AdminQuery` to add administrator only queries in other graphql files */
export type AdminQueryGetSurveyCategoryArgs = {
  surveyCategoryId: Scalars['String'];
};

/**
 * The args sent from React to MyEv Proxy
 * to update Age Test Result feedback
 */
export type AgeTestResultFeedbackArgs = {
  isAccurate: Scalars['Boolean'];
  petNum: Scalars['Int'];
  resultsUuid: Scalars['String'];
};

export enum AgeTestStatus {
  Activated = 'Activated',
  DnaAnalyzed = 'DnaAnalyzed',
  DnaExtracted = 'DnaExtracted',
  Error = 'Error',
  /** @deprecated Use more specific state - DnaExtracted or DnaAnalyzed */
  Processing = 'Processing',
  Received = 'Received',
  ResultsReady = 'ResultsReady'
}

export type AgeTestSummary = {
  __typename: 'AgeTestSummary';
  activatedAt: Maybe<Scalars['Date']>;
  /** INC-1840 This field is retired. Please use releasedResult */
  predictedBirthday: Maybe<Scalars['Date']>;
  releasedResult: Maybe<ReleasedResult>;
  resultsETADate: Maybe<Scalars['Date']>;
  sampleReceivedDate: Maybe<Scalars['Date']>;
  status: AgeTestStatus;
};

export type Ancestry = {
  __typename: 'Ancestry';
  breedMixName: Maybe<Scalars['String']>;
  breedMixScenario: Maybe<AncestryBreedMixScenario>;
  breeds: Maybe<Array<Maybe<AncestryBreed>>>;
  familyTree: Maybe<AncestryFamilyTree>;
  haplotype: Maybe<AncestryHaplotype>;
  similarPets: Maybe<Array<AncestrySimilarPets>>;
  traceBreeds: Maybe<AncestryTraceBreeds>;
};

export type AncestryBreed = {
  __typename: 'AncestryBreed';
  ancestryLabel: Maybe<Scalars['String']>;
  displayPercentage: Maybe<Scalars['String']>;
  image: Maybe<Scalars['String']>;
  index: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
  percentage: Maybe<Scalars['Float']>;
};

export enum AncestryBreedMixScenario {
  BreedWithVarieties = 'BreedWithVarieties',
  Designer = 'Designer',
  Mixed = 'Mixed',
  Purebred = 'Purebred',
  Village = 'Village',
  Wolfdog = 'Wolfdog'
}

export type AncestryFamilyTree = {
  __typename: 'AncestryFamilyTree';
  grandParents: Maybe<Array<AncestryFamilyTreeRelation>>;
  greatGrandParents: Maybe<Array<AncestryFamilyTreeRelation>>;
  parents: Maybe<Array<AncestryFamilyTreeRelation>>;
};

export type AncestryFamilyTreeRelation = {
  __typename: 'AncestryFamilyTreeRelation';
  ancestryLabel: Scalars['String'];
  breedImage: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  position: Scalars['Int'];
};

export type AncestryHaplotype = {
  __typename: 'AncestryHaplotype';
  mtHaplogroup: Maybe<AncestryHaplotypeDetails>;
  mtHaplotype: Maybe<AncestryHaplotypeDetails>;
  yHaplogroup: Maybe<AncestryHaplotypeDetails>;
  yHaplotype: Maybe<AncestryHaplotypeDetails>;
};

export type AncestryHaplotypeDetails = {
  __typename: 'AncestryHaplotypeDetails';
  description: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  map: Maybe<Scalars['String']>;
};

export type AncestrySimilarPets = {
  __typename: 'AncestrySimilarPets';
  handle: Scalars['String'];
  image: Maybe<Scalars['String']>;
  likenessPercentage: Scalars['Int'];
  name: Scalars['String'];
};

export type AncestryTraceBreed = {
  __typename: 'AncestryTraceBreed';
  ancestryLabel: Maybe<Scalars['String']>;
  image: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type AncestryTraceBreeds = {
  __typename: 'AncestryTraceBreeds';
  breeds: Maybe<Array<AncestryTraceBreed>>;
  percentage: Maybe<Scalars['Float']>;
};

export type Breed = {
  __typename: 'Breed';
  alternativeNamesForBreeders: Array<Scalars['String']>;
  /** Can be used as a unique identifier for a breed */
  ancestryLabel: Scalars['String'];
  displayName: Scalars['String'];
  funFact1: Maybe<Scalars['String']>;
  funFact2: Maybe<Scalars['String']>;
  funFact3: Maybe<Scalars['String']>;
  imageFileName: Maybe<Scalars['String']>;
  longDescription: Maybe<Scalars['String']>;
  pluralDisplayName: Scalars['String'];
};

export type BreederProfile = {
  __typename: 'BreederProfile';
  breedAncestryLabels: Array<Scalars['String']>;
  breedingExperience: Scalars['String'];
  breedingExperienceOther: Scalars['String'];
  commentsForUs: Scalars['String'];
  kennelAddressRaw: Scalars['String'];
  kennelEmail: Scalars['String'];
  kennelName: Scalars['String'];
  kennelPhone: Scalars['String'];
  kennelWebsite: Scalars['String'];
  testingReason: Scalars['String'];
};

export enum BusinessType {
  Breeder = 'breeder',
  Home = 'home',
  Other = 'other',
  Shelter = 'shelter'
}

export type Citation = {
  __typename: 'Citation';
  text: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type Cloudinary = {
  __typename: 'Cloudinary';
  roundDogFaceImageUrl: Scalars['String'];
};

export enum CoatColor {
  Black = 'Black',
  BlackAgouti = 'BlackAgouti',
  BlackFawnSable = 'BlackFawnSable',
  BlackTanPoint = 'BlackTanPoint',
  Brown = 'Brown',
  BrownAgouti = 'BrownAgouti',
  BrownFawnSable = 'BrownFawnSable',
  BrownTanPoint = 'BrownTanPoint',
  DilutedBlack = 'DilutedBlack',
  DilutedBlackAgouti = 'DilutedBlackAgouti',
  DilutedBlackFawnSable = 'DilutedBlackFawnSable',
  DilutedBlackTanPoint = 'DilutedBlackTanPoint',
  DilutedBrown = 'DilutedBrown',
  DilutedBrownAgouti = 'DilutedBrownAgouti',
  DilutedBrownFawnSable = 'DilutedBrownFawnSable',
  DilutedBrownTanPoint = 'DilutedBrownTanPoint',
  RecessiveRed = 'RecessiveRed'
}

export enum CoatType {
  Patterned = 'Patterned',
  Solid = 'Solid'
}

export type Cursor = {
  cursor: Scalars['String'];
};

export type DeleteVetPatientNoteInput = {
  noteId: Scalars['String'];
};

export type EmailPreferences = {
  __typename: 'EmailPreferences';
  isBreederEventsEnabled: Scalars['Boolean'];
  isBreederNewslettersEnabled: Scalars['Boolean'];
  isBreederPromotionsAndSalesEnabled: Scalars['Boolean'];
  isCareResourcesEnabled: Scalars['Boolean'];
  isChatEnabled: Scalars['Boolean'];
  isDogsLikeMineEnabled: Scalars['Boolean'];
  isNewslettersEnabled: Scalars['Boolean'];
  isProductUpdatesEnabled: Scalars['Boolean'];
  isPromotionsAndSalesEnabled: Scalars['Boolean'];
  isRelativeFinderEnabled: Scalars['Boolean'];
  isResearchSurveysEnabled: Scalars['Boolean'];
  isVetBusinessCommunicationsEnabled: Scalars['Boolean'];
  isVetEventsEnabled: Scalars['Boolean'];
  isVetNewslettersEnabled: Scalars['Boolean'];
};

export type EmailPreferencesInput = {
  isBreederEventsEnabled: Scalars['Boolean'];
  isBreederNewslettersEnabled: Scalars['Boolean'];
  isBreederPromotionsAndSalesEnabled: Scalars['Boolean'];
  isCareResourcesEnabled: Scalars['Boolean'];
  isChatEnabled: Scalars['Boolean'];
  isDogsLikeMineEnabled: Scalars['Boolean'];
  isNewslettersEnabled: Scalars['Boolean'];
  isProductUpdatesEnabled: Scalars['Boolean'];
  isPromotionsAndSalesEnabled: Scalars['Boolean'];
  isRelativeFinderEnabled: Scalars['Boolean'];
  isResearchSurveysEnabled: Scalars['Boolean'];
  isVetBusinessCommunicationsEnabled: Scalars['Boolean'];
  isVetEventsEnabled: Scalars['Boolean'];
  isVetNewslettersEnabled: Scalars['Boolean'];
};

/** Epigenetics mutations are exposed to React/UI and proxied to epigenetics-backend API */
export type EpigeneticsMutation = {
  __typename: 'EpigeneticsMutation';
  updateAgeTestResultFeedback: Maybe<ReleasedResult>;
};


/** Epigenetics mutations are exposed to React/UI and proxied to epigenetics-backend API */
export type EpigeneticsMutationUpdateAgeTestResultFeedbackArgs = {
  input: AgeTestResultFeedbackArgs;
};

export type FeatureFlags = {
  __typename: 'FeatureFlags';
  isFeatureFlagEnabled: Scalars['Boolean'];
  showPetParentDashboard: Scalars['Boolean'];
  showVetDashboard: Scalars['Boolean'];
};


export type FeatureFlagsIsFeatureFlagEnabledArgs = {
  name: Scalars['String'];
};

export type FeedbackInput = {
  additionalText?: InputMaybe<Scalars['String']>;
  isHelpful: Scalars['Boolean'];
  page: Scalars['String'];
  pageVariables?: InputMaybe<Scalars['String']>;
  petUuid?: InputMaybe<Scalars['String']>;
  selectedFeedback: Array<FeedbackItem>;
  variant?: InputMaybe<Scalars['String']>;
};

export enum FeedbackItem {
  Advertising = 'Advertising',
  AlreadyOwn = 'AlreadyOwn',
  Confused = 'Confused',
  DidNotLearnAnything = 'DidNotLearnAnything',
  Doubtful = 'Doubtful',
  EasyToUnderstand = 'EasyToUnderstand',
  ExpectedLitter = 'ExpectedLitter',
  Happy = 'Happy',
  InformationNotSpecific = 'InformationNotSpecific',
  InformedBreedingDecisions = 'InformedBreedingDecisions',
  LearnedSomething = 'LearnedSomething',
  NoResults = 'NoResults',
  NotAccurate = 'NotAccurate',
  NotSpecific = 'NotSpecific',
  Party = 'Party',
  ProductRecommendations = 'ProductRecommendations',
  PutAtEase = 'PutAtEase',
  Relieved = 'Relieved',
  Sad = 'Sad',
  Specific = 'Specific',
  TooLong = 'TooLong',
  WillUse = 'WillUse',
  Worried = 'Worried'
}

export type FileUploadBase64 = {
  base64String: Scalars['String'];
  filename: Scalars['String'];
  mimetype: Scalars['String'];
};

export type GeneticAgeTableRow = {
  __typename: 'GeneticAgeTableRow';
  calendarAgeMonths: Scalars['Int'];
  calendarAgeYears: Scalars['Int'];
  closest: Scalars['Boolean'];
  geneticAge: Maybe<Scalars['Int']>;
};

export type Genotype = {
  __typename: 'Genotype';
  breed1name: Maybe<Scalars['String']>;
  breed1pct: Maybe<Scalars['Float']>;
  breed2name: Maybe<Scalars['String']>;
  breed2pct: Maybe<Scalars['Float']>;
  breed3name: Maybe<Scalars['String']>;
  breed3pct: Maybe<Scalars['Float']>;
  breed4name: Maybe<Scalars['String']>;
  breed4pct: Maybe<Scalars['Float']>;
  breed5name: Maybe<Scalars['String']>;
  breed5pct: Maybe<Scalars['Float']>;
  breed6name: Maybe<Scalars['String']>;
  breed6pct: Maybe<Scalars['Float']>;
  breed7name: Maybe<Scalars['String']>;
  breed7pct: Maybe<Scalars['Float']>;
  breed8name: Maybe<Scalars['String']>;
  breed8pct: Maybe<Scalars['Float']>;
  /** Array of breeds and breed percentages for the dog */
  breedMix: Array<GenotypeBreedMix>;
  breedType: Maybe<Scalars['String']>;
  geneticAge: Maybe<Scalars['Int']>;
  geneticAgeTable: Maybe<Array<GeneticAgeTableRow>>;
  id: Scalars['String'];
  predictedWeight: Maybe<Scalars['Float']>;
  shouldShowVetBreedCount: Scalars['Boolean'];
  /** Wolfiness in the format of 0-100 where 100 is 100% */
  wolfiness: Maybe<Scalars['Float']>;
  wolfinessContext: Maybe<Scalars['String']>;
};

export type GenotypeBreedMix = {
  __typename: 'GenotypeBreedMix';
  ancestryLabel: Scalars['String'];
  barWidthPercentage: Scalars['Float'];
  breedName: Scalars['String'];
  breedPct: Scalars['Float'];
  colorIndex: Scalars['Int'];
  displayBreedPercent: Scalars['String'];
};

export type HealthConditionDetails = {
  __typename: 'HealthConditionDetails';
  healthId: Scalars['String'];
  topBreedsAffected: Array<HealthConditionTopBreedAffected>;
};

export type HealthConditionDetailsFilter = {
  healthIds: Array<Scalars['String']>;
};

export type HealthConditionTopBreedAffected = {
  __typename: 'HealthConditionTopBreedAffected';
  ancestryLabel: Scalars['String'];
  image: Maybe<Scalars['String']>;
  name: Scalars['String'];
  proportionDetected: Scalars['Float'];
};

export type HealthFilter = {
  healthIds?: InputMaybe<Array<Scalars['String']>>;
};

export type HealthResult = {
  __typename: 'HealthResult';
  actions: Maybe<Array<Maybe<Scalars['String']>>>;
  additionalDescription: Maybe<Scalars['String']>;
  breedingImpact: Maybe<Scalars['String']>;
  conditionClinicalSigns: Maybe<Array<Maybe<Scalars['String']>>>;
  conditionClinicalWarningSigns: Maybe<Array<Maybe<Scalars['String']>>>;
  description: Maybe<Scalars['String']>;
  detailedDescriptions: Maybe<Array<Maybe<Scalars['String']>>>;
  diagnosis: Maybe<Scalars['String']>;
  diagnosisDescriptions: Maybe<Array<Maybe<Scalars['String']>>>;
  explanation: Maybe<Scalars['String']>;
  gene: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identifiedInText: Maybe<Scalars['String']>;
  inapplicabilityReason: Maybe<Scalars['String']>;
  isBeta: Scalars['Boolean'];
  isBreedRelevant: Scalars['Boolean'];
  isClinicalTool: Maybe<Scalars['Boolean']>;
  isLinkageTest: Maybe<Scalars['Boolean']>;
  isPawsitResult: Scalars['Boolean'];
  isProvisional: Maybe<Scalars['Boolean']>;
  isXLinked: Maybe<Scalars['Boolean']>;
  moi: Maybe<Scalars['String']>;
  name: Scalars['String'];
  numberOfVariants: Maybe<Scalars['Int']>;
  probability: Maybe<Scalars['Float']>;
  references: Maybe<Array<Maybe<HealthResultReference>>>;
  resultText: Maybe<Scalars['String']>;
  risk: Maybe<Scalars['String']>;
  riskChanceDescriptions: Maybe<Array<Scalars['String']>>;
  riskExplainerDescriptions: Maybe<Array<Maybe<Scalars['String']>>>;
  riskFactorDescriptions: Maybe<Array<Maybe<Scalars['String']>>>;
  scienceBodyLink: Maybe<HealthResultReference>;
  scientificBasis: Maybe<Scalars['String']>;
  scientificName: Scalars['String'];
  severity: HealthResultSeverity;
  shortDescription: Maybe<Scalars['String']>;
  signs: Maybe<Scalars['String']>;
  signsDevelop: Maybe<Scalars['String']>;
  subdisorderName: Maybe<Scalars['String']>;
  surveyContents: Maybe<Array<Maybe<Scalars['String']>>>;
  treatment: Maybe<Scalars['String']>;
  treatmentRecommendations: Maybe<Array<Maybe<Scalars['String']>>>;
  variants: Maybe<Scalars['String']>;
};

export type HealthResultReference = {
  __typename: 'HealthResultReference';
  text: Scalars['String'];
  url: Scalars['String'];
};

export enum HealthResultSeverity {
  Clear = 'Clear',
  Hidden = 'Hidden',
  IncreasedRisk = 'IncreasedRisk',
  NoResult = 'NoResult',
  Notable = 'Notable'
}

export type HealthSummary = {
  __typename: 'HealthSummary';
  /**
   * The number of conditions the dog has tested clear for (green condition)
   * @deprecated This field will be removed, use health.results instead
   */
  allClearCount: Scalars['Int'];
  /**
   * The number of conditions the dog is at increased risk for (red severity conditions)
   * @deprecated This field will be removed, use health.results instead
   */
  increasedRiskCount: Scalars['Int'];
  /**
   * The number of conditions the dog has a notable variant for (blue severity condition)
   * @deprecated This field will be removed, use health.results instead
   */
  notableVariantCount: Scalars['Int'];
  results: Array<HealthResult>;
};

export enum HowHeardAboutUsOptions {
  Amazon = 'Amazon',
  Breeder = 'Breeder',
  Chewy = 'Chewy',
  Event = 'Event',
  Facebook = 'Facebook',
  FriendsFamily = 'FriendsFamily',
  Gift = 'Gift',
  Mail = 'Mail',
  News = 'News',
  OnlineSearch = 'OnlineSearch',
  Other = 'Other',
  Petco = 'Petco',
  Podcast = 'Podcast',
  Radio = 'Radio',
  RescueGroup = 'RescueGroup',
  StreamingTv = 'StreamingTV',
  Veterinarian = 'Veterinarian',
  YouTube = 'YouTube'
}

export type InputDate = {
  day?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export enum InsuranceType {
  NoPetOrWellness = 'noPetOrWellness',
  NotSure = 'notSure',
  Pet = 'pet',
  PetAndWellness = 'petAndWellness',
  Wellness = 'wellness'
}

export enum Intact {
  F = 'f',
  I = 'i'
}

export type LocationDetails = {
  address_components: Array<AddressComponent>;
  address_input: Scalars['String'];
  business_type: BusinessType;
  formatted_address: Scalars['String'];
  formatted_phone_number?: InputMaybe<Scalars['String']>;
  lng_lat: Point;
  location_type: LocationType;
  name: Scalars['String'];
  place_id: Scalars['String'];
  types: Array<Scalars['String']>;
  vicinity?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type LocationDetailsType = {
  __typename: 'LocationDetailsType';
  addressComponents: Array<AddressComponentsType>;
  addressInput: Scalars['String'];
  businessType: BusinessType;
  formattedAddress: Scalars['String'];
  formattedPhoneNumber: Maybe<Scalars['String']>;
  lngLat: PointsType;
  locationType: LocationType;
  name: Scalars['String'];
  placeId: Scalars['String'];
  types: Array<Scalars['String']>;
  vicinity: Maybe<Scalars['String']>;
  website: Maybe<Scalars['String']>;
};

export enum LocationType {
  Born = 'born',
  From = 'from',
  Live = 'live',
  Practice = 'practice'
}

export type LociCombination = {
  __typename: 'LociCombination';
  key: Scalars['String'];
  value: Scalars['Int'];
};

export enum Mask {
  Mask = 'Mask',
  NoMask = 'NoMask'
}

export type MicrobiomeTestSummary = {
  __typename: 'MicrobiomeTestSummary';
  createdAt: Scalars['DateTime'];
  petUuid: Scalars['String'];
  reportUrl: Scalars['String'];
  resultsReleasedAt: Maybe<Scalars['DateTime']>;
  state: SampleServiceState;
  testType: TestType;
};

/** The entry point for write operations on the graph. */
export type Mutation = {
  __typename: 'Mutation';
  /** Mutations specific to activating a kit or swab */
  activateKit: ActivateKitMutation;
  /** Mutations that can only be run by administrator users */
  admin: AdminMutation;
  /** Epigenetics Mutations exposed to React clients */
  epigenetics: EpigeneticsMutation;
  /** Mutations specific to pet data */
  pet: PetMutation;
  /** Mutations specific to user data */
  user: UserMutation;
  /** Mutations specific to vet data */
  vet: VetMutation;
};

export type NewPatientInput = {
  /** boxKey and swabCode are mutually exclusive. Only provide one of them to activate a swab */
  boxKey?: InputMaybe<Scalars['String']>;
  clientEmail?: InputMaybe<Scalars['String']>;
  clientName: Scalars['String'];
  clientPhoneNumber?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<InputDate>;
  emrId?: InputMaybe<Scalars['String']>;
  intact?: InputMaybe<Intact>;
  name: Scalars['String'];
  orderedByUserUUID?: InputMaybe<Scalars['String']>;
  sex: Sex;
  /** boxKey and swabCode are mutually exclusive. Only provide one of them to activate a swab */
  swabCode?: InputMaybe<Scalars['String']>;
};

/** Fields used for adding notification acknowledged */
export type NotificationAcknowledgedInput = {
  petNum?: InputMaybe<Scalars['Int']>;
  slug: NotificationSlug;
};

export enum NotificationSlug {
  BreedPageCareResourcesBanner = 'BreedPageCareResourcesBanner',
  HealthPageCareResourcesBanner = 'HealthPageCareResourcesBanner',
  SummaryCareResourcesModal = 'SummaryCareResourcesModal',
  TraitsPageCareResourcesBanner = 'TraitsPageCareResourcesBanner'
}

export enum NutritionActivityLevel {
  LessActive = 'LessActive',
  ModeratelyActive = 'ModeratelyActive',
  VeryActive = 'VeryActive'
}

export enum NutritionAgeCategory {
  Adult = 'Adult',
  MatureAdult = 'MatureAdult',
  Puppy = 'Puppy',
  Senior = 'Senior'
}

export enum NutritionBodyCondition {
  IdealWeight = 'IdealWeight',
  Obese = 'Obese',
  Overweight = 'Overweight',
  Underweight = 'Underweight'
}

export enum NutritionBreedSize {
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small'
}

export type NutritionDailyRecommendedFoodVolume = {
  __typename: 'NutritionDailyRecommendedFoodVolume';
  decimal: Scalars['Float'];
  fraction: Scalars['String'];
};

export enum NutritionFoodRecommendation {
  Dry = 'Dry',
  /** @deprecated use FreshFrozen */
  Fresh = 'Fresh',
  FreshFrozen = 'FreshFrozen',
  /** @deprecated use FreshFrozen */
  Frozen = 'Frozen',
  Homemade = 'Homemade',
  Raw = 'Raw',
  Specialty = 'Specialty',
  Wet = 'Wet'
}

export enum NutritionProductType {
  Dry = 'Dry',
  Wet = 'Wet'
}

/** Field returned in a nutrition recommendation */
export type NutritionRecommendation = {
  __typename: 'NutritionRecommendation';
  activityLevel: NutritionActivityLevel;
  ageCategory: NutritionAgeCategory;
  benefit: Scalars['String'];
  birthday: Scalars['String'];
  bodyCondition: NutritionBodyCondition;
  breedSize: NutritionBreedSize;
  dailyEnergyRequirement: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  foodRecommendations: Array<NutritionRecommendationProduct>;
  ingredients: Array<NutritionRecommendationIngredient>;
  nutrients: Array<NutritionRecommendationNutrient>;
  weight: Scalars['Float'];
};

export type NutritionRecommendationIngredient = {
  __typename: 'NutritionRecommendationIngredient';
  description: Scalars['String'];
  name: Scalars['String'];
};

/** Fields used to make a nutrition recommendation */
export type NutritionRecommendationInput = {
  activityLevel: NutritionActivityLevel;
  birthday: Scalars['String'];
  birthdayIsEstimated: Scalars['Boolean'];
  bodyCondition: NutritionBodyCondition;
  foodRecommendation: NutritionFoodRecommendation;
  ownerProvidedWeight: Scalars['Float'];
  petNum: Scalars['Int'];
};

export type NutritionRecommendationNutrient = {
  __typename: 'NutritionRecommendationNutrient';
  name: Scalars['String'];
};

export type NutritionRecommendationProduct = {
  __typename: 'NutritionRecommendationProduct';
  image: Scalars['String'];
  productKey: Scalars['String'];
  productName: Scalars['String'];
  recommendedDailyVolume: Maybe<NutritionDailyRecommendedFoodVolume>;
  type: NutritionProductType;
  url: Scalars['String'];
};

export enum OnboardingChecklistItem {
  AssignStaffChampion = 'assignStaffChampion',
  ConnectWithSuccessManager = 'connectWithSuccessManager',
  LearnToUseDashboard = 'learnToUseDashboard',
  PlaceFirstOrder = 'placeFirstOrder',
  ReceiveFirstResults = 'receiveFirstResults',
  TalkAboutGeneticTesting = 'talkAboutGeneticTesting',
  TestFirstPatient = 'testFirstPatient'
}

export type OnboardingChecklistStatus = {
  __typename: 'OnboardingChecklistStatus';
  assignStaffChampion: Scalars['Boolean'];
  /** NOTE: This field now governs the display of the 'Connect with your support team' onboarding checklist item */
  connectWithSuccessManager: Scalars['Boolean'];
  learnToUseDashboard: Scalars['Boolean'];
  placeFirstOrder: Scalars['Boolean'];
  receiveFirstResults: Scalars['Boolean'];
  talkAboutGeneticTesting: Scalars['Boolean'];
  testFirstPatient: Scalars['Boolean'];
};

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']>;
  next?: InputMaybe<Cursor>;
  previous?: InputMaybe<Cursor>;
};

export type PairPredictor = {
  __typename: 'PairPredictor';
  coatColorPredictions: Maybe<PairPredictorCoatColorPrediction>;
  dam: Pet;
  eCoi: PairPredictorECoi;
  healthPrediction: Maybe<PairPredictorHealthPrediction>;
  healthPredictions: Array<PairPredictorHealthPrediction>;
  sire: Pet;
};


export type PairPredictorHealthPredictionArgs = {
  healthId: Scalars['String'];
};

export enum PairPredictorCategory {
  NoPredictionOffBreed = 'noPredictionOffBreed',
  NoPredictionOnBreed = 'noPredictionOnBreed',
  OffBreed = 'offBreed',
  OnBreedDanger = 'onBreedDanger',
  OnBreedGood = 'onBreedGood',
  OnBreedWarn = 'onBreedWarn'
}

export type PairPredictorCoatColorAttributes = {
  __typename: 'PairPredictorCoatColorAttributes';
  coatColor: CoatColor;
  coatType: CoatType;
  diluted: Scalars['Boolean'];
  mask: Mask;
  pigmentColor: PigmentColor;
};

export type PairPredictorCoatColorCalculatedAttributes = {
  __typename: 'PairPredictorCoatColorCalculatedAttributes';
  attributes: PairPredictorCoatColorAttributes;
  count: Scalars['Int'];
  percentage: Maybe<Scalars['Int']>;
};

export type PairPredictorCoatColorLociCombinations = {
  __typename: 'PairPredictorCoatColorLociCombinations';
  a: Array<LociCombination>;
  b: Array<LociCombination>;
  d: Array<LociCombination>;
  e: Array<LociCombination>;
  k: Array<LociCombination>;
};

export type PairPredictorCoatColorPrediction = {
  __typename: 'PairPredictorCoatColorPrediction';
  coatAttributes: Array<PairPredictorCoatColorCalculatedAttributes>;
  damLocus: PairPredictorSireAndDamLocus;
  lociCombinations: PairPredictorCoatColorLociCombinations;
  sireLocus: PairPredictorSireAndDamLocus;
};

export enum PairPredictorCopyVariant {
  Copies = 'copies',
  CopiesQuotedAtRisk = 'copiesQuotedAtRisk',
  RiskLevels = 'riskLevels',
  RiskLevelsQuotedAtRisk = 'riskLevelsQuotedAtRisk'
}

export type PairPredictorECoi = {
  __typename: 'PairPredictorECoi';
  averageBreedCoi: Maybe<Scalars['Int']>;
  eCoiCopyVariant: PairPredictorECoiCopyVariant;
  expectedLitterCoi: Maybe<Scalars['Int']>;
  pluralBreedDisplayName: Maybe<Scalars['String']>;
};

export enum PairPredictorECoiCopyVariant {
  Available = 'available',
  AvailableECoiOnly = 'availableECoiOnly',
  NotAvailableOther = 'notAvailableOther',
  NotAvailablePurebred = 'notAvailablePurebred'
}

export type PairPredictorHealthPrediction = {
  __typename: 'PairPredictorHealthPrediction';
  bodySystem: Scalars['String'];
  damHealthStateCategory: Maybe<Scalars['String']>;
  damVariantsDetected: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  disorderName: Scalars['String'];
  gene: Scalars['String'];
  healthId: Scalars['String'];
  howCanImproveHealthRisksParagraphs: Array<Maybe<Scalars['String']>>;
  identifiedInText: Scalars['String'];
  isOneCopyDangerous: Maybe<Scalars['Boolean']>;
  isTwoCopiesDangerous: Maybe<Scalars['Boolean']>;
  litterOneCopyPercent: Maybe<Scalars['Int']>;
  litterTwoCopiesPercent: Maybe<Scalars['Int']>;
  litterZeroCopiesPercent: Maybe<Scalars['Int']>;
  modeOfInheritance: Scalars['String'];
  pairPredictorCategory: PairPredictorCategory;
  pairPredictorCopyVariant: PairPredictorCopyVariant;
  sireHealthStateCategory: Maybe<Scalars['String']>;
  sireVariantsDetected: Maybe<Scalars['Int']>;
  subdisorderName: Scalars['String'];
};

export type PairPredictorSireAndDamLocus = {
  __typename: 'PairPredictorSireAndDamLocus';
  a: Scalars['String'];
  b: Scalars['String'];
  d: Scalars['String'];
  e: Scalars['String'];
  k: Scalars['String'];
};

export type Pet = {
  __typename: 'Pet';
  /** User-entered Adult Weight (in lbs) */
  adultWeightLbs: Maybe<Scalars['Int']>;
  ageTest: Maybe<AgeTestSummary>;
  ageTestProductState: ProductState;
  ancestry: Maybe<Ancestry>;
  ancestryResultsState: ResultsState;
  /** Controls what color the dog avatar is if the user has dogs without profile images */
  avatarColorIndex: Scalars['Int'];
  callName: Maybe<Scalars['String']>;
  /** A pointer to the location of this pet in the list of pets */
  cursor: Scalars['String'];
  dateAdded: Scalars['Float'];
  dateOfBirth: Maybe<Scalars['Date']>;
  displayName: Maybe<Scalars['String']>;
  /** Whether or not embark can contact the vet */
  embarkMayContactVet: Maybe<Scalars['Boolean']>;
  /** @deprecated This field will be removed, please use customer result service instead */
  genotype: Maybe<Genotype>;
  genotypeTestProductState: ProductState;
  handle: Scalars['String'];
  /** Whether or not the dog has any activated products */
  hasActivatedProducts: Scalars['Boolean'];
  /** Whether or not the dog has pending results for all of its products (i.e. none with results) */
  hasPendingResults: Scalars['Boolean'];
  /** Whether or not pet has seen a notification */
  hasPetAcknowledgedNotification: Scalars['Boolean'];
  /** Whether or not the dog has any results for any of its products */
  hasResults: Scalars['Boolean'];
  hasSwab: Scalars['Boolean'];
  hashPetId: Scalars['String'];
  health: Maybe<HealthSummary>;
  healthResultsState: ResultsState;
  /** Pet UUID */
  id: Scalars['String'];
  insuranceUrl: Scalars['String'];
  intact: Maybe<Intact>;
  isDateOfBirthEstimated: Maybe<Scalars['Boolean']>;
  isEditable: Scalars['Boolean'];
  isEligibleForInsurance: Scalars['Boolean'];
  isEligibleForMatchmaker: Scalars['Boolean'];
  isHealthReady: Scalars['Boolean'];
  isNonhealthReady: Scalars['Boolean'];
  isPartOfAgeTestStudy: Scalars['Boolean'];
  isPrimaryOwnerBreeder: Scalars['Boolean'];
  /** True if the user can upgrade from a Breed ID only kit to a Breed & Health kit */
  isUpgradeAvailable: Scalars['Boolean'];
  lifeStage: Maybe<PetLifeStage>;
  locations: PetLocations;
  microbiomeTestProductState: ProductState;
  microbiomeTests: Array<MicrobiomeTestSummary>;
  name: Scalars['String'];
  petNum: Scalars['Int'];
  practiceLocation: Maybe<LocationDetailsType>;
  preferences: PetPreferences;
  profile: Profile;
  profileImageUrl: Maybe<Scalars['String']>;
  sex: Sex;
  shareOptions: Maybe<ShareOptions>;
  shouldForcePetToBreedReveal: Scalars['Boolean'];
  shouldShowAgeTestRecommendation: Scalars['Boolean'];
  shouldShowFoodRecommendation: Scalars['Boolean'];
  shouldShowGenotypeTestRecommendation: Scalars['Boolean'];
  showOfaReport: Scalars['Boolean'];
  /** True if the pet will have access to Relatives (this is independent of if the results are actually released to the customer yet) */
  showRelativeFinder: Scalars['Boolean'];
  /** True if the pet will have access to Traits (this is independent of if the results are actually released to the customer yet) */
  showTraits: Scalars['Boolean'];
  surveyUrlBySurveyId: Scalars['String'];
  surveys: Array<PetSurveyInfo>;
  swabSummary: SwabSummary;
  traits: Maybe<Traits>;
  /** Info about the vet practice this pet was tested at. Only loaded if the user is a vet. */
  vetPracticeInfo: Maybe<VetPracticePetInfo>;
};


export type PetHasPetAcknowledgedNotificationArgs = {
  slug: NotificationSlug;
};


export type PetHealthArgs = {
  filters: InputMaybe<HealthFilter>;
};


export type PetSurveyUrlBySurveyIdArgs = {
  surveyId: Scalars['String'];
};

export type PetFilters = {
  hasActiveGenotypeSwab?: InputMaybe<Scalars['Boolean']>;
  isHealthReady?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isNonhealthReady?: InputMaybe<Scalars['Boolean']>;
  patientSearch?: InputMaybe<Scalars['String']>;
  petNum?: InputMaybe<Scalars['Int']>;
  petNums?: InputMaybe<Array<Scalars['Int']>>;
  petUuid?: InputMaybe<Scalars['String']>;
};

export type PetInput = {
  adoptionLocation?: InputMaybe<LocationDetails>;
  /** User-entered Adult Weight (in lbs) */
  adultWeightLbs?: InputMaybe<Scalars['Int']>;
  birthLocation?: InputMaybe<LocationDetails>;
  currentLocation?: InputMaybe<LocationDetails>;
  dateOfAdoption?: InputMaybe<InputDate>;
  dateOfBirth?: InputMaybe<InputDate>;
  embarkMayContactVet?: InputMaybe<Scalars['Boolean']>;
  hasPrimaryVet?: InputMaybe<Scalars['Boolean']>;
  insurance?: InputMaybe<InsuranceType>;
  intact?: InputMaybe<Intact>;
  isDateOfBirthEstimated?: InputMaybe<Scalars['Boolean']>;
  isFirstTimeOwner?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  practiceLocation?: InputMaybe<LocationDetails>;
  profile?: InputMaybe<ProfileInput>;
  profilePicture?: InputMaybe<ProfilePicture>;
  sex: Sex;
};

export enum PetLifeStage {
  Geriatric = 'Geriatric',
  MatureAdult = 'MatureAdult',
  Puppy = 'Puppy',
  Senior = 'Senior',
  YoungAdult = 'YoungAdult'
}

export type PetLocations = {
  __typename: 'PetLocations';
  born: Maybe<LocationDetailsType>;
  from: Maybe<LocationDetailsType>;
  live: Maybe<LocationDetailsType>;
};

export type PetLocationsInput = {
  born?: InputMaybe<LocationDetails>;
  from?: InputMaybe<LocationDetails>;
  live?: InputMaybe<LocationDetails>;
};

/** Pet mutations live here! */
export type PetMutation = {
  __typename: 'PetMutation';
  /** Activates a box key or swab */
  activateSwab: Pet;
  /** Adds a new pet to the database. */
  addNewPet: Pet;
  /** Adds notification acknowledged for a pet */
  addPetNotificationAcknowledged: Pet;
  /** Adds notification acknowledged for a user */
  addUserNotificationAcknowledged: User;
  /** Saves nutrition user inputted data from nutrition recommendation, returns session id */
  saveNutritionInputData: SaveNutritionDataOutput;
  /** Shares results with a vet */
  shareResultsWithVet: Maybe<Scalars['Void']>;
  /** Returns the nutrition recommendation for a pet based on input data */
  submitNutritionRecommendationRequest: Maybe<NutritionRecommendation>;
  /** Updates a pet's fields */
  updatePet: Pet;
  /** Update current, birth, and from locations for a pet */
  updatePetLocations: Pet;
  /** Updates a preference for a pet */
  updatePetPreferences: Pet;
  /** Updates veterinary contact preferences and vet practice details for a pet */
  updateVetPracticeDetails: Maybe<Scalars['Void']>;
};


/** Pet mutations live here! */
export type PetMutationActivateSwabArgs = {
  activationDetails: ActivateSwabInput;
};


/** Pet mutations live here! */
export type PetMutationAddNewPetArgs = {
  pet: PetInput;
};


/** Pet mutations live here! */
export type PetMutationAddPetNotificationAcknowledgedArgs = {
  notification: NotificationAcknowledgedInput;
};


/** Pet mutations live here! */
export type PetMutationAddUserNotificationAcknowledgedArgs = {
  notification: NotificationAcknowledgedInput;
};


/** Pet mutations live here! */
export type PetMutationSaveNutritionInputDataArgs = {
  nutritionDataInput: SaveNutritionDataInput;
};


/** Pet mutations live here! */
export type PetMutationShareResultsWithVetArgs = {
  shareResultsWithVetInput: ShareResultsWithVetInput;
};


/** Pet mutations live here! */
export type PetMutationSubmitNutritionRecommendationRequestArgs = {
  nutritionInput: NutritionRecommendationInput;
};


/** Pet mutations live here! */
export type PetMutationUpdatePetArgs = {
  queryFields: PetQueryInput;
  updateFields: PetUpdateInput;
};


/** Pet mutations live here! */
export type PetMutationUpdatePetLocationsArgs = {
  petLocations: UpdatePetLocationsInput;
};


/** Pet mutations live here! */
export type PetMutationUpdatePetPreferencesArgs = {
  petNum: InputMaybe<Scalars['Int']>;
  preferences: InputMaybe<PetPreferencesInput>;
};


/** Pet mutations live here! */
export type PetMutationUpdateVetPracticeDetailsArgs = {
  vetPracticeDetails: VetPracticeDetailsInput;
};

export type PetPreferences = {
  __typename: 'PetPreferences';
  shareCareResourcesProfileAndResults: Scalars['Boolean'];
  shareCareResourcesSurveys: Scalars['Boolean'];
};

export type PetPreferencesInput = {
  shareCareResourcesProfileAndResults?: InputMaybe<Scalars['Boolean']>;
  shareCareResourcesSurveys?: InputMaybe<Scalars['Boolean']>;
};

/** Fields used to find a pet for the current user */
export type PetQueryInput = {
  pet_num: Scalars['Int'];
};

export type PetSort = {
  direction: PetSortDirection;
  field: PetSortField;
};

export enum PetSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum PetSortField {
  DateAdded = 'dateAdded',
  Name = 'name',
  PetNum = 'petNum'
}

export type PetSurveyInfo = {
  __typename: 'PetSurveyInfo';
  id: Scalars['String'];
  survey: Survey;
  surveyProgress: SurveyProgress;
  surveyTemplateId: Scalars['String'];
  /** The URL for this survey in Qualtrics (this is a unique per dog) */
  surveyUrl: Scalars['String'];
};

/** Fields used to update a pet */
export type PetUpdateInput = {
  adult_weight_lbs: Scalars['Int'];
};

export enum PigmentColor {
  Black = 'Black',
  Brown = 'Brown',
  DilutedBlack = 'DilutedBlack',
  DilutedBrown = 'DilutedBrown'
}

export type Point = {
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type PointsType = {
  __typename: 'PointsType';
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export enum ProductState {
  Activated = 'Activated',
  NoProduct = 'NoProduct',
  Results = 'Results'
}

export enum ProductType {
  Age = 'Age',
  BreedAndAncestry = 'BreedAndAncestry',
  ComprehensiveBreeder = 'ComprehensiveBreeder',
  ComprehensiveConsumer = 'ComprehensiveConsumer',
  ComprehensiveUpgrade = 'ComprehensiveUpgrade',
  Purebred = 'Purebred',
  Vet = 'Vet'
}

export type Profile = {
  __typename: 'Profile';
  bio: Maybe<Scalars['String']>;
  breed: Maybe<Scalars['String']>;
  callName: Maybe<Scalars['String']>;
  primaryBreedRegistrationNumber: Maybe<Scalars['String']>;
  primaryBreedRegistrationOrganizationAcronym: Maybe<Scalars['String']>;
  primaryBreedRegistrationOrganizationName: Maybe<Scalars['String']>;
};

export type ProfileInput = {
  bio?: InputMaybe<Scalars['String']>;
  breed?: InputMaybe<Scalars['String']>;
  breedtype?: InputMaybe<Scalars['String']>;
  callName?: InputMaybe<Scalars['String']>;
};

export type ProfilePicture = {
  imagePublicId?: InputMaybe<Scalars['String']>;
  phash?: InputMaybe<Scalars['String']>;
};

/** The entry point for read operations on the graph. */
export type Query = {
  __typename: 'Query';
  /** Admin only queries */
  admin: AdminQuery;
  /** Gets a list of all breeds */
  allBreeds: Array<Breed>;
  /** Gets a list of all registration organizations */
  allRegistrationOrganizations: Array<RegistrationOrganization>;
  /** Gets a list of breeds that Embark tests for Breeders */
  breederFacingBreeds: Array<Breed>;
  /** Gets information from cloudinary about a specific id */
  cloudinary: Cloudinary;
  /** Gets a list of all designer breeds */
  designerBreeds: Array<Breed>;
  /** Gets detailed information about health conditions */
  healthConditionDetails: Array<Maybe<HealthConditionDetails>>;
  /** Gets a list of breeds that Embark tests for */
  identifiableBreeds: Array<Breed>;
  /** Returns the currently logged in user */
  me: User;
  /** Gets various health related information for comparing a sire and dam */
  pairPredictor: PairPredictor;
};


/** The entry point for read operations on the graph. */
export type QueryCloudinaryArgs = {
  publicId: Scalars['String'];
};


/** The entry point for read operations on the graph. */
export type QueryHealthConditionDetailsArgs = {
  filters: HealthConditionDetailsFilter;
};


/** The entry point for read operations on the graph. */
export type QueryPairPredictorArgs = {
  damPetNum: Scalars['Int'];
  sirePetNum: Scalars['Int'];
};

export type RegistrationOrganization = {
  __typename: 'RegistrationOrganization';
  acronym: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  registryType: Scalars['String'];
};

export type ReleasePetToClientInput = {
  clientEmail: Scalars['String'];
  clientName: Scalars['String'];
  petNum: Scalars['Int'];
};

/** An object representing a result released to the user */
export type ReleasedResult = {
  __typename: 'ReleasedResult';
  isAccurate: Maybe<Scalars['Boolean']>;
  isUserFeedbackCollected: Scalars['Boolean'];
  predictedBirthday: Scalars['Date'];
  resultsUuid: Scalars['String'];
};

export enum ResearchStudyEnrollmentStatus {
  Approved = 'approved',
  MoreInformationRequired = 'moreInformationRequired',
  NotReviewed = 'notReviewed',
  Rejected = 'rejected'
}

export enum ResultsState {
  Empty = 'Empty',
  Full = 'Full',
  NeedsPurchase = 'NeedsPurchase',
  PendingUpgrade = 'PendingUpgrade',
  PendingRelease = 'Pending_Release'
}

export enum SampleServiceState {
  ActivatedNonPrimary = 'ActivatedNonPrimary',
  ActivatedPrimary = 'ActivatedPrimary',
  AnalysisFailed = 'AnalysisFailed',
  AnalysisFailedMaybeResample = 'AnalysisFailedMaybeResample',
  AnalysisFailedNoResample = 'AnalysisFailedNoResample',
  AnalysisFailedReplaced = 'AnalysisFailedReplaced',
  CustomerDataDelivered = 'CustomerDataDelivered',
  CustomerDataReady = 'CustomerDataReady',
  Damaged = 'Damaged',
  Disposed = 'Disposed',
  DnaExtracted = 'DnaExtracted',
  DnaExtractionFailedRetry = 'DnaExtractionFailedRetry',
  EmbarkAnalyzed = 'EmbarkAnalyzed',
  LabArrivedPrimary = 'LabArrivedPrimary',
  LabHoldActive = 'LabHoldActive',
  LabHoldInactive = 'LabHoldInactive',
  LabProcessingComplete = 'LabProcessingComplete',
  LabProcessingDataDuplicate = 'LabProcessingDataDuplicate',
  LabProcessingDataOk = 'LabProcessingDataOk',
  LabProcessingDataReceived = 'LabProcessingDataReceived',
  LabProcessingDataSent = 'LabProcessingDataSent',
  LabProcessingFailedRetry = 'LabProcessingFailedRetry',
  Lost = 'Lost',
  ReceivedFromManufacturer = 'ReceivedFromManufacturer',
  SuspendedPostLabAccessioning = 'SuspendedPostLabAccessioning',
  SuspendedPreLabAccessioning = 'SuspendedPreLabAccessioning',
  Voided = 'Voided'
}

export enum SampleState {
  Activated = 'Activated',
  AnalysisInProgress = 'AnalysisInProgress',
  ArrivedAtLab = 'ArrivedAtLab',
  DnaExtracted = 'DNAExtracted',
  Error = 'Error',
  GenotypingInProgress = 'GenotypingInProgress',
  NoSwab = 'NoSwab',
  Processing = 'Processing',
  Results = 'Results'
}

/** Fields used to save nutrition input data */
export type SaveNutritionDataInput = {
  currentActivityLevel?: InputMaybe<Scalars['String']>;
  currentFoodBrand?: InputMaybe<Array<Scalars['String']>>;
  currentFoodDuration?: InputMaybe<Scalars['String']>;
  currentFoodType?: InputMaybe<Array<Scalars['String']>>;
  foodAllergiesSensitivities?: InputMaybe<Array<Scalars['String']>>;
  hasSpecificFoodOrIllness?: InputMaybe<Scalars['Boolean']>;
  petUuid: Scalars['String'];
  recommendedFoodType?: InputMaybe<Array<Scalars['String']>>;
  sessionId?: InputMaybe<Scalars['String']>;
  step0Timestamp?: InputMaybe<Scalars['DateTime']>;
  step1Timestamp?: InputMaybe<Scalars['DateTime']>;
  step2Timestamp?: InputMaybe<Scalars['DateTime']>;
  step3Timestamp?: InputMaybe<Scalars['DateTime']>;
  weightDescription?: InputMaybe<Scalars['String']>;
  weightLbs?: InputMaybe<Scalars['Float']>;
};

export type SaveNutritionDataOutput = {
  __typename: 'SaveNutritionDataOutput';
  sessionId: Scalars['String'];
};

export type ScientificResult = {
  __typename: 'ScientificResult';
  name: Maybe<Scalars['String']>;
  result: Maybe<Scalars['String']>;
};

export enum Sex {
  F = 'f',
  M = 'm'
}

/** Urls for different sharing mechanisms for a pet's public profile */
export type ShareOptions = {
  __typename: 'ShareOptions';
  copyLinkUrl: Scalars['String'];
  displayUrl: Maybe<Scalars['String']>;
  downloadUrl: Maybe<Scalars['String']>;
  emailBody: Scalars['String'];
  emailMailTo: Scalars['String'];
  emailSubject: Scalars['String'];
  facebookUrl: Scalars['String'];
  partial: Maybe<Scalars['String']>;
  previewUrl: Scalars['String'];
  shareItem: Scalars['String'];
  shareItemId: Maybe<Scalars['String']>;
};

/** Fields used for sharing results with a vet */
export type ShareResultsWithVetInput = {
  petUuid: Scalars['String'];
  vetEmail: Scalars['String'];
  vetName: Scalars['String'];
};

export type Survey = {
  __typename: 'Survey';
  category: SurveyCategory;
  /** The hex color code for this survey. */
  color: Scalars['String'];
  /** The full URL to the icon for this survey */
  icon: Scalars['String'];
  id: Scalars['String'];
  /** True if this survey should only be shown to admin users */
  isAdminOnly: Scalars['Boolean'];
  /** True if this survey should appear on a Dog's Research page */
  isShownOnResearchPage: Scalars['Boolean'];
  /**
   * True if this survey is targeted and cannot be seen by all users.
   * Targeting criteria is stored in the surveys_eligibility table.
   */
  isTargeted: Scalars['Boolean'];
  /** Controls the order of this survey within its category, lower priorities come first */
  priority: Scalars['Int'];
  /** Friendly ID meant to be used in user facing area like the URL */
  slug: Scalars['String'];
  subtitle: Maybe<Scalars['String']>;
  /** The qualtrics template ID for this survey. This is unique per survey */
  templateId: Scalars['String'];
  title: Scalars['String'];
};

export type SurveyCategory = {
  __typename: 'SurveyCategory';
  category: Scalars['String'];
  id: Scalars['String'];
  /** Controls the order of this category in the UI, lower priorities come first */
  priority: Scalars['Int'];
  subtitle: Maybe<Scalars['String']>;
  /** All surveys in this category */
  surveys: Array<Survey>;
};

export type SurveyCategoryInput = {
  priority: Scalars['Int'];
  subtitle?: InputMaybe<Scalars['String']>;
  surveyCategory: Scalars['String'];
};

export type SurveyInput = {
  color: Scalars['String'];
  icon?: InputMaybe<Scalars['String']>;
  /** If set, this uploads a new file to S3 and sets the icon path. Throws an error if the file name is not unique. */
  iconToUpload?: InputMaybe<FileUploadBase64>;
  isAdminOnly: Scalars['Boolean'];
  isShownOnResearchPage: Scalars['Boolean'];
  isTargeted: Scalars['Boolean'];
  priority: Scalars['Int'];
  shareId: Scalars['String'];
  slug: Scalars['String'];
  subtitle?: InputMaybe<Scalars['String']>;
  surveyCategoryId: Scalars['String'];
  templateId: Scalars['String'];
  title: Scalars['String'];
};

export enum SurveyProgress {
  Done = 'Done',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted'
}

/** Deprecated -- prefer SampleState */
export enum SwabState {
  Activated = 'Activated',
  NoSwab = 'NoSwab',
  Processing = 'Processing',
  Results = 'Results'
}

export type SwabSummary = {
  __typename: 'SwabSummary';
  /** The date the user activated the swab for this pet, or null if they have not activated a swab */
  activatedDate: Maybe<Scalars['Date']>;
  /** The date that breed results were made available for this pet, or null if they don't have breed results yet */
  breedResultsReleasedDate: Maybe<Scalars['Date']>;
  /** The date that the comprehensive upgrade was purchased for this pet, or null if they didn't purchase for this pet. */
  comprehensiveUpgradePurchasedDate: Maybe<Scalars['Date']>;
  /** The date that health results were made available for this pet, or null if they don't have health results yet or didn't use a kit that gives health results. */
  healthResultsReleasedDate: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  /** The source for the kit order (Amazon, Chewy, Embark, etc.) */
  productPurchaseSource: Maybe<Scalars['String']>;
  /** The type of product the swab is */
  productType: Maybe<ProductType>;
  /** The estimated date that the pet's results will be available in the format of "Early May" or "Late November" */
  resultsETA: Maybe<Scalars['String']>;
  /**
   * The return tracking URL for the swab. Might be provided only if the swab has state "Activated".
   * @deprecated no longer showing to customers
   */
  returnTrackingUrl: Maybe<Scalars['String']>;
  /** More granular swab state field */
  sampleState: SampleState;
  /** The swab code for this swab or null if the pet does not have a swab activated yet. */
  swabCode: Maybe<Scalars['String']>;
  /** @deprecated Use sampleState instead */
  swabState: SwabState;
  /** Vet specific summary for the vet dashboard */
  vetSummary: VetSwabSummary;
};

export enum TestType {
  Genotyping = 'genotyping',
  Methylation = 'methylation',
  MicrobiomeGut = 'microbiomeGut',
  MicrobiomeOral = 'microbiomeOral'
}

export type Trait = {
  __typename: 'Trait';
  additionalInfo: Maybe<Scalars['String']>;
  citations: Maybe<Array<Citation>>;
  description: Maybe<Scalars['String']>;
  gene: Maybe<ScientificResult>;
  isAmbiguous: Maybe<Scalars['Boolean']>;
  isLinkageTest: Maybe<Scalars['Boolean']>;
  moreInformationUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  order: Maybe<Scalars['Int']>;
  result: Maybe<Scalars['String']>;
  showLinkageTestExplanation: Maybe<Scalars['Boolean']>;
  sublabel: Maybe<Scalars['String']>;
  subloci: Maybe<Array<ScientificResult>>;
};

export type TraitCategory = {
  __typename: 'TraitCategory';
  description: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  order: Maybe<Scalars['Int']>;
  traits: Maybe<Array<Trait>>;
};

export type Traits = {
  __typename: 'Traits';
  /** @deprecated This field will be removed, use traits.traitsCategory instead */
  id: Scalars['String'];
  /** @deprecated This field will be removed, use traits.traitsCategory instead */
  roundedCoiPercent: Maybe<Scalars['Int']>;
  /** @deprecated This field will be removed, use traits.traitsCategory instead */
  swabCode: Scalars['String'];
  traitsCategory: Maybe<Array<TraitCategory>>;
};

export type UpdatePatientCaseInput = {
  caseCompleted: Scalars['Boolean'];
  notes: Array<VetPatientNoteInput>;
  petId: Scalars['String'];
  swabOrderedBy: Scalars['String'];
};

export type UpdatePatientInput = {
  clientEmail?: InputMaybe<Scalars['String']>;
  clientName: Scalars['String'];
  clientPhoneNumber?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<InputDate>;
  emrId?: InputMaybe<Scalars['String']>;
  handle: Scalars['String'];
  intact?: InputMaybe<Intact>;
  name: Scalars['String'];
  petNum: Scalars['Int'];
  sex: Sex;
};

export type UpdatePetLocationsInput = {
  locations: PetLocationsInput;
  petUuid: Scalars['String'];
};

export type UpdatePracticeOnboardingChecklistInput = {
  checklistItemName: OnboardingChecklistItem;
  checklistItemStatus: Scalars['Boolean'];
};

export type User = {
  __typename: 'User';
  breederProfile: Maybe<BreederProfile>;
  /** The 2 digit country code for where the user lives (ISO 3166-1 alpha-2 codes) */
  countryCode: Scalars['String'];
  /** Link to the embarkvet.com site */
  ecommLink: Scalars['String'];
  email: Scalars['String'];
  emailPreferences: EmailPreferences;
  /** Gets requested feature flags for the current user */
  featureFlags: FeatureFlags;
  /** Whether or not pet has seen a notification */
  hasUserAcknowledgedNotification: Scalars['Boolean'];
  howHeardAboutUs: Maybe<Scalars['String']>;
  /** The UUID for the user (not the numeric id) */
  id: Scalars['String'];
  impersonator: Maybe<UserImpersonatorInfo>;
  numUnreadMessages: Scalars['Int'];
  permissions: UserPermissions;
  petByPetNum: Maybe<Pet>;
  petCount: Scalars['Int'];
  pets: Array<Pet>;
  /** The vet practice that this user works for if they are a practice user. */
  practice: Maybe<VetPractice>;
  profile: UserProfile;
  /** Link to the embark store */
  shopLink: Scalars['String'];
  shouldShowFeedback: Scalars['Boolean'];
  /** Last digit of the user id, used to group users for feature testing */
  userGroup: Scalars['Int'];
  userType: UserTypeGraphQl;
};


export type UserHasUserAcknowledgedNotificationArgs = {
  slug: NotificationSlug;
};


export type UserPetByPetNumArgs = {
  petNum: Scalars['Int'];
};


export type UserPetCountArgs = {
  filters: InputMaybe<PetFilters>;
};


export type UserPetsArgs = {
  filters: InputMaybe<PetFilters>;
  pagination: InputMaybe<Pagination>;
  sort: InputMaybe<PetSort>;
};


export type UserShouldShowFeedbackArgs = {
  page: Scalars['String'];
  petUuid: InputMaybe<Scalars['String']>;
  variant: InputMaybe<Scalars['String']>;
};

export type UserImpersonatorInfo = {
  __typename: 'UserImpersonatorInfo';
  email: Scalars['String'];
  name: Scalars['String'];
};

export type UserMutation = {
  __typename: 'UserMutation';
  /** Adds feedback from a user */
  addFeedback: Maybe<Scalars['Void']>;
  /** Updates the email preferences for a user */
  updateUserEmailPreferences: Maybe<EmailPreferences>;
};


export type UserMutationAddFeedbackArgs = {
  feedback: FeedbackInput;
};


export type UserMutationUpdateUserEmailPreferencesArgs = {
  preferences: EmailPreferencesInput;
};

export type UserPermissions = {
  __typename: 'UserPermissions';
  canImpersonateAsSubAdmin: Scalars['Boolean'];
  isAdmin: Scalars['Boolean'];
  showMatchMaker: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  showVetChat: Scalars['Boolean'];
};

export type UserProfile = {
  __typename: 'UserProfile';
  name: Maybe<Scalars['String']>;
};

export enum UserTypeGraphQl {
  Breeder = 'Breeder',
  PetParent = 'PetParent',
  Vet = 'Vet'
}

export type VetActivationDetails = {
  orderedByUserUUID: Scalars['String'];
};

/** Information about the transfer of a pet from a vet practice to a client */
export type VetClientTransfer = {
  __typename: 'VetClientTransfer';
  completedAt: Maybe<Scalars['DateTime']>;
  recipientEmail: Maybe<Scalars['String']>;
  recipientName: Maybe<Scalars['String']>;
  requestedAt: Maybe<Scalars['DateTime']>;
  requestedByName: Maybe<Scalars['String']>;
  requesterIsDVM: Maybe<Scalars['Boolean']>;
};

/** Vet mutations live here! */
export type VetMutation = {
  __typename: 'VetMutation';
  /** Creates a new patient associated with the vet clinic */
  addNewPatient: Pet;
  /** Deletes a note from a patient */
  deletePatientNote: Pet;
  /** Releases a pet to a vet client */
  releasePetToClient: Pet;
  /** Updates a patient and clients information */
  updatePatient: Pet;
  /** Updates a patient's case information */
  updatePatientCase: Pet;
  /** Updates a practice's onboarding checklist status */
  updatePracticeOnboardingChecklistStatus: OnboardingChecklistStatus;
};


/** Vet mutations live here! */
export type VetMutationAddNewPatientArgs = {
  patient: NewPatientInput;
};


/** Vet mutations live here! */
export type VetMutationDeletePatientNoteArgs = {
  noteToDelete: DeleteVetPatientNoteInput;
};


/** Vet mutations live here! */
export type VetMutationReleasePetToClientArgs = {
  vetPatient: ReleasePetToClientInput;
};


/** Vet mutations live here! */
export type VetMutationUpdatePatientArgs = {
  patient: UpdatePatientInput;
};


/** Vet mutations live here! */
export type VetMutationUpdatePatientCaseArgs = {
  patientCase: UpdatePatientCaseInput;
};


/** Vet mutations live here! */
export type VetMutationUpdatePracticeOnboardingChecklistStatusArgs = {
  checklistItem: UpdatePracticeOnboardingChecklistInput;
};

/** Information about a note a vet attached to a patient */
export type VetPatientNote = {
  __typename: 'VetPatientNote';
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  /** @deprecated This field will be removed */
  noteUUID: Scalars['String'];
  /** @deprecated This field will be removed */
  petUUID: Maybe<Scalars['String']>;
  /** @deprecated This field will be removed */
  practiceId: Maybe<Scalars['String']>;
};

export type VetPatientNoteInput = {
  content: Scalars['String'];
  sequenceOrder: Scalars['Int'];
};

export type VetPractice = {
  __typename: 'VetPractice';
  createdAt: Scalars['Date'];
  name: Scalars['String'];
  onboardingChecklist: OnboardingChecklistStatus;
  onboardingMetadata: VetPracticeOnboardingMetadata;
  petActivationCount: Scalars['Int'];
  practiceId: Scalars['String'];
  practicePetCount: Scalars['Int'];
  practiceUsers: Array<VetPracticeUser>;
  swabsOrderedCount: Scalars['Int'];
};

export type VetPracticeDetailsInput = {
  embarkMayContactVet?: InputMaybe<Scalars['Boolean']>;
  petUuid: Scalars['String'];
  practiceLocation?: InputMaybe<LocationDetails>;
};

export type VetPracticeOnboardingMetadata = {
  __typename: 'VetPracticeOnboardingMetadata';
  /** True if the practice has fewer than 15 patients and some all clear results */
  hasFewPatientsAndSomeAllClearResults: Scalars['Boolean'];
  /** True if the practice has fewer than 15 patients and some notable or at risk results */
  hasFewPatientsAndSomeNotableOrAtRiskResults: Scalars['Boolean'];
};

/** Information about a pet in a vet practice (only loaded if the user is a vet) */
export type VetPracticePetInfo = {
  __typename: 'VetPracticePetInfo';
  caseCompleted: Scalars['Boolean'];
  clientEmail: Maybe<Scalars['String']>;
  clientName: Scalars['String'];
  clientPhone: Maybe<Scalars['String']>;
  isVetAffiliate: Scalars['Boolean'];
  patientEMRId: Maybe<Scalars['String']>;
  patientNotes: Array<VetPatientNote>;
  reportUrl: Maybe<Scalars['String']>;
  swabOrderedBy: Maybe<VetPracticeUser>;
  vetClientTransfer: Maybe<VetClientTransfer>;
};

export type VetPracticeUser = {
  __typename: 'VetPracticeUser';
  email: Scalars['String'];
  /** The user UUID for this practice user */
  id: Scalars['String'];
  isDVM: Scalars['Boolean'];
  name: Scalars['String'];
  role: Maybe<Scalars['String']>;
};

export type VetSwabSummary = {
  __typename: 'VetSwabSummary';
  header: Scalars['String'];
  subheader: Maybe<Scalars['String']>;
  swabState: SwabState;
};

export type GetBreedersBreedsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBreedersBreedsQuery = { __typename: 'Query', allBreeds: Array<{ __typename: 'Breed', displayName: string, ancestryLabel: string }>, me: { __typename: 'User', breederProfile: { __typename: 'BreederProfile', breedAncestryLabels: Array<string> } | null } };

export type BreederAllBreedsFragment = { __typename: 'Breed', displayName: string, ancestryLabel: string };

export type GetAllRegistrationOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRegistrationOrganizationsQuery = { __typename: 'Query', allRegistrationOrganizations: Array<{ __typename: 'RegistrationOrganization', id: string, name: string, acronym: string, registryType: string }> };

export type GetRoundDogFaceImageUrlQueryVariables = Exact<{
  publicId: Scalars['String'];
}>;


export type GetRoundDogFaceImageUrlQuery = { __typename: 'Query', cloudinary: { __typename: 'Cloudinary', roundDogFaceImageUrl: string } };

export type AddNewPetMutationVariables = Exact<{
  pet: PetInput;
}>;


export type AddNewPetMutation = { __typename: 'Mutation', pet: { __typename: 'PetMutation', addNewPet: { __typename: 'Pet', petNum: number } } };

export type CreateEditQualtricsCategoryBodyFragment = { __typename: 'SurveyCategory', id: string, category: string, subtitle: string | null, priority: number };

export type CreateEditQualtricsSurveyBodyFragment = { __typename: 'Survey', id: string, slug: string, templateId: string, subtitle: string | null, icon: string, title: string, color: string, priority: number, isTargeted: boolean, isAdminOnly: boolean, isShownOnResearchPage: boolean, category: { __typename: 'SurveyCategory', id: string, category: string, subtitle: string | null } };

export type GetAllSurveysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSurveysQuery = { __typename: 'Query', admin: { __typename: 'AdminQuery', getAllSurveys: Array<{ __typename: 'Survey', id: string, slug: string, templateId: string, subtitle: string | null, icon: string, title: string, color: string, priority: number, isTargeted: boolean, isAdminOnly: boolean, isShownOnResearchPage: boolean, category: { __typename: 'SurveyCategory', id: string, category: string, subtitle: string | null } }>, getAllSurveyCategories: Array<{ __typename: 'SurveyCategory', id: string, category: string, subtitle: string | null, priority: number }> } };

export type AddNewSurveyMutationVariables = Exact<{
  survey: SurveyInput;
}>;


export type AddNewSurveyMutation = { __typename: 'Mutation', admin: { __typename: 'AdminMutation', addSurvey: { __typename: 'Survey', id: string, slug: string, templateId: string, subtitle: string | null, icon: string, title: string, color: string, priority: number, isTargeted: boolean, isAdminOnly: boolean, isShownOnResearchPage: boolean, category: { __typename: 'SurveyCategory', id: string, category: string, subtitle: string | null } } } };

export type UpdateSurveyMutationVariables = Exact<{
  surveyId: Scalars['String'];
  survey: SurveyInput;
}>;


export type UpdateSurveyMutation = { __typename: 'Mutation', admin: { __typename: 'AdminMutation', updateSurvey: { __typename: 'Survey', id: string, slug: string, templateId: string, subtitle: string | null, icon: string, title: string, color: string, priority: number, isTargeted: boolean, isAdminOnly: boolean, isShownOnResearchPage: boolean, category: { __typename: 'SurveyCategory', id: string, category: string, subtitle: string | null } } } };

export type UpdateSurveyCategoryMutationVariables = Exact<{
  surveyCategoryId: Scalars['String'];
  category: SurveyCategoryInput;
}>;


export type UpdateSurveyCategoryMutation = { __typename: 'Mutation', admin: { __typename: 'AdminMutation', updateSurveyCategory: { __typename: 'SurveyCategory', id: string, category: string, subtitle: string | null, priority: number } } };

export type AddSurveyCategoryMutationVariables = Exact<{
  category: SurveyCategoryInput;
}>;


export type AddSurveyCategoryMutation = { __typename: 'Mutation', admin: { __typename: 'AdminMutation', addSurveyCategory: { __typename: 'SurveyCategory', id: string, category: string, subtitle: string | null, priority: number } } };

export type UploadFileForExampleMutationVariables = Exact<{
  survey: SurveyInput;
}>;


export type UploadFileForExampleMutation = { __typename: 'Mutation', admin: { __typename: 'AdminMutation', addSurvey: { __typename: 'Survey', id: string, icon: string } } };

export type GetFileUploadExampleSurveyCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFileUploadExampleSurveyCategoriesQuery = { __typename: 'Query', admin: { __typename: 'AdminQuery', getAllSurveyCategories: Array<{ __typename: 'SurveyCategory', id: string }> } };

export type GetHealthPredictionForPairPredictorQueryVariables = Exact<{
  sirePetNum: Scalars['Int'];
  damPetNum: Scalars['Int'];
  healthId: Scalars['String'];
}>;


export type GetHealthPredictionForPairPredictorQuery = { __typename: 'Query', pairPredictor: { __typename: 'PairPredictor', sire: { __typename: 'Pet', name: string, callName: string | null, avatarColorIndex: number, profileImageUrl: string | null }, dam: { __typename: 'Pet', name: string, callName: string | null, avatarColorIndex: number, profileImageUrl: string | null }, healthPrediction: { __typename: 'PairPredictorHealthPrediction', disorderName: string, subdisorderName: string, bodySystem: string, gene: string, modeOfInheritance: string, description: string, sireVariantsDetected: number | null, sireHealthStateCategory: string | null, damVariantsDetected: number | null, damHealthStateCategory: string | null, litterZeroCopiesPercent: number | null, litterOneCopyPercent: number | null, litterTwoCopiesPercent: number | null, isOneCopyDangerous: boolean | null, isTwoCopiesDangerous: boolean | null, pairPredictorCategory: PairPredictorCategory, pairPredictorCopyVariant: PairPredictorCopyVariant, howCanImproveHealthRisksParagraphs: Array<string | null> } | null } };

export type GetEligibleDogsForPairPredictorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEligibleDogsForPairPredictorQuery = { __typename: 'Query', me: { __typename: 'User', pets: Array<{ __typename: 'Pet', name: string, callName: string | null, sex: Sex, petNum: number, handle: string }> } };

export type GetPredictionForPairPredictorQueryVariables = Exact<{
  sirePetNum: Scalars['Int'];
  damPetNum: Scalars['Int'];
}>;


export type GetPredictionForPairPredictorQuery = { __typename: 'Query', pairPredictor: { __typename: 'PairPredictor', healthPredictions: Array<{ __typename: 'PairPredictorHealthPrediction', healthId: string, disorderName: string, subdisorderName: string, gene: string, description: string, bodySystem: string, modeOfInheritance: string, sireVariantsDetected: number | null, damVariantsDetected: number | null, sireHealthStateCategory: string | null, damHealthStateCategory: string | null, identifiedInText: string, litterZeroCopiesPercent: number | null, litterOneCopyPercent: number | null, litterTwoCopiesPercent: number | null, pairPredictorCategory: PairPredictorCategory }>, eCoi: { __typename: 'PairPredictorECoi', expectedLitterCoi: number | null, averageBreedCoi: number | null, eCoiCopyVariant: PairPredictorECoiCopyVariant, pluralBreedDisplayName: string | null }, coatColorPredictions: { __typename: 'PairPredictorCoatColorPrediction', coatAttributes: Array<{ __typename: 'PairPredictorCoatColorCalculatedAttributes', count: number, percentage: number | null, attributes: { __typename: 'PairPredictorCoatColorAttributes', diluted: boolean, pigmentColor: PigmentColor, coatColor: CoatColor, coatType: CoatType, mask: Mask } }>, lociCombinations: { __typename: 'PairPredictorCoatColorLociCombinations', e: Array<{ __typename: 'LociCombination', key: string, value: number }>, a: Array<{ __typename: 'LociCombination', key: string, value: number }>, k: Array<{ __typename: 'LociCombination', key: string, value: number }>, d: Array<{ __typename: 'LociCombination', key: string, value: number }>, b: Array<{ __typename: 'LociCombination', key: string, value: number }> }, sireLocus: { __typename: 'PairPredictorSireAndDamLocus', e: string, a: string, k: string, d: string, b: string }, damLocus: { __typename: 'PairPredictorSireAndDamLocus', e: string, a: string, k: string, d: string, b: string } } | null, sire: { __typename: 'Pet', id: string, name: string, callName: string | null, handle: string, profileImageUrl: string | null, avatarColorIndex: number, traits: { __typename: 'Traits', roundedCoiPercent: number | null } | null }, dam: { __typename: 'Pet', id: string, name: string, callName: string | null, handle: string, profileImageUrl: string | null, avatarColorIndex: number, traits: { __typename: 'Traits', roundedCoiPercent: number | null } | null } } };

export type HealthResultFieldsFragment = { __typename: 'PairPredictorHealthPrediction', healthId: string, disorderName: string, subdisorderName: string, gene: string, description: string, bodySystem: string, modeOfInheritance: string, sireVariantsDetected: number | null, damVariantsDetected: number | null, sireHealthStateCategory: string | null, damHealthStateCategory: string | null, identifiedInText: string, litterZeroCopiesPercent: number | null, litterOneCopyPercent: number | null, litterTwoCopiesPercent: number | null, pairPredictorCategory: PairPredictorCategory };

export type GetBreederFacingBreedsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBreederFacingBreedsQuery = { __typename: 'Query', breederFacingBreeds: Array<{ __typename: 'Breed', displayName: string, ancestryLabel: string }> };

export type GetPetInfoByUuidQueryVariables = Exact<{
  petUuid: Scalars['String'];
}>;


export type GetPetInfoByUuidQuery = { __typename: 'Query', me: { __typename: 'User', pets: Array<{ __typename: 'Pet', id: string, petNum: number, name: string, dateOfBirth: string | null, ancestry: { __typename: 'Ancestry', breeds: Array<{ __typename: 'AncestryBreed', name: string | null, percentage: number | null } | null> | null } | null }> } };

export type ActivateHowDidYouHearMutationVariables = Exact<{
  input: ActivateHowDidYouHearInput;
}>;


export type ActivateHowDidYouHearMutation = { __typename: 'Mutation', activateKit: { __typename: 'ActivateKitMutation', activateHowDidYouHear: void | null } };

export type ActivatedQualtricsSurveyQueryVariables = Exact<{
  petNum: Scalars['Int'];
}>;


export type ActivatedQualtricsSurveyQuery = { __typename: 'Query', me: { __typename: 'User', pets: Array<{ __typename: 'Pet', name: string, surveys: Array<{ __typename: 'PetSurveyInfo', surveyTemplateId: string, surveyUrl: string }> }> } };

export type GetPetsEligibleForKitActivationMutationVariables = Exact<{
  boxKeyOrSwabCode: Scalars['String'];
}>;


export type GetPetsEligibleForKitActivationMutation = { __typename: 'Mutation', activateKit: { __typename: 'ActivateKitMutation', activateBoxKeyOrSwabCode: { __typename: 'ActivateBoxKeyReturn', boxKeyOrSwabCode: string, productSkuPrefix: string | null, isVetAffiliate: boolean, pets: Array<{ __typename: 'Pet', petNum: number, name: string, handle: string }> } } };

export type ActivateKitWithPetMutationVariables = Exact<{
  boxKeyOrSwabCode: Scalars['String'];
  petNum: Scalars['Int'];
  surveyId: Scalars['String'];
  practiceId: InputMaybe<Scalars['String']>;
}>;


export type ActivateKitWithPetMutation = { __typename: 'Mutation', activateKit: { __typename: 'ActivateKitMutation', activateSelectDog: { __typename: 'ActivateSelectDogReturn', boxKey: string | null, swabCode: string | null, testType: TestType, pet: { __typename: 'Pet', petNum: number, name: string, id: string, dateOfBirth: string | null, profileImageUrl: string | null, avatarColorIndex: number, surveyUrlBySurveyId: string, genotype: { __typename: 'Genotype', breedMix: Array<{ __typename: 'GenotypeBreedMix', breedName: string, ancestryLabel: string }> } | null } } } };

export type ActivateContributeToResearchMutationVariables = Exact<{
  input: ActivateContributeToResearchInput;
}>;


export type ActivateContributeToResearchMutation = { __typename: 'Mutation', activateKit: { __typename: 'ActivateKitMutation', activateContributeToResearch: void | null } };

export type GetKitActivationPageInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKitActivationPageInfoQuery = { __typename: 'Query', identifiableBreeds: Array<{ __typename: 'Breed', displayName: string, ancestryLabel: string }>, me: { __typename: 'User', howHeardAboutUs: string | null } };

export type BreedAndAncestryPageFragment = { __typename: 'Pet', id: string, name: string, handle: string, petNum: number, sex: Sex, profileImageUrl: string | null, ancestryResultsState: ResultsState, isPrimaryOwnerBreeder: boolean, avatarColorIndex: number, swabSummary: { __typename: 'SwabSummary', swabCode: string | null, productType: ProductType | null, id: string }, ancestry: { __typename: 'Ancestry', breedMixScenario: AncestryBreedMixScenario | null, breedMixName: string | null, breeds: Array<{ __typename: 'AncestryBreed', ancestryLabel: string | null, index: number | null, percentage: number | null, name: string | null, image: string | null, displayPercentage: string | null } | null> | null, traceBreeds: { __typename: 'AncestryTraceBreeds', percentage: number | null, breeds: Array<{ __typename: 'AncestryTraceBreed', name: string | null, ancestryLabel: string | null, image: string | null }> | null } | null, similarPets: Array<{ __typename: 'AncestrySimilarPets', handle: string, image: string | null, likenessPercentage: number, name: string }> | null, familyTree: { __typename: 'AncestryFamilyTree', parents: Array<{ __typename: 'AncestryFamilyTreeRelation', position: number, ancestryLabel: string, displayName: string, breedImage: string | null }> | null, grandParents: Array<{ __typename: 'AncestryFamilyTreeRelation', position: number, ancestryLabel: string, displayName: string, breedImage: string | null }> | null, greatGrandParents: Array<{ __typename: 'AncestryFamilyTreeRelation', position: number, ancestryLabel: string, displayName: string, breedImage: string | null }> | null } | null, haplotype: { __typename: 'AncestryHaplotype', yHaplotype: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null, yHaplogroup: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null, mtHaplotype: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null, mtHaplogroup: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null } | null } | null, shareOptions: { __typename: 'ShareOptions', copyLinkUrl: string, downloadUrl: string | null, emailMailTo: string, facebookUrl: string, shareItemId: string | null } | null, profile: { __typename: 'Profile', breed: string | null, primaryBreedRegistrationOrganizationAcronym: string | null, primaryBreedRegistrationOrganizationName: string | null, primaryBreedRegistrationNumber: string | null } };

export type AncestryFragment = { __typename: 'Ancestry', breedMixScenario: AncestryBreedMixScenario | null, breedMixName: string | null, breeds: Array<{ __typename: 'AncestryBreed', ancestryLabel: string | null, name: string | null, image: string | null, displayPercentage: string | null, percentage: number | null, index: number | null } | null> | null, traceBreeds: { __typename: 'AncestryTraceBreeds', percentage: number | null, breeds: Array<{ __typename: 'AncestryTraceBreed', name: string | null, ancestryLabel: string | null, image: string | null }> | null } | null, similarPets: Array<{ __typename: 'AncestrySimilarPets', handle: string, image: string | null, likenessPercentage: number, name: string }> | null, familyTree: { __typename: 'AncestryFamilyTree', parents: Array<{ __typename: 'AncestryFamilyTreeRelation', position: number, ancestryLabel: string, displayName: string, breedImage: string | null }> | null, grandParents: Array<{ __typename: 'AncestryFamilyTreeRelation', position: number, ancestryLabel: string, displayName: string, breedImage: string | null }> | null, greatGrandParents: Array<{ __typename: 'AncestryFamilyTreeRelation', position: number, ancestryLabel: string, displayName: string, breedImage: string | null }> | null } | null, haplotype: { __typename: 'AncestryHaplotype', yHaplotype: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null, yHaplogroup: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null, mtHaplotype: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null, mtHaplogroup: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null } | null };

export type BreedAndAncestryPageUserFragment = { __typename: 'User', petCount: number };

export type RegisteredBreedAccordionFragment = { __typename: 'Pet', petNum: number, profile: { __typename: 'Profile', breed: string | null, primaryBreedRegistrationOrganizationAcronym: string | null, primaryBreedRegistrationOrganizationName: string | null, primaryBreedRegistrationNumber: string | null } };

export type UpdatePetMutationVariables = Exact<{
  updateFields: PetUpdateInput;
  queryFields: PetQueryInput;
}>;


export type UpdatePetMutation = { __typename: 'Mutation', pet: { __typename: 'PetMutation', updatePet: { __typename: 'Pet', adultWeightLbs: number | null } } };

export type PetResultsQueryVariables = Exact<{
  petNum: Scalars['Int'];
}>;


export type PetResultsQuery = { __typename: 'Query', me: { __typename: 'User', id: string, petCount: number, userGroup: number, countryCode: string, userType: UserTypeGraphQl, shopLink: string, ecommLink: string, petByPetNum: { __typename: 'Pet', id: string, isPrimaryOwnerBreeder: boolean, healthResultsState: ResultsState, name: string, petNum: number, hasActivatedProducts: boolean, genotypeTestProductState: ProductState, hasSwab: boolean, handle: string, isNonhealthReady: boolean, showOfaReport: boolean, isEligibleForMatchmaker: boolean, sex: Sex, dateOfBirth: string | null, isDateOfBirthEstimated: boolean | null, profileImageUrl: string | null, ancestryResultsState: ResultsState, isHealthReady: boolean, avatarColorIndex: number, showTraits: boolean, showRelativeFinder: boolean, isUpgradeAvailable: boolean, hashPetId: string, isEligibleForInsurance: boolean, hasResults: boolean, insuranceUrl: string, shouldShowFoodRecommendation: boolean, shouldShowAgeTestRecommendation: boolean, shouldShowGenotypeTestRecommendation: boolean, ageTestProductState: ProductState, microbiomeTestProductState: ProductState, isPartOfAgeTestStudy: boolean, displayName: string | null, swabSummary: { __typename: 'SwabSummary', id: string, swabState: SwabState, productType: ProductType | null, productPurchaseSource: string | null, activatedDate: string | null, healthResultsReleasedDate: string | null, breedResultsReleasedDate: string | null, comprehensiveUpgradePurchasedDate: string | null, swabCode: string | null, sampleState: SampleState }, genotype: { __typename: 'Genotype', id: string, breedType: string | null, breed1name: string | null, breed1pct: number | null, predictedWeight: number | null, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedPct: number }> } | null, health: { __typename: 'HealthSummary', results: Array<{ __typename: 'HealthResult', id: string, isPawsitResult: boolean, name: string, isBreedRelevant: boolean, severity: HealthResultSeverity, resultText: string | null, identifiedInText: string | null, isBeta: boolean, subdisorderName: string | null }> } | null, traits: { __typename: 'Traits', id: string, roundedCoiPercent: number | null, traitsCategory: Array<{ __typename: 'TraitCategory', name: string | null, description: string | null, order: number | null, traits: Array<{ __typename: 'Trait', additionalInfo: string | null, description: string | null, isAmbiguous: boolean | null, isLinkageTest: boolean | null, moreInformationUrl: string | null, name: string | null, order: number | null, result: string | null, showLinkageTestExplanation: boolean | null, sublabel: string | null, subloci: Array<{ __typename: 'ScientificResult', name: string | null, result: string | null }> | null, gene: { __typename: 'ScientificResult', name: string | null, result: string | null } | null, citations: Array<{ __typename: 'Citation', text: string | null, url: string | null }> | null }> | null }> | null } | null, ancestry: { __typename: 'Ancestry', breedMixScenario: AncestryBreedMixScenario | null, breedMixName: string | null, breeds: Array<{ __typename: 'AncestryBreed', ancestryLabel: string | null, index: number | null, percentage: number | null, name: string | null, image: string | null, displayPercentage: string | null } | null> | null, traceBreeds: { __typename: 'AncestryTraceBreeds', percentage: number | null, breeds: Array<{ __typename: 'AncestryTraceBreed', name: string | null, ancestryLabel: string | null, image: string | null }> | null } | null, similarPets: Array<{ __typename: 'AncestrySimilarPets', handle: string, image: string | null, likenessPercentage: number, name: string }> | null, familyTree: { __typename: 'AncestryFamilyTree', parents: Array<{ __typename: 'AncestryFamilyTreeRelation', position: number, ancestryLabel: string, displayName: string, breedImage: string | null }> | null, grandParents: Array<{ __typename: 'AncestryFamilyTreeRelation', position: number, ancestryLabel: string, displayName: string, breedImage: string | null }> | null, greatGrandParents: Array<{ __typename: 'AncestryFamilyTreeRelation', position: number, ancestryLabel: string, displayName: string, breedImage: string | null }> | null } | null, haplotype: { __typename: 'AncestryHaplotype', yHaplotype: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null, yHaplogroup: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null, mtHaplotype: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null, mtHaplogroup: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null } | null } | null, shareOptions: { __typename: 'ShareOptions', copyLinkUrl: string, downloadUrl: string | null, emailMailTo: string, facebookUrl: string, shareItemId: string | null } | null, ageTest: { __typename: 'AgeTestSummary', status: AgeTestStatus, activatedAt: string | null, releasedResult: { __typename: 'ReleasedResult', resultsUuid: string, predictedBirthday: string } | null } | null, microbiomeTests: Array<{ __typename: 'MicrobiomeTestSummary', createdAt: string, testType: TestType, state: SampleServiceState, reportUrl: string, resultsReleasedAt: string | null }>, profile: { __typename: 'Profile', breed: string | null, primaryBreedRegistrationOrganizationAcronym: string | null, primaryBreedRegistrationOrganizationName: string | null, primaryBreedRegistrationNumber: string | null }, surveys: Array<{ __typename: 'PetSurveyInfo', id: string, surveyUrl: string, survey: { __typename: 'Survey', id: string, slug: string, isShownOnResearchPage: boolean, title: string, subtitle: string | null, icon: string, color: string, category: { __typename: 'SurveyCategory', id: string, category: string, subtitle: string | null, priority: number } } }> } | null, permissions: { __typename: 'UserPermissions', showMatchMaker: boolean } } };

export type PetResultsSubPagePetFragment = { __typename: 'Pet', id: string, displayName: string | null, isEligibleForInsurance: boolean, insuranceUrl: string, petNum: number, name: string, handle: string, profileImageUrl: string | null, avatarColorIndex: number, hasSwab: boolean, isHealthReady: boolean, isNonhealthReady: boolean, showTraits: boolean, showRelativeFinder: boolean, isUpgradeAvailable: boolean, swabSummary: { __typename: 'SwabSummary', id: string, swabState: SwabState, productType: ProductType | null, productPurchaseSource: string | null, activatedDate: string | null, healthResultsReleasedDate: string | null, breedResultsReleasedDate: string | null, comprehensiveUpgradePurchasedDate: string | null }, genotype: { __typename: 'Genotype', id: string, breedType: string | null, breed1name: string | null, breed1pct: number | null } | null };

export type PetResultsSubPageUserFragment = { __typename: 'User', id: string, petCount: number, countryCode: string, userType: UserTypeGraphQl, shopLink: string, ecommLink: string, permissions: { __typename: 'UserPermissions', showMatchMaker: boolean } };

export type ResearchPageContainerPetFragment = { __typename: 'Pet', id: string, name: string, petNum: number, displayName: string | null, hasSwab: boolean, hasActivatedProducts: boolean, surveys: Array<{ __typename: 'PetSurveyInfo', id: string, surveyUrl: string, survey: { __typename: 'Survey', id: string, slug: string, isShownOnResearchPage: boolean, title: string, subtitle: string | null, icon: string, color: string, category: { __typename: 'SurveyCategory', id: string, category: string, subtitle: string | null, priority: number } } }> };

export type ResearchPagePetFragment = { __typename: 'Pet', id: string, petNum: number, displayName: string | null, name: string, hasSwab: boolean, hasActivatedProducts: boolean, surveys: Array<{ __typename: 'PetSurveyInfo', id: string, surveyUrl: string, survey: { __typename: 'Survey', id: string, slug: string, isShownOnResearchPage: boolean, title: string, subtitle: string | null, icon: string, color: string, category: { __typename: 'SurveyCategory', id: string, category: string, subtitle: string | null, priority: number } } }> };

export type SurveyProgressQueryVariables = Exact<{
  petNum: InputMaybe<Scalars['Int']>;
}>;


export type SurveyProgressQuery = { __typename: 'Query', me: { __typename: 'User', id: string, pets: Array<{ __typename: 'Pet', id: string, surveys: Array<{ __typename: 'PetSurveyInfo', id: string, surveyProgress: SurveyProgress }> }> } };

export type SurveyCardFragment = { __typename: 'PetSurveyInfo', id: string, surveyUrl: string, survey: { __typename: 'Survey', id: string, slug: string, title: string, subtitle: string | null, icon: string, color: string } };

export type SurveyCategorySectionFragment = { __typename: 'Pet', surveys: Array<{ __typename: 'PetSurveyInfo', id: string, surveyUrl: string, survey: { __typename: 'Survey', id: string, slug: string, isShownOnResearchPage: boolean, title: string, subtitle: string | null, icon: string, color: string, category: { __typename: 'SurveyCategory', id: string, category: string, subtitle: string | null, priority: number } } }> };

export type TraitsPagePetFragment = { __typename: 'Pet', id: string, name: string, handle: string, petNum: number, healthResultsState: ResultsState, isNonhealthReady: boolean, profileImageUrl: string | null, avatarColorIndex: number, showOfaReport: boolean, isEligibleForMatchmaker: boolean, sex: Sex, isEligibleForInsurance: boolean, hasResults: boolean, insuranceUrl: string, shouldShowFoodRecommendation: boolean, shouldShowAgeTestRecommendation: boolean, shouldShowGenotypeTestRecommendation: boolean, genotypeTestProductState: ProductState, ageTestProductState: ProductState, microbiomeTestProductState: ProductState, hashPetId: string, genotype: { __typename: 'Genotype', predictedWeight: number | null } | null, traits: { __typename: 'Traits', id: string, roundedCoiPercent: number | null, traitsCategory: Array<{ __typename: 'TraitCategory', name: string | null, description: string | null, order: number | null, traits: Array<{ __typename: 'Trait', additionalInfo: string | null, description: string | null, isAmbiguous: boolean | null, isLinkageTest: boolean | null, moreInformationUrl: string | null, name: string | null, order: number | null, result: string | null, showLinkageTestExplanation: boolean | null, sublabel: string | null, subloci: Array<{ __typename: 'ScientificResult', name: string | null, result: string | null }> | null, gene: { __typename: 'ScientificResult', name: string | null, result: string | null } | null, citations: Array<{ __typename: 'Citation', text: string | null, url: string | null }> | null }> | null }> | null } | null, swabSummary: { __typename: 'SwabSummary', id: string, productType: ProductType | null, swabCode: string | null }, ancestry: { __typename: 'Ancestry', breeds: Array<{ __typename: 'AncestryBreed', index: number | null, percentage: number | null, ancestryLabel: string | null } | null> | null } | null, health: { __typename: 'HealthSummary', results: Array<{ __typename: 'HealthResult', id: string, isPawsitResult: boolean, name: string, isBreedRelevant: boolean, severity: HealthResultSeverity, resultText: string | null, identifiedInText: string | null, isBeta: boolean, subdisorderName: string | null }> } | null };

export type TraitsPageUserFragment = { __typename: 'User', petCount: number };

export type PetParentDashboardPetFragment = { __typename: 'Pet', id: string, name: string, petNum: number, isPartOfAgeTestStudy: boolean, cursor: string, hasSwab: boolean, sex: Sex, profileImageUrl: string | null, avatarColorIndex: number, shareOptions: { __typename: 'ShareOptions', copyLinkUrl: string, downloadUrl: string | null, emailMailTo: string, facebookUrl: string, shareItemId: string | null } | null, swabSummary: { __typename: 'SwabSummary', breedResultsReleasedDate: string | null, healthResultsReleasedDate: string | null, productType: ProductType | null, sampleState: SampleState, id: string }, genotype: { __typename: 'Genotype', id: string, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedPct: number }> } | null, ageTest: { __typename: 'AgeTestSummary', status: AgeTestStatus, releasedResult: { __typename: 'ReleasedResult', resultsUuid: string } | null } | null, microbiomeTests: Array<{ __typename: 'MicrobiomeTestSummary', createdAt: string, testType: TestType, state: SampleServiceState, reportUrl: string, resultsReleasedAt: string | null }> };

export type PetParentDashboardContainerFragment = { __typename: 'User', id: string, petCount: number, hiddenPetCount: number, pets: Array<{ __typename: 'Pet', id: string, name: string, petNum: number, isPartOfAgeTestStudy: boolean, cursor: string, hasSwab: boolean, sex: Sex, profileImageUrl: string | null, avatarColorIndex: number, shareOptions: { __typename: 'ShareOptions', copyLinkUrl: string, downloadUrl: string | null, emailMailTo: string, facebookUrl: string, shareItemId: string | null } | null, swabSummary: { __typename: 'SwabSummary', breedResultsReleasedDate: string | null, healthResultsReleasedDate: string | null, productType: ProductType | null, sampleState: SampleState, id: string }, genotype: { __typename: 'Genotype', id: string, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedPct: number }> } | null, ageTest: { __typename: 'AgeTestSummary', status: AgeTestStatus, releasedResult: { __typename: 'ReleasedResult', resultsUuid: string } | null } | null, microbiomeTests: Array<{ __typename: 'MicrobiomeTestSummary', createdAt: string, testType: TestType, state: SampleServiceState, reportUrl: string, resultsReleasedAt: string | null }> }> };

export type PetParentDashboardQueryVariables = Exact<{
  pagination: InputMaybe<Pagination>;
  filters: InputMaybe<PetFilters>;
}>;


export type PetParentDashboardQuery = { __typename: 'Query', me: { __typename: 'User', id: string, petCount: number, countryCode: string, userType: UserTypeGraphQl, shopLink: string, ecommLink: string, hiddenPetCount: number, featureFlags: { __typename: 'FeatureFlags', showPetParentDashboard: boolean }, pets: Array<{ __typename: 'Pet', id: string, name: string, petNum: number, isPartOfAgeTestStudy: boolean, cursor: string, hasSwab: boolean, sex: Sex, profileImageUrl: string | null, avatarColorIndex: number, shareOptions: { __typename: 'ShareOptions', copyLinkUrl: string, downloadUrl: string | null, emailMailTo: string, facebookUrl: string, shareItemId: string | null } | null, swabSummary: { __typename: 'SwabSummary', breedResultsReleasedDate: string | null, healthResultsReleasedDate: string | null, productType: ProductType | null, sampleState: SampleState, id: string }, genotype: { __typename: 'Genotype', id: string, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedPct: number }> } | null, ageTest: { __typename: 'AgeTestSummary', status: AgeTestStatus, releasedResult: { __typename: 'ReleasedResult', resultsUuid: string } | null } | null, microbiomeTests: Array<{ __typename: 'MicrobiomeTestSummary', createdAt: string, testType: TestType, state: SampleServiceState, reportUrl: string, resultsReleasedAt: string | null }> }>, permissions: { __typename: 'UserPermissions', showMatchMaker: boolean } } };

export type GetHealthConditionDetailsQueryVariables = Exact<{
  filters: HealthConditionDetailsFilter;
}>;


export type GetHealthConditionDetailsQuery = { __typename: 'Query', healthConditionDetails: Array<{ __typename: 'HealthConditionDetails', healthId: string, topBreedsAffected: Array<{ __typename: 'HealthConditionTopBreedAffected', name: string, ancestryLabel: string, proportionDetected: number, image: string | null }> } | null> };

export type HealthConditionDetailsFragment = { __typename: 'HealthConditionDetails', healthId: string, topBreedsAffected: Array<{ __typename: 'HealthConditionTopBreedAffected', name: string, ancestryLabel: string, proportionDetected: number, image: string | null }> };

export type HealthConditionPagePetFragment = { __typename: 'Pet', petNum: number, name: string, sex: Sex, profileImageUrl: string | null, avatarColorIndex: number, id: string, hashPetId: string, swabSummary: { __typename: 'SwabSummary', id: string, productType: ProductType | null }, ancestry: { __typename: 'Ancestry', breeds: Array<{ __typename: 'AncestryBreed', index: number | null, percentage: number | null, ancestryLabel: string | null } | null> | null } | null };

export type GetHealthConditionQueryVariables = Exact<{
  petNum: Scalars['Int'];
  filters: HealthFilter;
}>;


export type GetHealthConditionQuery = { __typename: 'Query', me: { __typename: 'User', id: string, petByPetNum: { __typename: 'Pet', id: string, health: { __typename: 'HealthSummary', results: Array<{ __typename: 'HealthResult', id: string, isPawsitResult: boolean, name: string, scientificName: string, severity: HealthResultSeverity, description: string | null, additionalDescription: string | null, actions: Array<string | null> | null, signs: string | null, signsDevelop: string | null, diagnosis: string | null, risk: string | null, explanation: string | null, scientificBasis: string | null, breedingImpact: string | null, treatment: string | null, numberOfVariants: number | null, gene: string | null, moi: string | null, isLinkageTest: boolean | null, isProvisional: boolean | null, variants: string | null, isClinicalTool: boolean | null, isXLinked: boolean | null, subdisorderName: string | null, shortDescription: string | null, detailedDescriptions: Array<string | null> | null, conditionClinicalSigns: Array<string | null> | null, conditionClinicalWarningSigns: Array<string | null> | null, diagnosisDescriptions: Array<string | null> | null, surveyContents: Array<string | null> | null, treatmentRecommendations: Array<string | null> | null, riskChanceDescriptions: Array<string> | null, riskFactorDescriptions: Array<string | null> | null, riskExplainerDescriptions: Array<string | null> | null, identifiedInText: string | null, probability: number | null, inapplicabilityReason: string | null, references: Array<{ __typename: 'HealthResultReference', url: string, text: string } | null> | null, scienceBodyLink: { __typename: 'HealthResultReference', url: string, text: string } | null }> } | null } | null } };

export type MonogenicConditionPageFragment = { __typename: 'HealthResult', id: string, name: string, scientificName: string, severity: HealthResultSeverity, description: string | null, additionalDescription: string | null, actions: Array<string | null> | null, signs: string | null, signsDevelop: string | null, diagnosis: string | null, risk: string | null, explanation: string | null, scientificBasis: string | null, breedingImpact: string | null, treatment: string | null, numberOfVariants: number | null, gene: string | null, moi: string | null, isLinkageTest: boolean | null, isProvisional: boolean | null, variants: string | null, isClinicalTool: boolean | null, isXLinked: boolean | null, subdisorderName: string | null, references: Array<{ __typename: 'HealthResultReference', url: string, text: string } | null> | null };

export type PolygenicConditionPageFragment = { __typename: 'HealthResult', name: string, id: string, severity: HealthResultSeverity, shortDescription: string | null, detailedDescriptions: Array<string | null> | null, conditionClinicalSigns: Array<string | null> | null, conditionClinicalWarningSigns: Array<string | null> | null, diagnosisDescriptions: Array<string | null> | null, surveyContents: Array<string | null> | null, treatmentRecommendations: Array<string | null> | null, riskChanceDescriptions: Array<string> | null, riskFactorDescriptions: Array<string | null> | null, riskExplainerDescriptions: Array<string | null> | null, identifiedInText: string | null, probability: number | null, inapplicabilityReason: string | null, scienceBodyLink: { __typename: 'HealthResultReference', url: string, text: string } | null, references: Array<{ __typename: 'HealthResultReference', url: string, text: string } | null> | null };

export type HealthPagePetFragment = { __typename: 'Pet', id: string, name: string, handle: string, isNonhealthReady: boolean, showOfaReport: boolean, isEligibleForMatchmaker: boolean, profileImageUrl: string | null, avatarColorIndex: number, petNum: number, sex: Sex, isEligibleForInsurance: boolean, hasResults: boolean, insuranceUrl: string, shouldShowFoodRecommendation: boolean, shouldShowAgeTestRecommendation: boolean, shouldShowGenotypeTestRecommendation: boolean, genotypeTestProductState: ProductState, ageTestProductState: ProductState, microbiomeTestProductState: ProductState, hashPetId: string, health: { __typename: 'HealthSummary', results: Array<{ __typename: 'HealthResult', id: string, isPawsitResult: boolean, name: string, isBreedRelevant: boolean, severity: HealthResultSeverity, resultText: string | null, identifiedInText: string | null, isBeta: boolean, subdisorderName: string | null }> } | null, traits: { __typename: 'Traits', id: string, roundedCoiPercent: number | null } | null, swabSummary: { __typename: 'SwabSummary', swabCode: string | null, id: string, productType: ProductType | null }, ancestry: { __typename: 'Ancestry', breeds: Array<{ __typename: 'AncestryBreed', index: number | null, percentage: number | null, ancestryLabel: string | null } | null> | null } | null };

export type HealthPageResultFragment = { __typename: 'HealthResult', id: string, isPawsitResult: boolean, name: string, isBreedRelevant: boolean, severity: HealthResultSeverity, resultText: string | null, identifiedInText: string | null, isBeta: boolean, subdisorderName: string | null };

export type NutritionPageFragment = { __typename: 'Pet', id: string, petNum: number, name: string, sex: Sex, dateOfBirth: string | null, isDateOfBirthEstimated: boolean | null, profileImageUrl: string | null, avatarColorIndex: number, swabSummary: { __typename: 'SwabSummary', id: string, productType: ProductType | null }, ancestry: { __typename: 'Ancestry', breeds: Array<{ __typename: 'AncestryBreed', index: number | null, percentage: number | null, ancestryLabel: string | null } | null> | null } | null };

export type NutritionPageUserFragment = { __typename: 'User', userGroup: number };

export type SubmitNutritionRecommendationRequestMutationVariables = Exact<{
  nutritionInput: NutritionRecommendationInput;
}>;


export type SubmitNutritionRecommendationRequestMutation = { __typename: 'Mutation', pet: { __typename: 'PetMutation', submitNutritionRecommendationRequest: { __typename: 'NutritionRecommendation', weight: number, benefit: string, birthday: string, ageCategory: NutritionAgeCategory, description: string, bodyCondition: NutritionBodyCondition, breedSize: NutritionBreedSize, dailyEnergyRequirement: number | null, activityLevel: NutritionActivityLevel, foodRecommendations: Array<{ __typename: 'NutritionRecommendationProduct', image: string, productKey: string, productName: string, type: NutritionProductType, url: string, recommendedDailyVolume: { __typename: 'NutritionDailyRecommendedFoodVolume', decimal: number, fraction: string } | null }>, ingredients: Array<{ __typename: 'NutritionRecommendationIngredient', name: string, description: string }>, nutrients: Array<{ __typename: 'NutritionRecommendationNutrient', name: string }> } | null } };

export type SaveNutritionInputDataMutationVariables = Exact<{
  nutritionDataInput: SaveNutritionDataInput;
}>;


export type SaveNutritionInputDataMutation = { __typename: 'Mutation', pet: { __typename: 'PetMutation', saveNutritionInputData: { __typename: 'SaveNutritionDataOutput', sessionId: string } } };

export type PetCardFragment = { __typename: 'Pet', name: string, id: string, petNum: number, hasSwab: boolean, sex: Sex, profileImageUrl: string | null, avatarColorIndex: number, isPartOfAgeTestStudy: boolean, shareOptions: { __typename: 'ShareOptions', copyLinkUrl: string, downloadUrl: string | null, emailMailTo: string, facebookUrl: string, shareItemId: string | null } | null, swabSummary: { __typename: 'SwabSummary', breedResultsReleasedDate: string | null, healthResultsReleasedDate: string | null, productType: ProductType | null, sampleState: SampleState, id: string }, genotype: { __typename: 'Genotype', id: string, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedPct: number }> } | null, ageTest: { __typename: 'AgeTestSummary', status: AgeTestStatus, releasedResult: { __typename: 'ReleasedResult', resultsUuid: string } | null } | null, microbiomeTests: Array<{ __typename: 'MicrobiomeTestSummary', createdAt: string, testType: TestType, state: SampleServiceState, reportUrl: string, resultsReleasedAt: string | null }> };

export type AgeTestProductCardFragment = { __typename: 'Pet', id: string, petNum: number, name: string, isPartOfAgeTestStudy: boolean, ageTest: { __typename: 'AgeTestSummary', status: AgeTestStatus, releasedResult: { __typename: 'ReleasedResult', resultsUuid: string } | null } | null };

export type GenotypeTestProductCardFragment = { __typename: 'Pet', sex: Sex, petNum: number, id: string, hasSwab: boolean, name: string, shareOptions: { __typename: 'ShareOptions', copyLinkUrl: string, downloadUrl: string | null, emailMailTo: string, facebookUrl: string, shareItemId: string | null } | null, swabSummary: { __typename: 'SwabSummary', breedResultsReleasedDate: string | null, healthResultsReleasedDate: string | null, productType: ProductType | null, sampleState: SampleState } };

export type GenotypeTestSwabDetailFragment = { __typename: 'Pet', name: string, petNum: number, swabSummary: { __typename: 'SwabSummary', productType: ProductType | null, sampleState: SampleState } };

export type RecommendationCardFragment = { __typename: 'Pet', petNum: number, name: string, sex: Sex, isEligibleForInsurance: boolean, hasResults: boolean, insuranceUrl: string, shouldShowFoodRecommendation: boolean, shouldShowAgeTestRecommendation: boolean, shouldShowGenotypeTestRecommendation: boolean, genotypeTestProductState: ProductState, ageTestProductState: ProductState, microbiomeTestProductState: ProductState };

export type AgeTestSummaryCardFragment = { __typename: 'Pet', id: string, petNum: number, isPartOfAgeTestStudy: boolean, name: string, profileImageUrl: string | null, avatarColorIndex: number, sex: Sex, ageTest: { __typename: 'AgeTestSummary', status: AgeTestStatus, activatedAt: string | null, releasedResult: { __typename: 'ReleasedResult', resultsUuid: string, predictedBirthday: string } | null } | null };

export type AgeTestSwabTrackerFragment = { __typename: 'Pet', name: string, petNum: number, sex: Sex, ageTest: { __typename: 'AgeTestSummary', status: AgeTestStatus } | null };

export type DownloadCardFragment = { __typename: 'Pet', hashPetId: string, petNum: number, isPrimaryOwnerBreeder: boolean, showOfaReport: boolean };

export type SummaryPageGenotypeCardFragment = { __typename: 'Pet', name: string, handle: string, petNum: number, hasSwab: boolean, isUpgradeAvailable: boolean, profileImageUrl: string | null, avatarColorIndex: number, swabSummary: { __typename: 'SwabSummary', activatedDate: string | null, productType: ProductType | null, swabCode: string | null, id: string, sampleState: SampleState }, ancestry: { __typename: 'Ancestry', breeds: Array<{ __typename: 'AncestryBreed', index: number | null, percentage: number | null, ancestryLabel: string | null } | null> | null } | null };

export type GenotypeSwabTrackerFragment = { __typename: 'Pet', name: string, petNum: number, swabSummary: { __typename: 'SwabSummary', productType: ProductType | null, sampleState: SampleState } };

export type HealthSummaryCardFragment = { __typename: 'Pet', name: string, isHealthReady: boolean, petNum: number, id: string, handle: string, isNonhealthReady: boolean, showOfaReport: boolean, isEligibleForMatchmaker: boolean, profileImageUrl: string | null, avatarColorIndex: number, sex: Sex, isEligibleForInsurance: boolean, hasResults: boolean, insuranceUrl: string, shouldShowFoodRecommendation: boolean, shouldShowAgeTestRecommendation: boolean, shouldShowGenotypeTestRecommendation: boolean, genotypeTestProductState: ProductState, ageTestProductState: ProductState, microbiomeTestProductState: ProductState, hashPetId: string, health: { __typename: 'HealthSummary', results: Array<{ __typename: 'HealthResult', id: string, isPawsitResult: boolean, name: string, isBreedRelevant: boolean, severity: HealthResultSeverity, resultText: string | null, identifiedInText: string | null, isBeta: boolean, subdisorderName: string | null }> } | null, traits: { __typename: 'Traits', id: string, roundedCoiPercent: number | null } | null, swabSummary: { __typename: 'SwabSummary', swabCode: string | null, id: string, productType: ProductType | null }, ancestry: { __typename: 'Ancestry', breeds: Array<{ __typename: 'AncestryBreed', index: number | null, percentage: number | null, ancestryLabel: string | null } | null> | null } | null };

export type MicrobiomeSummaryCardFragment = { __typename: 'Pet', id: string, name: string, profileImageUrl: string | null, avatarColorIndex: number, microbiomeTests: Array<{ __typename: 'MicrobiomeTestSummary', createdAt: string, testType: TestType, state: SampleServiceState, reportUrl: string, resultsReleasedAt: string | null }> };

export type ProductCardFragment = { __typename: 'Pet', name: string, profileImageUrl: string | null, avatarColorIndex: number };

export type SummaryPagePetFragment = { __typename: 'Pet', id: string, name: string, petNum: number, hasActivatedProducts: boolean, genotypeTestProductState: ProductState, isHealthReady: boolean, handle: string, profileImageUrl: string | null, avatarColorIndex: number, hasSwab: boolean, isNonhealthReady: boolean, showTraits: boolean, showRelativeFinder: boolean, isUpgradeAvailable: boolean, hashPetId: string, isPrimaryOwnerBreeder: boolean, showOfaReport: boolean, sex: Sex, isEligibleForInsurance: boolean, hasResults: boolean, insuranceUrl: string, shouldShowFoodRecommendation: boolean, shouldShowAgeTestRecommendation: boolean, shouldShowGenotypeTestRecommendation: boolean, ageTestProductState: ProductState, microbiomeTestProductState: ProductState, isPartOfAgeTestStudy: boolean, ancestryResultsState: ResultsState, isEligibleForMatchmaker: boolean, ageTest: { __typename: 'AgeTestSummary', status: AgeTestStatus, activatedAt: string | null, releasedResult: { __typename: 'ReleasedResult', resultsUuid: string, predictedBirthday: string } | null } | null, microbiomeTests: Array<{ __typename: 'MicrobiomeTestSummary', createdAt: string, testType: TestType, state: SampleServiceState, reportUrl: string, resultsReleasedAt: string | null }>, swabSummary: { __typename: 'SwabSummary', activatedDate: string | null, productType: ProductType | null, swabCode: string | null, id: string, swabState: SwabState, productPurchaseSource: string | null, healthResultsReleasedDate: string | null, breedResultsReleasedDate: string | null, comprehensiveUpgradePurchasedDate: string | null, sampleState: SampleState }, ancestry: { __typename: 'Ancestry', breedMixScenario: AncestryBreedMixScenario | null, breedMixName: string | null, breeds: Array<{ __typename: 'AncestryBreed', ancestryLabel: string | null, index: number | null, percentage: number | null, name: string | null, image: string | null, displayPercentage: string | null } | null> | null, traceBreeds: { __typename: 'AncestryTraceBreeds', percentage: number | null, breeds: Array<{ __typename: 'AncestryTraceBreed', name: string | null, ancestryLabel: string | null, image: string | null }> | null } | null, similarPets: Array<{ __typename: 'AncestrySimilarPets', handle: string, image: string | null, likenessPercentage: number, name: string }> | null, familyTree: { __typename: 'AncestryFamilyTree', parents: Array<{ __typename: 'AncestryFamilyTreeRelation', position: number, ancestryLabel: string, displayName: string, breedImage: string | null }> | null, grandParents: Array<{ __typename: 'AncestryFamilyTreeRelation', position: number, ancestryLabel: string, displayName: string, breedImage: string | null }> | null, greatGrandParents: Array<{ __typename: 'AncestryFamilyTreeRelation', position: number, ancestryLabel: string, displayName: string, breedImage: string | null }> | null } | null, haplotype: { __typename: 'AncestryHaplotype', yHaplotype: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null, yHaplogroup: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null, mtHaplotype: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null, mtHaplogroup: { __typename: 'AncestryHaplotypeDetails', map: string | null, label: string | null, description: string | null } | null } | null } | null, shareOptions: { __typename: 'ShareOptions', copyLinkUrl: string, downloadUrl: string | null, emailMailTo: string, facebookUrl: string, shareItemId: string | null } | null, health: { __typename: 'HealthSummary', results: Array<{ __typename: 'HealthResult', id: string, isPawsitResult: boolean, name: string, isBreedRelevant: boolean, severity: HealthResultSeverity, resultText: string | null, identifiedInText: string | null, isBeta: boolean, subdisorderName: string | null }> } | null, traits: { __typename: 'Traits', id: string, roundedCoiPercent: number | null } | null, genotype: { __typename: 'Genotype', id: string, breedType: string | null, breed1name: string | null, breed1pct: number | null, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedPct: number }> } | null, profile: { __typename: 'Profile', breed: string | null, primaryBreedRegistrationOrganizationAcronym: string | null, primaryBreedRegistrationOrganizationName: string | null, primaryBreedRegistrationNumber: string | null } };

export type SummaryPageUserFragment = { __typename: 'User', petCount: number };

export type EmailPreferencesUserFragment = { __typename: 'User', emailPreferences: { __typename: 'EmailPreferences', isChatEnabled: boolean, isDogsLikeMineEnabled: boolean, isRelativeFinderEnabled: boolean, isCareResourcesEnabled: boolean, isResearchSurveysEnabled: boolean, isNewslettersEnabled: boolean, isPromotionsAndSalesEnabled: boolean, isProductUpdatesEnabled: boolean, isBreederNewslettersEnabled: boolean, isBreederPromotionsAndSalesEnabled: boolean, isBreederEventsEnabled: boolean, isVetNewslettersEnabled: boolean, isVetBusinessCommunicationsEnabled: boolean, isVetEventsEnabled: boolean } };

export type EmailPreferencesFragment = { __typename: 'EmailPreferences', isChatEnabled: boolean, isDogsLikeMineEnabled: boolean, isRelativeFinderEnabled: boolean, isCareResourcesEnabled: boolean, isResearchSurveysEnabled: boolean, isNewslettersEnabled: boolean, isPromotionsAndSalesEnabled: boolean, isProductUpdatesEnabled: boolean, isBreederNewslettersEnabled: boolean, isBreederPromotionsAndSalesEnabled: boolean, isBreederEventsEnabled: boolean, isVetNewslettersEnabled: boolean, isVetBusinessCommunicationsEnabled: boolean, isVetEventsEnabled: boolean };

export type UpdateEmailPreferencesMutationVariables = Exact<{
  preferences: EmailPreferencesInput;
}>;


export type UpdateEmailPreferencesMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', updateUserEmailPreferences: { __typename: 'EmailPreferences', isChatEnabled: boolean, isDogsLikeMineEnabled: boolean, isRelativeFinderEnabled: boolean, isCareResourcesEnabled: boolean, isResearchSurveysEnabled: boolean, isNewslettersEnabled: boolean, isPromotionsAndSalesEnabled: boolean, isProductUpdatesEnabled: boolean, isBreederNewslettersEnabled: boolean, isBreederPromotionsAndSalesEnabled: boolean, isBreederEventsEnabled: boolean, isVetNewslettersEnabled: boolean, isVetBusinessCommunicationsEnabled: boolean, isVetEventsEnabled: boolean } | null } };

export type UserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSettingsQuery = { __typename: 'Query', me: { __typename: 'User', id: string, emailPreferences: { __typename: 'EmailPreferences', isChatEnabled: boolean, isDogsLikeMineEnabled: boolean, isRelativeFinderEnabled: boolean, isCareResourcesEnabled: boolean, isResearchSurveysEnabled: boolean, isNewslettersEnabled: boolean, isPromotionsAndSalesEnabled: boolean, isProductUpdatesEnabled: boolean, isBreederNewslettersEnabled: boolean, isBreederPromotionsAndSalesEnabled: boolean, isBreederEventsEnabled: boolean, isVetNewslettersEnabled: boolean, isVetBusinessCommunicationsEnabled: boolean, isVetEventsEnabled: boolean } } };

export type AddNewPatientMutationVariables = Exact<{
  patient: NewPatientInput;
}>;


export type AddNewPatientMutation = { __typename: 'Mutation', vet: { __typename: 'VetMutation', addNewPatient: { __typename: 'Pet', petNum: number } } };

export type UpdatePatientMutationVariables = Exact<{
  patient: UpdatePatientInput;
}>;


export type UpdatePatientMutation = { __typename: 'Mutation', vet: { __typename: 'VetMutation', updatePatient: { __typename: 'Pet', petNum: number } } };

export type ActivateSwabMutationVariables = Exact<{
  activationDetails: ActivateSwabInput;
}>;


export type ActivateSwabMutation = { __typename: 'Mutation', pet: { __typename: 'PetMutation', activateSwab: { __typename: 'Pet', swabSummary: { __typename: 'SwabSummary', swabCode: string | null } } } };

export type VetDashboardInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type VetDashboardInfoQuery = { __typename: 'Query', me: { __typename: 'User', id: string, practice: { __typename: 'VetPractice', practiceId: string, name: string, createdAt: string, swabsOrderedCount: number, petActivationCount: number, practicePetCount: number, id: string, practiceUsers: Array<{ __typename: 'VetPracticeUser', id: string, name: string, email: string, isDVM: boolean }>, onboardingChecklist: { __typename: 'OnboardingChecklistStatus', placeFirstOrder: boolean, testFirstPatient: boolean, receiveFirstResults: boolean, assignStaffChampion: boolean, talkAboutGeneticTesting: boolean, learnToUseDashboard: boolean, connectWithSuccessManager: boolean }, onboardingMetadata: { __typename: 'VetPracticeOnboardingMetadata', hasFewPatientsAndSomeAllClearResults: boolean, hasFewPatientsAndSomeNotableOrAtRiskResults: boolean } } | null } };

export type ListPracticePetsQueryVariables = Exact<{
  pagination: InputMaybe<Pagination>;
  filters: InputMaybe<PetFilters>;
  sort: InputMaybe<PetSort>;
}>;


export type ListPracticePetsQuery = { __typename: 'Query', me: { __typename: 'User', id: string, petCount: number, pets: Array<{ __typename: 'Pet', dateAdded: number, id: string, name: string, handle: string, petNum: number, profileImageUrl: string | null, cursor: string, sex: Sex, intact: Intact | null, dateOfBirth: string | null, swabSummary: { __typename: 'SwabSummary', vetSummary: { __typename: 'VetSwabSummary', swabState: SwabState, header: string, subheader: string | null } }, vetPracticeInfo: { __typename: 'VetPracticePetInfo', clientName: string, clientEmail: string | null, patientEMRId: string | null, reportUrl: string | null, caseCompleted: boolean, isVetAffiliate: boolean, clientPhone: string | null, swabOrderedBy: { __typename: 'VetPracticeUser', name: string, isDVM: boolean, id: string } | null, vetClientTransfer: { __typename: 'VetClientTransfer', completedAt: string | null, recipientEmail: string | null, recipientName: string | null, requestedAt: string | null, requestedByName: string | null, requesterIsDVM: boolean | null } | null, patientNotes: Array<{ __typename: 'VetPatientNote', createdAt: string, content: string, id: string }> } | null, genotype: { __typename: 'Genotype', breedType: string | null, shouldShowVetBreedCount: boolean, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedName: string, breedPct: number, displayBreedPercent: string }> } | null, health: { __typename: 'HealthSummary', increasedRiskCount: number, notableVariantCount: number, allClearCount: number } | null, ageTest: { __typename: 'AgeTestSummary', activatedAt: string | null } | null }> } };

export type ListPracticePetFragment = { __typename: 'Pet', dateAdded: number, id: string, name: string, handle: string, petNum: number, profileImageUrl: string | null, cursor: string, sex: Sex, intact: Intact | null, dateOfBirth: string | null, swabSummary: { __typename: 'SwabSummary', vetSummary: { __typename: 'VetSwabSummary', swabState: SwabState, header: string, subheader: string | null } }, vetPracticeInfo: { __typename: 'VetPracticePetInfo', clientName: string, clientEmail: string | null, patientEMRId: string | null, reportUrl: string | null, caseCompleted: boolean, isVetAffiliate: boolean, clientPhone: string | null, swabOrderedBy: { __typename: 'VetPracticeUser', name: string, isDVM: boolean, id: string } | null, vetClientTransfer: { __typename: 'VetClientTransfer', completedAt: string | null, recipientEmail: string | null, recipientName: string | null, requestedAt: string | null, requestedByName: string | null, requesterIsDVM: boolean | null } | null, patientNotes: Array<{ __typename: 'VetPatientNote', createdAt: string, content: string, id: string }> } | null, genotype: { __typename: 'Genotype', breedType: string | null, shouldShowVetBreedCount: boolean, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedName: string, breedPct: number, displayBreedPercent: string }> } | null, health: { __typename: 'HealthSummary', increasedRiskCount: number, notableVariantCount: number, allClearCount: number } | null, ageTest: { __typename: 'AgeTestSummary', activatedAt: string | null } | null };

export type PracticePetCardFragment = { __typename: 'Pet', id: string, name: string, handle: string, petNum: number, profileImageUrl: string | null, cursor: string, sex: Sex, intact: Intact | null, dateOfBirth: string | null, swabSummary: { __typename: 'SwabSummary', vetSummary: { __typename: 'VetSwabSummary', swabState: SwabState, header: string, subheader: string | null } }, vetPracticeInfo: { __typename: 'VetPracticePetInfo', clientName: string, clientEmail: string | null, patientEMRId: string | null, reportUrl: string | null, caseCompleted: boolean, isVetAffiliate: boolean, clientPhone: string | null, swabOrderedBy: { __typename: 'VetPracticeUser', name: string, isDVM: boolean, id: string } | null, vetClientTransfer: { __typename: 'VetClientTransfer', completedAt: string | null, recipientEmail: string | null, recipientName: string | null, requestedAt: string | null, requestedByName: string | null, requesterIsDVM: boolean | null } | null, patientNotes: Array<{ __typename: 'VetPatientNote', createdAt: string, content: string, id: string }> } | null, genotype: { __typename: 'Genotype', breedType: string | null, shouldShowVetBreedCount: boolean, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedName: string, breedPct: number, displayBreedPercent: string }> } | null, health: { __typename: 'HealthSummary', increasedRiskCount: number, notableVariantCount: number, allClearCount: number } | null, ageTest: { __typename: 'AgeTestSummary', activatedAt: string | null } | null };

export type ClientDetailsModalButtonFragment = { __typename: 'Pet', id: string, name: string, sex: Sex, intact: Intact | null, dateOfBirth: string | null, petNum: number, handle: string, vetPracticeInfo: { __typename: 'VetPracticePetInfo', clientEmail: string | null, clientName: string, clientPhone: string | null, patientEMRId: string | null } | null };

export type OnboardingChecklistStatusFragment = { __typename: 'OnboardingChecklistStatus', placeFirstOrder: boolean, testFirstPatient: boolean, receiveFirstResults: boolean, assignStaffChampion: boolean, talkAboutGeneticTesting: boolean, learnToUseDashboard: boolean, connectWithSuccessManager: boolean };

export type ReleasePetToClientMutationVariables = Exact<{
  vetPatient: ReleasePetToClientInput;
}>;


export type ReleasePetToClientMutation = { __typename: 'Mutation', vet: { __typename: 'VetMutation', releasePetToClient: { __typename: 'Pet', id: string, name: string, handle: string, petNum: number, profileImageUrl: string | null, cursor: string, sex: Sex, intact: Intact | null, dateOfBirth: string | null, swabSummary: { __typename: 'SwabSummary', vetSummary: { __typename: 'VetSwabSummary', swabState: SwabState, header: string, subheader: string | null } }, vetPracticeInfo: { __typename: 'VetPracticePetInfo', clientName: string, clientEmail: string | null, patientEMRId: string | null, reportUrl: string | null, caseCompleted: boolean, isVetAffiliate: boolean, clientPhone: string | null, swabOrderedBy: { __typename: 'VetPracticeUser', name: string, isDVM: boolean, id: string } | null, vetClientTransfer: { __typename: 'VetClientTransfer', completedAt: string | null, recipientEmail: string | null, recipientName: string | null, requestedAt: string | null, requestedByName: string | null, requesterIsDVM: boolean | null } | null, patientNotes: Array<{ __typename: 'VetPatientNote', createdAt: string, content: string, id: string }> } | null, genotype: { __typename: 'Genotype', breedType: string | null, shouldShowVetBreedCount: boolean, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedName: string, breedPct: number, displayBreedPercent: string }> } | null, health: { __typename: 'HealthSummary', increasedRiskCount: number, notableVariantCount: number, allClearCount: number } | null, ageTest: { __typename: 'AgeTestSummary', activatedAt: string | null } | null } } };

export type DeletePatientNoteMutationVariables = Exact<{
  noteToDelete: DeleteVetPatientNoteInput;
}>;


export type DeletePatientNoteMutation = { __typename: 'Mutation', vet: { __typename: 'VetMutation', deletePatientNote: { __typename: 'Pet', id: string, name: string, handle: string, petNum: number, profileImageUrl: string | null, cursor: string, sex: Sex, intact: Intact | null, dateOfBirth: string | null, swabSummary: { __typename: 'SwabSummary', vetSummary: { __typename: 'VetSwabSummary', swabState: SwabState, header: string, subheader: string | null } }, vetPracticeInfo: { __typename: 'VetPracticePetInfo', clientName: string, clientEmail: string | null, patientEMRId: string | null, reportUrl: string | null, caseCompleted: boolean, isVetAffiliate: boolean, clientPhone: string | null, swabOrderedBy: { __typename: 'VetPracticeUser', name: string, isDVM: boolean, id: string } | null, vetClientTransfer: { __typename: 'VetClientTransfer', completedAt: string | null, recipientEmail: string | null, recipientName: string | null, requestedAt: string | null, requestedByName: string | null, requesterIsDVM: boolean | null } | null, patientNotes: Array<{ __typename: 'VetPatientNote', createdAt: string, content: string, id: string }> } | null, genotype: { __typename: 'Genotype', breedType: string | null, shouldShowVetBreedCount: boolean, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedName: string, breedPct: number, displayBreedPercent: string }> } | null, health: { __typename: 'HealthSummary', increasedRiskCount: number, notableVariantCount: number, allClearCount: number } | null, ageTest: { __typename: 'AgeTestSummary', activatedAt: string | null } | null } } };

export type UpdatePatientCaseMutationVariables = Exact<{
  formInformationToSubmit: UpdatePatientCaseInput;
}>;


export type UpdatePatientCaseMutation = { __typename: 'Mutation', vet: { __typename: 'VetMutation', updatePatientCase: { __typename: 'Pet', id: string, name: string, handle: string, petNum: number, profileImageUrl: string | null, cursor: string, sex: Sex, intact: Intact | null, dateOfBirth: string | null, swabSummary: { __typename: 'SwabSummary', vetSummary: { __typename: 'VetSwabSummary', swabState: SwabState, header: string, subheader: string | null } }, vetPracticeInfo: { __typename: 'VetPracticePetInfo', clientName: string, clientEmail: string | null, patientEMRId: string | null, reportUrl: string | null, caseCompleted: boolean, isVetAffiliate: boolean, clientPhone: string | null, swabOrderedBy: { __typename: 'VetPracticeUser', name: string, isDVM: boolean, id: string } | null, vetClientTransfer: { __typename: 'VetClientTransfer', completedAt: string | null, recipientEmail: string | null, recipientName: string | null, requestedAt: string | null, requestedByName: string | null, requesterIsDVM: boolean | null } | null, patientNotes: Array<{ __typename: 'VetPatientNote', createdAt: string, content: string, id: string }> } | null, genotype: { __typename: 'Genotype', breedType: string | null, shouldShowVetBreedCount: boolean, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedName: string, breedPct: number, displayBreedPercent: string }> } | null, health: { __typename: 'HealthSummary', increasedRiskCount: number, notableVariantCount: number, allClearCount: number } | null, ageTest: { __typename: 'AgeTestSummary', activatedAt: string | null } | null } } };

export type UpdatePracticeOnboardingChecklistStatusMutationVariables = Exact<{
  formInformationToSubmit: UpdatePracticeOnboardingChecklistInput;
}>;


export type UpdatePracticeOnboardingChecklistStatusMutation = { __typename: 'Mutation', vet: { __typename: 'VetMutation', updatePracticeOnboardingChecklistStatus: { __typename: 'OnboardingChecklistStatus', placeFirstOrder: boolean, testFirstPatient: boolean, receiveFirstResults: boolean, assignStaffChampion: boolean, talkAboutGeneticTesting: boolean, learnToUseDashboard: boolean, connectWithSuccessManager: boolean } } };

export type GetPetUuidQueryVariables = Exact<{
  petNum: Scalars['Int'];
}>;


export type GetPetUuidQuery = { __typename: 'Query', me: { __typename: 'User', id: string, petByPetNum: { __typename: 'Pet', id: string } | null } };

export type GetGeneticStatsSectionDataQueryVariables = Exact<{
  petNum: Scalars['Int'];
}>;


export type GetGeneticStatsSectionDataQuery = { __typename: 'Query', me: { __typename: 'User', id: string, petByPetNum: { __typename: 'Pet', id: string, name: string, petNum: number, sex: Sex, lifeStage: PetLifeStage | null, dateOfBirth: string | null, isDateOfBirthEstimated: boolean | null, shouldShowAgeTestRecommendation: boolean, showTraits: boolean, ageTest: { __typename: 'AgeTestSummary', status: AgeTestStatus, releasedResult: { __typename: 'ReleasedResult', resultsUuid: string, isAccurate: boolean | null, predictedBirthday: string, isUserFeedbackCollected: boolean } | null } | null, genotype: { __typename: 'Genotype', predictedWeight: number | null, wolfiness: number | null, wolfinessContext: string | null } | null } | null } };

export type GetLocationsForPetQueryVariables = Exact<{
  petNum: Scalars['Int'];
}>;


export type GetLocationsForPetQuery = { __typename: 'Query', me: { __typename: 'User', id: string, petByPetNum: { __typename: 'Pet', id: string, petNum: number, locations: { __typename: 'PetLocations', born: { __typename: 'LocationDetailsType', addressInput: string } | null, from: { __typename: 'LocationDetailsType', addressInput: string } | null, live: { __typename: 'LocationDetailsType', addressInput: string } | null } } | null } };

export type PetLocationInformationFragment = { __typename: 'Pet', petNum: number, id: string, locations: { __typename: 'PetLocations', born: { __typename: 'LocationDetailsType', addressInput: string } | null, from: { __typename: 'LocationDetailsType', addressInput: string } | null, live: { __typename: 'LocationDetailsType', addressInput: string } | null } };

export type UpdatePetLocationsMutationVariables = Exact<{
  petLocations: UpdatePetLocationsInput;
}>;


export type UpdatePetLocationsMutation = { __typename: 'Mutation', pet: { __typename: 'PetMutation', updatePetLocations: { __typename: 'Pet', id: string } } };

export type GetPetResultsNavDataQueryVariables = Exact<{
  petNum: Scalars['Int'];
}>;


export type GetPetResultsNavDataQuery = { __typename: 'Query', me: { __typename: 'User', id: string, petByPetNum: { __typename: 'Pet', id: string, petNum: number, name: string, handle: string, profileImageUrl: string | null, avatarColorIndex: number, hasSwab: boolean, isHealthReady: boolean, isNonhealthReady: boolean, showTraits: boolean, showRelativeFinder: boolean, isUpgradeAvailable: boolean, swabSummary: { __typename: 'SwabSummary', id: string, swabState: SwabState, productType: ProductType | null, productPurchaseSource: string | null, activatedDate: string | null, healthResultsReleasedDate: string | null, breedResultsReleasedDate: string | null, comprehensiveUpgradePurchasedDate: string | null }, genotype: { __typename: 'Genotype', id: string, breedType: string | null, breed1name: string | null, breed1pct: number | null } | null } | null } };

export type GetProfileDataSettingsDataQueryVariables = Exact<{
  petNum: Scalars['Int'];
}>;


export type GetProfileDataSettingsDataQuery = { __typename: 'Query', me: { __typename: 'User', id: string, ecommLink: string, petByPetNum: { __typename: 'Pet', id: string, petNum: number } | null } };

export type GetVeterinaryInformationForPetQueryVariables = Exact<{
  petNum: Scalars['Int'];
}>;


export type GetVeterinaryInformationForPetQuery = { __typename: 'Query', me: { __typename: 'User', id: string, petByPetNum: { __typename: 'Pet', id: string, petNum: number, embarkMayContactVet: boolean | null, practiceLocation: { __typename: 'LocationDetailsType', name: string, placeId: string, formattedAddress: string } | null } | null } };

export type PetVeterinaryInformationFragment = { __typename: 'Pet', petNum: number, id: string, embarkMayContactVet: boolean | null, practiceLocation: { __typename: 'LocationDetailsType', name: string, placeId: string, formattedAddress: string } | null };

export type UpdateVetPracticeDetailsMutationVariables = Exact<{
  vetPracticeDetails: VetPracticeDetailsInput;
}>;


export type UpdateVetPracticeDetailsMutation = { __typename: 'Mutation', pet: { __typename: 'PetMutation', updateVetPracticeDetails: void | null } };

export type GetPetForShareResultsWithVetQueryVariables = Exact<{
  petNum: Scalars['Int'];
}>;


export type GetPetForShareResultsWithVetQuery = { __typename: 'Query', me: { __typename: 'User', id: string, petByPetNum: { __typename: 'Pet', id: string, hashPetId: string, name: string } | null } };

export type GetAllBreedsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllBreedsQuery = { __typename: 'Query', allBreeds: Array<{ __typename: 'Breed', displayName: string, ancestryLabel: string }>, identifiableBreeds: Array<{ __typename: 'Breed', displayName: string, ancestryLabel: string }>, designerBreeds: Array<{ __typename: 'Breed', displayName: string, ancestryLabel: string }> };

export type BreedHaloFragment = { __typename: 'Pet', name: string, profileImageUrl: string | null, avatarColorIndex: number, swabSummary: { __typename: 'SwabSummary', id: string, productType: ProductType | null }, ancestry: { __typename: 'Ancestry', breeds: Array<{ __typename: 'AncestryBreed', index: number | null, percentage: number | null, ancestryLabel: string | null } | null> | null } | null };

export type LegacyBreedHaloFragment = { __typename: 'Pet', name: string, profileImageUrl: string | null, avatarColorIndex: number, swabSummary: { __typename: 'SwabSummary', id: string, productType: ProductType | null }, genotype: { __typename: 'Genotype', id: string, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedPct: number }> } | null };

export type FeedbackFragment = { __typename: 'Pet', id: string };

export type AddFeedbackMutationVariables = Exact<{
  feedback: FeedbackInput;
}>;


export type AddFeedbackMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', addFeedback: void | null } };

export type ShowFeedbackQueryVariables = Exact<{
  page: Scalars['String'];
  variant: InputMaybe<Scalars['String']>;
  petUuid: InputMaybe<Scalars['String']>;
}>;


export type ShowFeedbackQuery = { __typename: 'Query', me: { __typename: 'User', id: string, shouldShowFeedback: boolean } };

export type FooterUserFragment = { __typename: 'User', id: string, petCount: number, countryCode: string, userType: UserTypeGraphQl, shopLink: string, ecommLink: string, permissions: { __typename: 'UserPermissions', showMatchMaker: boolean } };

export type FooterPetFragment = { __typename: 'Pet', id: string, displayName: string | null, isEligibleForInsurance: boolean, insuranceUrl: string, petNum: number, name: string, handle: string, profileImageUrl: string | null, avatarColorIndex: number, hasSwab: boolean, isHealthReady: boolean, isNonhealthReady: boolean, showTraits: boolean, showRelativeFinder: boolean, isUpgradeAvailable: boolean, swabSummary: { __typename: 'SwabSummary', id: string, swabState: SwabState, productType: ProductType | null, productPurchaseSource: string | null, activatedDate: string | null, healthResultsReleasedDate: string | null, breedResultsReleasedDate: string | null, comprehensiveUpgradePurchasedDate: string | null }, genotype: { __typename: 'Genotype', id: string, breedType: string | null, breed1name: string | null, breed1pct: number | null } | null };

export type GetFooterDataQueryVariables = Exact<{
  petNum: Scalars['Int'];
  shouldLoadPet: Scalars['Boolean'];
}>;


export type GetFooterDataQuery = { __typename: 'Query', me: { __typename: 'User', id: string, petCount: number, countryCode: string, userType: UserTypeGraphQl, shopLink: string, ecommLink: string, petByPetNum?: { __typename: 'Pet', id: string, displayName: string | null, isEligibleForInsurance: boolean, insuranceUrl: string, petNum: number, name: string, handle: string, profileImageUrl: string | null, avatarColorIndex: number, hasSwab: boolean, isHealthReady: boolean, isNonhealthReady: boolean, showTraits: boolean, showRelativeFinder: boolean, isUpgradeAvailable: boolean, swabSummary: { __typename: 'SwabSummary', id: string, swabState: SwabState, productType: ProductType | null, productPurchaseSource: string | null, activatedDate: string | null, healthResultsReleasedDate: string | null, breedResultsReleasedDate: string | null, comprehensiveUpgradePurchasedDate: string | null }, genotype: { __typename: 'Genotype', id: string, breedType: string | null, breed1name: string | null, breed1pct: number | null } | null } | null, permissions: { __typename: 'UserPermissions', showMatchMaker: boolean } } };

export type GeneticStatsSectionFragment = { __typename: 'Pet', name: string, petNum: number, sex: Sex, lifeStage: PetLifeStage | null, dateOfBirth: string | null, isDateOfBirthEstimated: boolean | null, shouldShowAgeTestRecommendation: boolean, showTraits: boolean, ageTest: { __typename: 'AgeTestSummary', status: AgeTestStatus, releasedResult: { __typename: 'ReleasedResult', resultsUuid: string, isAccurate: boolean | null, predictedBirthday: string, isUserFeedbackCollected: boolean } | null } | null, genotype: { __typename: 'Genotype', predictedWeight: number | null, wolfiness: number | null, wolfinessContext: string | null } | null };

export type GeneticStatsLifeStageFragment = { __typename: 'Pet', name: string, petNum: number, sex: Sex, lifeStage: PetLifeStage | null, dateOfBirth: string | null, isDateOfBirthEstimated: boolean | null, shouldShowAgeTestRecommendation: boolean, showTraits: boolean, ageTest: { __typename: 'AgeTestSummary', status: AgeTestStatus, releasedResult: { __typename: 'ReleasedResult', resultsUuid: string, isAccurate: boolean | null, predictedBirthday: string, isUserFeedbackCollected: boolean } | null } | null };

export type GeneticStatsPredictedAdultWeightFragment = { __typename: 'Pet', genotype: { __typename: 'Genotype', predictedWeight: number | null } | null };

export type GeneticStatsWolfinessFragment = { __typename: 'Pet', genotype: { __typename: 'Genotype', wolfiness: number | null, wolfinessContext: string | null } | null };

export type BreedsFragment = { __typename: 'Pet', ancestry: { __typename: 'Ancestry', breeds: Array<{ __typename: 'AncestryBreed', index: number | null, percentage: number | null, ancestryLabel: string | null } | null> | null } | null, swabSummary: { __typename: 'SwabSummary', productType: ProductType | null } };

export type ReplayBreedRevealBannerFragment = { __typename: 'Pet', id: string, name: string, petNum: number };

export type PetResultsNavFragment = { __typename: 'Pet', id: string, petNum: number, name: string, handle: string, profileImageUrl: string | null, avatarColorIndex: number, hasSwab: boolean, isHealthReady: boolean, isNonhealthReady: boolean, showTraits: boolean, showRelativeFinder: boolean, isUpgradeAvailable: boolean, swabSummary: { __typename: 'SwabSummary', id: string, swabState: SwabState, productType: ProductType | null, productPurchaseSource: string | null, activatedDate: string | null, healthResultsReleasedDate: string | null, breedResultsReleasedDate: string | null, comprehensiveUpgradePurchasedDate: string | null }, genotype: { __typename: 'Genotype', id: string, breedType: string | null, breed1name: string | null, breed1pct: number | null } | null };

export type ShareButtonFragment = { __typename: 'ShareOptions', copyLinkUrl: string, downloadUrl: string | null, emailMailTo: string, facebookUrl: string, shareItemId: string | null };

export type ProfileDataSettingsCardUserFragment = { __typename: 'User', ecommLink: string };

export type ProfileDataSettingsCardFragment = { __typename: 'Pet', petNum: number };

export type UpdateProfileDataSettingsMutationVariables = Exact<{
  petNum: Scalars['Int'];
  preferences: PetPreferencesInput;
}>;


export type UpdateProfileDataSettingsMutation = { __typename: 'Mutation', pet: { __typename: 'PetMutation', updatePetPreferences: { __typename: 'Pet', id: string, preferences: { __typename: 'PetPreferences', shareCareResourcesSurveys: boolean, shareCareResourcesProfileAndResults: boolean } } } };

export type PublicProfileBreedSummaryBarsFragment = { __typename: 'Pet', swabSummary: { __typename: 'SwabSummary', id: string, productType: ProductType | null }, genotype: { __typename: 'Genotype', id: string, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedName: string, displayBreedPercent: string, colorIndex: number, barWidthPercentage: number }> } | null };

export type PublicProfileBreedSummaryCardFragment = { __typename: 'Pet', name: string, petNum: number, handle: string, profileImageUrl: string | null, avatarColorIndex: number, genotype: { __typename: 'Genotype', id: string, breedType: string | null, breedMix: Array<{ __typename: 'GenotypeBreedMix', breedName: string, displayBreedPercent: string, colorIndex: number, barWidthPercentage: number, breedPct: number }> } | null, swabSummary: { __typename: 'SwabSummary', id: string, productType: ProductType | null } };

export type PetTrackingFragment = { __typename: 'Pet', petNum: number, swabSummary: { __typename: 'SwabSummary', id: string, swabState: SwabState, productType: ProductType | null, productPurchaseSource: string | null, activatedDate: string | null, healthResultsReleasedDate: string | null, breedResultsReleasedDate: string | null, comprehensiveUpgradePurchasedDate: string | null }, genotype: { __typename: 'Genotype', id: string, breedType: string | null, breed1name: string | null, breed1pct: number | null } | null };

export type ShareResultsWithVetFragment = { __typename: 'Pet', id: string, hashPetId: string, name: string };

export type ShareResultsWithVetMutationVariables = Exact<{
  shareResultsWithVetInput: ShareResultsWithVetInput;
}>;


export type ShareResultsWithVetMutation = { __typename: 'Mutation', pet: { __typename: 'PetMutation', shareResultsWithVet: void | null } };

export const BreederAllBreedsFragmentDoc = gql`
    fragment BreederAllBreedsFragment on Breed {
  displayName
  ancestryLabel
}
    `;
export const CreateEditQualtricsCategoryBodyFragmentDoc = gql`
    fragment createEditQualtricsCategoryBodyFragment on SurveyCategory {
  id
  category
  subtitle
  priority
}
    `;
export const CreateEditQualtricsSurveyBodyFragmentDoc = gql`
    fragment createEditQualtricsSurveyBodyFragment on Survey {
  id
  slug
  templateId
  category {
    id
    category
    subtitle
  }
  subtitle
  icon
  title
  color
  priority
  isTargeted
  isAdminOnly
  isShownOnResearchPage
}
    `;
export const HealthResultFieldsFragmentDoc = gql`
    fragment healthResultFields on PairPredictorHealthPrediction {
  healthId
  disorderName
  subdisorderName
  gene
  description
  bodySystem
  modeOfInheritance
  sireVariantsDetected
  damVariantsDetected
  sireHealthStateCategory
  damHealthStateCategory
  identifiedInText
  litterZeroCopiesPercent
  litterOneCopyPercent
  litterTwoCopiesPercent
  pairPredictorCategory
}
    `;
export const PetTrackingFragmentDoc = gql`
    fragment PetTrackingFragment on Pet {
  petNum
  swabSummary {
    id
    swabState
    productType
    productPurchaseSource
    activatedDate
    healthResultsReleasedDate
    breedResultsReleasedDate
    comprehensiveUpgradePurchasedDate
  }
  genotype {
    id
    breedType
    breed1name
    breed1pct
  }
}
    `;
export const PetResultsNavFragmentDoc = gql`
    fragment PetResultsNavFragment on Pet {
  id
  petNum
  name
  handle
  profileImageUrl
  avatarColorIndex
  hasSwab
  isHealthReady
  isNonhealthReady
  showTraits
  showRelativeFinder
  isUpgradeAvailable
  ...PetTrackingFragment
}
    ${PetTrackingFragmentDoc}`;
export const FooterPetFragmentDoc = gql`
    fragment FooterPetFragment on Pet {
  id
  displayName
  isEligibleForInsurance
  insuranceUrl
  ...PetResultsNavFragment
}
    ${PetResultsNavFragmentDoc}`;
export const PetResultsSubPagePetFragmentDoc = gql`
    fragment PetResultsSubPagePetFragment on Pet {
  ...FooterPetFragment
  ...PetResultsNavFragment
}
    ${FooterPetFragmentDoc}
${PetResultsNavFragmentDoc}`;
export const FooterUserFragmentDoc = gql`
    fragment FooterUserFragment on User {
  id
  petCount
  countryCode
  userType
  shopLink
  ecommLink
  permissions {
    showMatchMaker
  }
}
    `;
export const PetResultsSubPageUserFragmentDoc = gql`
    fragment PetResultsSubPageUserFragment on User {
  ...FooterUserFragment
}
    ${FooterUserFragmentDoc}`;
export const SurveyCardFragmentDoc = gql`
    fragment SurveyCardFragment on PetSurveyInfo {
  id
  surveyUrl
  survey {
    id
    slug
    title
    subtitle
    icon
    color
  }
}
    `;
export const SurveyCategorySectionFragmentDoc = gql`
    fragment SurveyCategorySectionFragment on Pet {
  surveys {
    id
    survey {
      id
      slug
      category {
        id
        category
        subtitle
        priority
      }
      isShownOnResearchPage
    }
    ...SurveyCardFragment
  }
}
    ${SurveyCardFragmentDoc}`;
export const ResearchPagePetFragmentDoc = gql`
    fragment ResearchPagePetFragment on Pet {
  id
  petNum
  displayName
  name
  hasSwab
  hasActivatedProducts
  ...SurveyCategorySectionFragment
}
    ${SurveyCategorySectionFragmentDoc}`;
export const ResearchPageContainerPetFragmentDoc = gql`
    fragment ResearchPageContainerPetFragment on Pet {
  id
  name
  petNum
  ...ResearchPagePetFragment
}
    ${ResearchPagePetFragmentDoc}`;
export const BreedsFragmentDoc = gql`
    fragment BreedsFragment on Pet {
  ancestry {
    breeds {
      index
      percentage
      ancestryLabel
    }
  }
  swabSummary {
    productType
  }
}
    `;
export const BreedHaloFragmentDoc = gql`
    fragment BreedHaloFragment on Pet {
  name
  profileImageUrl
  avatarColorIndex
  swabSummary {
    id
    productType
  }
  ancestry {
    breeds {
      index
      percentage
    }
  }
  ...BreedsFragment
}
    ${BreedsFragmentDoc}`;
export const HealthPageResultFragmentDoc = gql`
    fragment HealthPageResultFragment on HealthResult {
  id
  isPawsitResult
  name
  isBreedRelevant
  severity
  resultText
  identifiedInText
  isBeta
  subdisorderName
}
    `;
export const RecommendationCardFragmentDoc = gql`
    fragment RecommendationCardFragment on Pet {
  petNum
  name
  sex
  isEligibleForInsurance
  hasResults
  insuranceUrl
  shouldShowFoodRecommendation
  shouldShowAgeTestRecommendation
  shouldShowGenotypeTestRecommendation
  genotypeTestProductState
  ageTestProductState
  microbiomeTestProductState
}
    `;
export const ShareResultsWithVetFragmentDoc = gql`
    fragment ShareResultsWithVetFragment on Pet {
  id
  hashPetId
  name
}
    `;
export const HealthPagePetFragmentDoc = gql`
    fragment HealthPagePetFragment on Pet {
  id
  name
  handle
  isNonhealthReady
  health {
    results {
      ...HealthPageResultFragment
    }
  }
  traits {
    id
    roundedCoiPercent
  }
  swabSummary {
    swabCode
  }
  showOfaReport
  isEligibleForMatchmaker
  ...BreedHaloFragment
  ...RecommendationCardFragment
  ...ShareResultsWithVetFragment
}
    ${HealthPageResultFragmentDoc}
${BreedHaloFragmentDoc}
${RecommendationCardFragmentDoc}
${ShareResultsWithVetFragmentDoc}`;
export const TraitsPagePetFragmentDoc = gql`
    fragment TraitsPagePetFragment on Pet {
  id
  name
  handle
  petNum
  genotype {
    predictedWeight
  }
  healthResultsState
  isNonhealthReady
  traits {
    traitsCategory {
      name
      description
      order
      traits {
        additionalInfo
        description
        isAmbiguous
        isLinkageTest
        moreInformationUrl
        name
        order
        result
        showLinkageTestExplanation
        sublabel
        subloci {
          name
          result
        }
        gene {
          name
          result
        }
        citations {
          text
          url
        }
      }
    }
  }
  ...BreedHaloFragment
  ...HealthPagePetFragment
}
    ${BreedHaloFragmentDoc}
${HealthPagePetFragmentDoc}`;
export const TraitsPageUserFragmentDoc = gql`
    fragment TraitsPageUserFragment on User {
  petCount
}
    `;
export const ShareButtonFragmentDoc = gql`
    fragment ShareButtonFragment on ShareOptions {
  copyLinkUrl
  downloadUrl
  emailMailTo
  facebookUrl
  shareItemId
}
    `;
export const GenotypeTestSwabDetailFragmentDoc = gql`
    fragment GenotypeTestSwabDetailFragment on Pet {
  name
  petNum
  swabSummary {
    productType
    sampleState
  }
}
    `;
export const GenotypeTestProductCardFragmentDoc = gql`
    fragment GenotypeTestProductCardFragment on Pet {
  sex
  petNum
  id
  hasSwab
  shareOptions {
    ...ShareButtonFragment
  }
  swabSummary {
    breedResultsReleasedDate
    healthResultsReleasedDate
    productType
    sampleState
  }
  ...GenotypeTestSwabDetailFragment
}
    ${ShareButtonFragmentDoc}
${GenotypeTestSwabDetailFragmentDoc}`;
export const LegacyBreedHaloFragmentDoc = gql`
    fragment LegacyBreedHaloFragment on Pet {
  name
  profileImageUrl
  avatarColorIndex
  swabSummary {
    id
    productType
  }
  genotype {
    id
    breedMix {
      breedPct
    }
  }
}
    `;
export const AgeTestProductCardFragmentDoc = gql`
    fragment AgeTestProductCardFragment on Pet {
  id
  petNum
  name
  isPartOfAgeTestStudy
  ageTest {
    status
    releasedResult {
      resultsUuid
    }
  }
}
    `;
export const ProductCardFragmentDoc = gql`
    fragment ProductCardFragment on Pet {
  name
  profileImageUrl
  avatarColorIndex
}
    `;
export const MicrobiomeSummaryCardFragmentDoc = gql`
    fragment MicrobiomeSummaryCardFragment on Pet {
  id
  ...ProductCardFragment
  microbiomeTests {
    createdAt
    testType
    state
    reportUrl
    resultsReleasedAt
  }
}
    ${ProductCardFragmentDoc}`;
export const PetCardFragmentDoc = gql`
    fragment PetCardFragment on Pet {
  name
  id
  petNum
  hasSwab
  ...GenotypeTestProductCardFragment
  ...LegacyBreedHaloFragment
  ...AgeTestProductCardFragment
  ...MicrobiomeSummaryCardFragment
}
    ${GenotypeTestProductCardFragmentDoc}
${LegacyBreedHaloFragmentDoc}
${AgeTestProductCardFragmentDoc}
${MicrobiomeSummaryCardFragmentDoc}`;
export const PetParentDashboardPetFragmentDoc = gql`
    fragment PetParentDashboardPetFragment on Pet {
  id
  name
  petNum
  isPartOfAgeTestStudy
  ...PetCardFragment
  cursor
}
    ${PetCardFragmentDoc}`;
export const PetParentDashboardContainerFragmentDoc = gql`
    fragment PetParentDashboardContainerFragment on User {
  id
  petCount
  hiddenPetCount: petCount(filters: {isHidden: true})
  pets(pagination: $pagination, filters: $filters) {
    ...PetParentDashboardPetFragment
  }
}
    ${PetParentDashboardPetFragmentDoc}`;
export const HealthConditionDetailsFragmentDoc = gql`
    fragment HealthConditionDetailsFragment on HealthConditionDetails {
  healthId
  topBreedsAffected {
    name
    ancestryLabel
    proportionDetected
    image
  }
}
    `;
export const HealthConditionPagePetFragmentDoc = gql`
    fragment HealthConditionPagePetFragment on Pet {
  petNum
  name
  sex
  ...BreedHaloFragment
  ...ShareResultsWithVetFragment
}
    ${BreedHaloFragmentDoc}
${ShareResultsWithVetFragmentDoc}`;
export const MonogenicConditionPageFragmentDoc = gql`
    fragment MonogenicConditionPageFragment on HealthResult {
  id
  name
  scientificName
  severity
  description
  additionalDescription
  actions
  signs
  signsDevelop
  diagnosis
  risk
  explanation
  scientificBasis
  breedingImpact
  treatment
  references {
    url
    text
  }
  numberOfVariants
  gene
  moi
  isLinkageTest
  isProvisional
  variants
  isClinicalTool
  isXLinked
  subdisorderName
}
    `;
export const PolygenicConditionPageFragmentDoc = gql`
    fragment PolygenicConditionPageFragment on HealthResult {
  name
  id
  severity
  shortDescription
  detailedDescriptions
  conditionClinicalSigns
  conditionClinicalWarningSigns
  diagnosisDescriptions
  surveyContents
  treatmentRecommendations
  riskChanceDescriptions
  riskFactorDescriptions
  riskExplainerDescriptions
  scienceBodyLink {
    url
    text
  }
  identifiedInText
  references {
    url
    text
  }
  probability
  inapplicabilityReason
}
    `;
export const NutritionPageFragmentDoc = gql`
    fragment NutritionPageFragment on Pet {
  id
  petNum
  name
  sex
  dateOfBirth
  isDateOfBirthEstimated
  ...BreedHaloFragment
}
    ${BreedHaloFragmentDoc}`;
export const NutritionPageUserFragmentDoc = gql`
    fragment NutritionPageUserFragment on User {
  userGroup
}
    `;
export const HealthSummaryCardFragmentDoc = gql`
    fragment HealthSummaryCardFragment on Pet {
  name
  isHealthReady
  petNum
  ...HealthPagePetFragment
}
    ${HealthPagePetFragmentDoc}`;
export const DownloadCardFragmentDoc = gql`
    fragment DownloadCardFragment on Pet {
  hashPetId
  petNum
  isPrimaryOwnerBreeder
  showOfaReport
}
    `;
export const AgeTestSwabTrackerFragmentDoc = gql`
    fragment AgeTestSwabTrackerFragment on Pet {
  name
  petNum
  sex
  ageTest {
    status
  }
}
    `;
export const AgeTestSummaryCardFragmentDoc = gql`
    fragment AgeTestSummaryCardFragment on Pet {
  id
  petNum
  isPartOfAgeTestStudy
  ageTest {
    status
    activatedAt
    releasedResult {
      resultsUuid
      predictedBirthday
    }
  }
  ...ProductCardFragment
  ...AgeTestSwabTrackerFragment
}
    ${ProductCardFragmentDoc}
${AgeTestSwabTrackerFragmentDoc}`;
export const GenotypeSwabTrackerFragmentDoc = gql`
    fragment GenotypeSwabTrackerFragment on Pet {
  name
  petNum
  swabSummary {
    productType
    sampleState
  }
}
    `;
export const SummaryPageGenotypeCardFragmentDoc = gql`
    fragment SummaryPageGenotypeCardFragment on Pet {
  name
  handle
  petNum
  hasSwab
  isUpgradeAvailable
  swabSummary {
    activatedDate
    productType
    swabCode
  }
  ...BreedHaloFragment
  ...GenotypeSwabTrackerFragment
}
    ${BreedHaloFragmentDoc}
${GenotypeSwabTrackerFragmentDoc}`;
export const AncestryFragmentDoc = gql`
    fragment AncestryFragment on Ancestry {
  breeds {
    ancestryLabel
    name
    image
    displayPercentage
    percentage
    index
  }
  traceBreeds {
    percentage
    breeds {
      name
      ancestryLabel
      image
    }
  }
  breedMixScenario
  breedMixName
  similarPets {
    handle
    image
    likenessPercentage
    name
  }
  familyTree {
    parents {
      position
      ancestryLabel
      displayName
      breedImage
    }
    grandParents {
      position
      ancestryLabel
      displayName
      breedImage
    }
    greatGrandParents {
      position
      ancestryLabel
      displayName
      breedImage
    }
  }
  haplotype {
    yHaplotype {
      map
      label
      description
    }
    yHaplogroup {
      map
      label
      description
    }
    mtHaplotype {
      map
      label
      description
    }
    mtHaplogroup {
      map
      label
      description
    }
  }
}
    `;
export const RegisteredBreedAccordionFragmentDoc = gql`
    fragment RegisteredBreedAccordionFragment on Pet {
  petNum
  profile {
    breed
    primaryBreedRegistrationOrganizationAcronym
    primaryBreedRegistrationOrganizationName
    primaryBreedRegistrationNumber
  }
}
    `;
export const BreedAndAncestryPageFragmentDoc = gql`
    fragment BreedAndAncestryPageFragment on Pet {
  id
  name
  handle
  petNum
  sex
  profileImageUrl
  ancestryResultsState
  isPrimaryOwnerBreeder
  swabSummary {
    swabCode
    productType
  }
  ancestry {
    breeds {
      ancestryLabel
    }
    traceBreeds {
      percentage
      breeds {
        name
        ancestryLabel
        image
      }
    }
    breedMixScenario
    breedMixName
    similarPets {
      handle
      image
      likenessPercentage
      name
    }
    ...AncestryFragment
  }
  shareOptions {
    ...ShareButtonFragment
  }
  ...BreedHaloFragment
  ...RegisteredBreedAccordionFragment
  ...BreedsFragment
}
    ${AncestryFragmentDoc}
${ShareButtonFragmentDoc}
${BreedHaloFragmentDoc}
${RegisteredBreedAccordionFragmentDoc}
${BreedsFragmentDoc}`;
export const SummaryPagePetFragmentDoc = gql`
    fragment SummaryPagePetFragment on Pet {
  id
  name
  petNum
  hasActivatedProducts
  genotypeTestProductState
  ...HealthSummaryCardFragment
  ...PetResultsNavFragment
  ...PetCardFragment
  ...DownloadCardFragment
  ...RecommendationCardFragment
  ...AgeTestSummaryCardFragment
  ...MicrobiomeSummaryCardFragment
  ...SummaryPageGenotypeCardFragment
  ...BreedAndAncestryPageFragment
}
    ${HealthSummaryCardFragmentDoc}
${PetResultsNavFragmentDoc}
${PetCardFragmentDoc}
${DownloadCardFragmentDoc}
${RecommendationCardFragmentDoc}
${AgeTestSummaryCardFragmentDoc}
${MicrobiomeSummaryCardFragmentDoc}
${SummaryPageGenotypeCardFragmentDoc}
${BreedAndAncestryPageFragmentDoc}`;
export const BreedAndAncestryPageUserFragmentDoc = gql`
    fragment BreedAndAncestryPageUserFragment on User {
  petCount
}
    `;
export const SummaryPageUserFragmentDoc = gql`
    fragment SummaryPageUserFragment on User {
  ...BreedAndAncestryPageUserFragment
}
    ${BreedAndAncestryPageUserFragmentDoc}`;
export const EmailPreferencesFragmentDoc = gql`
    fragment EmailPreferencesFragment on EmailPreferences {
  isChatEnabled
  isDogsLikeMineEnabled
  isRelativeFinderEnabled
  isCareResourcesEnabled
  isResearchSurveysEnabled
  isNewslettersEnabled
  isPromotionsAndSalesEnabled
  isProductUpdatesEnabled
  isBreederNewslettersEnabled
  isBreederPromotionsAndSalesEnabled
  isBreederEventsEnabled
  isVetNewslettersEnabled
  isVetBusinessCommunicationsEnabled
  isVetEventsEnabled
}
    `;
export const EmailPreferencesUserFragmentDoc = gql`
    fragment EmailPreferencesUserFragment on User {
  emailPreferences {
    ...EmailPreferencesFragment
  }
}
    ${EmailPreferencesFragmentDoc}`;
export const ClientDetailsModalButtonFragmentDoc = gql`
    fragment ClientDetailsModalButtonFragment on Pet {
  id
  name
  sex
  intact
  dateOfBirth
  petNum
  handle
  vetPracticeInfo {
    clientEmail
    clientName
    clientPhone
    patientEMRId
  }
}
    `;
export const PracticePetCardFragmentDoc = gql`
    fragment PracticePetCardFragment on Pet {
  id
  name
  handle
  petNum
  profileImageUrl
  cursor
  swabSummary {
    vetSummary {
      swabState
      header
      subheader
    }
  }
  vetPracticeInfo {
    clientName
    clientEmail
    patientEMRId
    reportUrl
    swabOrderedBy {
      name
      isDVM
      id
    }
    vetClientTransfer {
      completedAt
      recipientEmail
      recipientName
      requestedAt
      requestedByName
      requesterIsDVM
    }
    patientNotes {
      createdAt
      content
      id
    }
    caseCompleted
    isVetAffiliate
  }
  genotype {
    breedType
    shouldShowVetBreedCount
    breedMix {
      breedName
      breedPct
      displayBreedPercent
    }
  }
  health {
    increasedRiskCount
    notableVariantCount
    allClearCount
  }
  ageTest {
    activatedAt
  }
  ...ClientDetailsModalButtonFragment
}
    ${ClientDetailsModalButtonFragmentDoc}`;
export const ListPracticePetFragmentDoc = gql`
    fragment ListPracticePetFragment on Pet {
  dateAdded
  ...PracticePetCardFragment
}
    ${PracticePetCardFragmentDoc}`;
export const OnboardingChecklistStatusFragmentDoc = gql`
    fragment OnboardingChecklistStatusFragment on OnboardingChecklistStatus {
  placeFirstOrder
  testFirstPatient
  receiveFirstResults
  assignStaffChampion
  talkAboutGeneticTesting
  learnToUseDashboard
  connectWithSuccessManager
}
    `;
export const PetLocationInformationFragmentDoc = gql`
    fragment PetLocationInformation on Pet {
  petNum
  id
  locations {
    born {
      addressInput
    }
    from {
      addressInput
    }
    live {
      addressInput
    }
  }
}
    `;
export const PetVeterinaryInformationFragmentDoc = gql`
    fragment PetVeterinaryInformation on Pet {
  petNum
  id
  embarkMayContactVet
  practiceLocation {
    name
    placeId
    formattedAddress
  }
}
    `;
export const FeedbackFragmentDoc = gql`
    fragment FeedbackFragment on Pet {
  id
}
    `;
export const GeneticStatsLifeStageFragmentDoc = gql`
    fragment GeneticStatsLifeStageFragment on Pet {
  name
  petNum
  name
  sex
  lifeStage
  dateOfBirth
  isDateOfBirthEstimated
  shouldShowAgeTestRecommendation
  showTraits
  ageTest {
    status
    releasedResult {
      resultsUuid
      isAccurate
      predictedBirthday
      isUserFeedbackCollected
    }
  }
}
    `;
export const GeneticStatsPredictedAdultWeightFragmentDoc = gql`
    fragment GeneticStatsPredictedAdultWeightFragment on Pet {
  genotype {
    predictedWeight
  }
}
    `;
export const GeneticStatsWolfinessFragmentDoc = gql`
    fragment GeneticStatsWolfinessFragment on Pet {
  genotype {
    wolfiness
    wolfinessContext
  }
}
    `;
export const GeneticStatsSectionFragmentDoc = gql`
    fragment GeneticStatsSectionFragment on Pet {
  name
  ...GeneticStatsLifeStageFragment
  ...GeneticStatsPredictedAdultWeightFragment
  ...GeneticStatsWolfinessFragment
}
    ${GeneticStatsLifeStageFragmentDoc}
${GeneticStatsPredictedAdultWeightFragmentDoc}
${GeneticStatsWolfinessFragmentDoc}`;
export const ReplayBreedRevealBannerFragmentDoc = gql`
    fragment ReplayBreedRevealBannerFragment on Pet {
  id
  name
  petNum
}
    `;
export const ProfileDataSettingsCardUserFragmentDoc = gql`
    fragment ProfileDataSettingsCardUserFragment on User {
  ecommLink
}
    `;
export const ProfileDataSettingsCardFragmentDoc = gql`
    fragment ProfileDataSettingsCardFragment on Pet {
  petNum
}
    `;
export const PublicProfileBreedSummaryBarsFragmentDoc = gql`
    fragment PublicProfileBreedSummaryBarsFragment on Pet {
  swabSummary {
    id
    productType
  }
  genotype {
    id
    breedMix {
      breedName
      displayBreedPercent
      colorIndex
      barWidthPercentage
    }
  }
}
    `;
export const PublicProfileBreedSummaryCardFragmentDoc = gql`
    fragment PublicProfileBreedSummaryCardFragment on Pet {
  name
  petNum
  handle
  genotype {
    id
    breedType
  }
  ...PublicProfileBreedSummaryBarsFragment
  ...LegacyBreedHaloFragment
}
    ${PublicProfileBreedSummaryBarsFragmentDoc}
${LegacyBreedHaloFragmentDoc}`;
export const GetBreedersBreedsDocument = gql`
    query GetBreedersBreeds {
  allBreeds {
    ...BreederAllBreedsFragment
  }
  me {
    breederProfile {
      breedAncestryLabels
    }
  }
}
    ${BreederAllBreedsFragmentDoc}`;

/**
 * __useGetBreedersBreedsQuery__
 *
 * To run a query within a React component, call `useGetBreedersBreedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBreedersBreedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBreedersBreedsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBreedersBreedsQuery(baseOptions?: Apollo.QueryHookOptions<GetBreedersBreedsQuery, GetBreedersBreedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBreedersBreedsQuery, GetBreedersBreedsQueryVariables>(GetBreedersBreedsDocument, options);
      }
export function useGetBreedersBreedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBreedersBreedsQuery, GetBreedersBreedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBreedersBreedsQuery, GetBreedersBreedsQueryVariables>(GetBreedersBreedsDocument, options);
        }
export type GetBreedersBreedsQueryHookResult = ReturnType<typeof useGetBreedersBreedsQuery>;
export type GetBreedersBreedsLazyQueryHookResult = ReturnType<typeof useGetBreedersBreedsLazyQuery>;
export type GetBreedersBreedsQueryResult = Apollo.QueryResult<GetBreedersBreedsQuery, GetBreedersBreedsQueryVariables>;
export const GetAllRegistrationOrganizationsDocument = gql`
    query GetAllRegistrationOrganizations {
  allRegistrationOrganizations {
    id
    name
    acronym
    registryType
  }
}
    `;

/**
 * __useGetAllRegistrationOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetAllRegistrationOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRegistrationOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRegistrationOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRegistrationOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRegistrationOrganizationsQuery, GetAllRegistrationOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRegistrationOrganizationsQuery, GetAllRegistrationOrganizationsQueryVariables>(GetAllRegistrationOrganizationsDocument, options);
      }
export function useGetAllRegistrationOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRegistrationOrganizationsQuery, GetAllRegistrationOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRegistrationOrganizationsQuery, GetAllRegistrationOrganizationsQueryVariables>(GetAllRegistrationOrganizationsDocument, options);
        }
export type GetAllRegistrationOrganizationsQueryHookResult = ReturnType<typeof useGetAllRegistrationOrganizationsQuery>;
export type GetAllRegistrationOrganizationsLazyQueryHookResult = ReturnType<typeof useGetAllRegistrationOrganizationsLazyQuery>;
export type GetAllRegistrationOrganizationsQueryResult = Apollo.QueryResult<GetAllRegistrationOrganizationsQuery, GetAllRegistrationOrganizationsQueryVariables>;
export const GetRoundDogFaceImageUrlDocument = gql`
    query GetRoundDogFaceImageUrl($publicId: String!) {
  cloudinary(publicId: $publicId) {
    roundDogFaceImageUrl
  }
}
    `;

/**
 * __useGetRoundDogFaceImageUrlQuery__
 *
 * To run a query within a React component, call `useGetRoundDogFaceImageUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoundDogFaceImageUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoundDogFaceImageUrlQuery({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useGetRoundDogFaceImageUrlQuery(baseOptions: Apollo.QueryHookOptions<GetRoundDogFaceImageUrlQuery, GetRoundDogFaceImageUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoundDogFaceImageUrlQuery, GetRoundDogFaceImageUrlQueryVariables>(GetRoundDogFaceImageUrlDocument, options);
      }
export function useGetRoundDogFaceImageUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoundDogFaceImageUrlQuery, GetRoundDogFaceImageUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoundDogFaceImageUrlQuery, GetRoundDogFaceImageUrlQueryVariables>(GetRoundDogFaceImageUrlDocument, options);
        }
export type GetRoundDogFaceImageUrlQueryHookResult = ReturnType<typeof useGetRoundDogFaceImageUrlQuery>;
export type GetRoundDogFaceImageUrlLazyQueryHookResult = ReturnType<typeof useGetRoundDogFaceImageUrlLazyQuery>;
export type GetRoundDogFaceImageUrlQueryResult = Apollo.QueryResult<GetRoundDogFaceImageUrlQuery, GetRoundDogFaceImageUrlQueryVariables>;
export const AddNewPetDocument = gql`
    mutation AddNewPet($pet: PetInput!) {
  pet {
    addNewPet(pet: $pet) {
      petNum
    }
  }
}
    `;
export type AddNewPetMutationFn = Apollo.MutationFunction<AddNewPetMutation, AddNewPetMutationVariables>;

/**
 * __useAddNewPetMutation__
 *
 * To run a mutation, you first call `useAddNewPetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewPetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewPetMutation, { data, loading, error }] = useAddNewPetMutation({
 *   variables: {
 *      pet: // value for 'pet'
 *   },
 * });
 */
export function useAddNewPetMutation(baseOptions?: Apollo.MutationHookOptions<AddNewPetMutation, AddNewPetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewPetMutation, AddNewPetMutationVariables>(AddNewPetDocument, options);
      }
export type AddNewPetMutationHookResult = ReturnType<typeof useAddNewPetMutation>;
export type AddNewPetMutationResult = Apollo.MutationResult<AddNewPetMutation>;
export type AddNewPetMutationOptions = Apollo.BaseMutationOptions<AddNewPetMutation, AddNewPetMutationVariables>;
export const GetAllSurveysDocument = gql`
    query GetAllSurveys {
  admin {
    getAllSurveys {
      ...createEditQualtricsSurveyBodyFragment
    }
    getAllSurveyCategories {
      ...createEditQualtricsCategoryBodyFragment
    }
  }
}
    ${CreateEditQualtricsSurveyBodyFragmentDoc}
${CreateEditQualtricsCategoryBodyFragmentDoc}`;

/**
 * __useGetAllSurveysQuery__
 *
 * To run a query within a React component, call `useGetAllSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSurveysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSurveysQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSurveysQuery, GetAllSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSurveysQuery, GetAllSurveysQueryVariables>(GetAllSurveysDocument, options);
      }
export function useGetAllSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSurveysQuery, GetAllSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSurveysQuery, GetAllSurveysQueryVariables>(GetAllSurveysDocument, options);
        }
export type GetAllSurveysQueryHookResult = ReturnType<typeof useGetAllSurveysQuery>;
export type GetAllSurveysLazyQueryHookResult = ReturnType<typeof useGetAllSurveysLazyQuery>;
export type GetAllSurveysQueryResult = Apollo.QueryResult<GetAllSurveysQuery, GetAllSurveysQueryVariables>;
export const AddNewSurveyDocument = gql`
    mutation AddNewSurvey($survey: SurveyInput!) {
  admin {
    addSurvey(survey: $survey) {
      ...createEditQualtricsSurveyBodyFragment
    }
  }
}
    ${CreateEditQualtricsSurveyBodyFragmentDoc}`;
export type AddNewSurveyMutationFn = Apollo.MutationFunction<AddNewSurveyMutation, AddNewSurveyMutationVariables>;

/**
 * __useAddNewSurveyMutation__
 *
 * To run a mutation, you first call `useAddNewSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewSurveyMutation, { data, loading, error }] = useAddNewSurveyMutation({
 *   variables: {
 *      survey: // value for 'survey'
 *   },
 * });
 */
export function useAddNewSurveyMutation(baseOptions?: Apollo.MutationHookOptions<AddNewSurveyMutation, AddNewSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewSurveyMutation, AddNewSurveyMutationVariables>(AddNewSurveyDocument, options);
      }
export type AddNewSurveyMutationHookResult = ReturnType<typeof useAddNewSurveyMutation>;
export type AddNewSurveyMutationResult = Apollo.MutationResult<AddNewSurveyMutation>;
export type AddNewSurveyMutationOptions = Apollo.BaseMutationOptions<AddNewSurveyMutation, AddNewSurveyMutationVariables>;
export const UpdateSurveyDocument = gql`
    mutation UpdateSurvey($surveyId: String!, $survey: SurveyInput!) {
  admin {
    updateSurvey(surveyId: $surveyId, survey: $survey) {
      ...createEditQualtricsSurveyBodyFragment
    }
  }
}
    ${CreateEditQualtricsSurveyBodyFragmentDoc}`;
export type UpdateSurveyMutationFn = Apollo.MutationFunction<UpdateSurveyMutation, UpdateSurveyMutationVariables>;

/**
 * __useUpdateSurveyMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyMutation, { data, loading, error }] = useUpdateSurveyMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      survey: // value for 'survey'
 *   },
 * });
 */
export function useUpdateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyMutation, UpdateSurveyMutationVariables>(UpdateSurveyDocument, options);
      }
export type UpdateSurveyMutationHookResult = ReturnType<typeof useUpdateSurveyMutation>;
export type UpdateSurveyMutationResult = Apollo.MutationResult<UpdateSurveyMutation>;
export type UpdateSurveyMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>;
export const UpdateSurveyCategoryDocument = gql`
    mutation UpdateSurveyCategory($surveyCategoryId: String!, $category: SurveyCategoryInput!) {
  admin {
    updateSurveyCategory(surveyCategoryId: $surveyCategoryId, category: $category) {
      ...createEditQualtricsCategoryBodyFragment
    }
  }
}
    ${CreateEditQualtricsCategoryBodyFragmentDoc}`;
export type UpdateSurveyCategoryMutationFn = Apollo.MutationFunction<UpdateSurveyCategoryMutation, UpdateSurveyCategoryMutationVariables>;

/**
 * __useUpdateSurveyCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyCategoryMutation, { data, loading, error }] = useUpdateSurveyCategoryMutation({
 *   variables: {
 *      surveyCategoryId: // value for 'surveyCategoryId'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useUpdateSurveyCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyCategoryMutation, UpdateSurveyCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyCategoryMutation, UpdateSurveyCategoryMutationVariables>(UpdateSurveyCategoryDocument, options);
      }
export type UpdateSurveyCategoryMutationHookResult = ReturnType<typeof useUpdateSurveyCategoryMutation>;
export type UpdateSurveyCategoryMutationResult = Apollo.MutationResult<UpdateSurveyCategoryMutation>;
export type UpdateSurveyCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyCategoryMutation, UpdateSurveyCategoryMutationVariables>;
export const AddSurveyCategoryDocument = gql`
    mutation AddSurveyCategory($category: SurveyCategoryInput!) {
  admin {
    addSurveyCategory(category: $category) {
      ...createEditQualtricsCategoryBodyFragment
    }
  }
}
    ${CreateEditQualtricsCategoryBodyFragmentDoc}`;
export type AddSurveyCategoryMutationFn = Apollo.MutationFunction<AddSurveyCategoryMutation, AddSurveyCategoryMutationVariables>;

/**
 * __useAddSurveyCategoryMutation__
 *
 * To run a mutation, you first call `useAddSurveyCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSurveyCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSurveyCategoryMutation, { data, loading, error }] = useAddSurveyCategoryMutation({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useAddSurveyCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AddSurveyCategoryMutation, AddSurveyCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSurveyCategoryMutation, AddSurveyCategoryMutationVariables>(AddSurveyCategoryDocument, options);
      }
export type AddSurveyCategoryMutationHookResult = ReturnType<typeof useAddSurveyCategoryMutation>;
export type AddSurveyCategoryMutationResult = Apollo.MutationResult<AddSurveyCategoryMutation>;
export type AddSurveyCategoryMutationOptions = Apollo.BaseMutationOptions<AddSurveyCategoryMutation, AddSurveyCategoryMutationVariables>;
export const UploadFileForExampleDocument = gql`
    mutation uploadFileForExample($survey: SurveyInput!) {
  admin {
    addSurvey(survey: $survey) {
      id
      icon
    }
  }
}
    `;
export type UploadFileForExampleMutationFn = Apollo.MutationFunction<UploadFileForExampleMutation, UploadFileForExampleMutationVariables>;

/**
 * __useUploadFileForExampleMutation__
 *
 * To run a mutation, you first call `useUploadFileForExampleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileForExampleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileForExampleMutation, { data, loading, error }] = useUploadFileForExampleMutation({
 *   variables: {
 *      survey: // value for 'survey'
 *   },
 * });
 */
export function useUploadFileForExampleMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileForExampleMutation, UploadFileForExampleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileForExampleMutation, UploadFileForExampleMutationVariables>(UploadFileForExampleDocument, options);
      }
export type UploadFileForExampleMutationHookResult = ReturnType<typeof useUploadFileForExampleMutation>;
export type UploadFileForExampleMutationResult = Apollo.MutationResult<UploadFileForExampleMutation>;
export type UploadFileForExampleMutationOptions = Apollo.BaseMutationOptions<UploadFileForExampleMutation, UploadFileForExampleMutationVariables>;
export const GetFileUploadExampleSurveyCategoriesDocument = gql`
    query getFileUploadExampleSurveyCategories {
  admin {
    getAllSurveyCategories {
      id
    }
  }
}
    `;

/**
 * __useGetFileUploadExampleSurveyCategoriesQuery__
 *
 * To run a query within a React component, call `useGetFileUploadExampleSurveyCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileUploadExampleSurveyCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileUploadExampleSurveyCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFileUploadExampleSurveyCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetFileUploadExampleSurveyCategoriesQuery, GetFileUploadExampleSurveyCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileUploadExampleSurveyCategoriesQuery, GetFileUploadExampleSurveyCategoriesQueryVariables>(GetFileUploadExampleSurveyCategoriesDocument, options);
      }
export function useGetFileUploadExampleSurveyCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileUploadExampleSurveyCategoriesQuery, GetFileUploadExampleSurveyCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileUploadExampleSurveyCategoriesQuery, GetFileUploadExampleSurveyCategoriesQueryVariables>(GetFileUploadExampleSurveyCategoriesDocument, options);
        }
export type GetFileUploadExampleSurveyCategoriesQueryHookResult = ReturnType<typeof useGetFileUploadExampleSurveyCategoriesQuery>;
export type GetFileUploadExampleSurveyCategoriesLazyQueryHookResult = ReturnType<typeof useGetFileUploadExampleSurveyCategoriesLazyQuery>;
export type GetFileUploadExampleSurveyCategoriesQueryResult = Apollo.QueryResult<GetFileUploadExampleSurveyCategoriesQuery, GetFileUploadExampleSurveyCategoriesQueryVariables>;
export const GetHealthPredictionForPairPredictorDocument = gql`
    query getHealthPredictionForPairPredictor($sirePetNum: Int!, $damPetNum: Int!, $healthId: String!) {
  pairPredictor(sirePetNum: $sirePetNum, damPetNum: $damPetNum) {
    sire {
      name
      callName
      avatarColorIndex
      profileImageUrl
    }
    dam {
      name
      callName
      avatarColorIndex
      profileImageUrl
    }
    healthPrediction(healthId: $healthId) {
      disorderName
      subdisorderName
      bodySystem
      gene
      modeOfInheritance
      description
      sireVariantsDetected
      sireHealthStateCategory
      damVariantsDetected
      damHealthStateCategory
      litterZeroCopiesPercent
      litterOneCopyPercent
      litterTwoCopiesPercent
      isOneCopyDangerous
      isTwoCopiesDangerous
      pairPredictorCategory
      pairPredictorCopyVariant
      howCanImproveHealthRisksParagraphs
    }
  }
}
    `;

/**
 * __useGetHealthPredictionForPairPredictorQuery__
 *
 * To run a query within a React component, call `useGetHealthPredictionForPairPredictorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHealthPredictionForPairPredictorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHealthPredictionForPairPredictorQuery({
 *   variables: {
 *      sirePetNum: // value for 'sirePetNum'
 *      damPetNum: // value for 'damPetNum'
 *      healthId: // value for 'healthId'
 *   },
 * });
 */
export function useGetHealthPredictionForPairPredictorQuery(baseOptions: Apollo.QueryHookOptions<GetHealthPredictionForPairPredictorQuery, GetHealthPredictionForPairPredictorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHealthPredictionForPairPredictorQuery, GetHealthPredictionForPairPredictorQueryVariables>(GetHealthPredictionForPairPredictorDocument, options);
      }
export function useGetHealthPredictionForPairPredictorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHealthPredictionForPairPredictorQuery, GetHealthPredictionForPairPredictorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHealthPredictionForPairPredictorQuery, GetHealthPredictionForPairPredictorQueryVariables>(GetHealthPredictionForPairPredictorDocument, options);
        }
export type GetHealthPredictionForPairPredictorQueryHookResult = ReturnType<typeof useGetHealthPredictionForPairPredictorQuery>;
export type GetHealthPredictionForPairPredictorLazyQueryHookResult = ReturnType<typeof useGetHealthPredictionForPairPredictorLazyQuery>;
export type GetHealthPredictionForPairPredictorQueryResult = Apollo.QueryResult<GetHealthPredictionForPairPredictorQuery, GetHealthPredictionForPairPredictorQueryVariables>;
export const GetEligibleDogsForPairPredictorDocument = gql`
    query getEligibleDogsForPairPredictor {
  me {
    pets(filters: {isHealthReady: true, isNonhealthReady: true}) {
      name
      callName
      sex
      petNum
      handle
    }
  }
}
    `;

/**
 * __useGetEligibleDogsForPairPredictorQuery__
 *
 * To run a query within a React component, call `useGetEligibleDogsForPairPredictorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEligibleDogsForPairPredictorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEligibleDogsForPairPredictorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEligibleDogsForPairPredictorQuery(baseOptions?: Apollo.QueryHookOptions<GetEligibleDogsForPairPredictorQuery, GetEligibleDogsForPairPredictorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEligibleDogsForPairPredictorQuery, GetEligibleDogsForPairPredictorQueryVariables>(GetEligibleDogsForPairPredictorDocument, options);
      }
export function useGetEligibleDogsForPairPredictorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEligibleDogsForPairPredictorQuery, GetEligibleDogsForPairPredictorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEligibleDogsForPairPredictorQuery, GetEligibleDogsForPairPredictorQueryVariables>(GetEligibleDogsForPairPredictorDocument, options);
        }
export type GetEligibleDogsForPairPredictorQueryHookResult = ReturnType<typeof useGetEligibleDogsForPairPredictorQuery>;
export type GetEligibleDogsForPairPredictorLazyQueryHookResult = ReturnType<typeof useGetEligibleDogsForPairPredictorLazyQuery>;
export type GetEligibleDogsForPairPredictorQueryResult = Apollo.QueryResult<GetEligibleDogsForPairPredictorQuery, GetEligibleDogsForPairPredictorQueryVariables>;
export const GetPredictionForPairPredictorDocument = gql`
    query getPredictionForPairPredictor($sirePetNum: Int!, $damPetNum: Int!) {
  pairPredictor(sirePetNum: $sirePetNum, damPetNum: $damPetNum) {
    healthPredictions {
      ...healthResultFields
    }
    eCoi {
      expectedLitterCoi
      averageBreedCoi
      eCoiCopyVariant
      pluralBreedDisplayName
    }
    coatColorPredictions {
      coatAttributes {
        count
        percentage
        attributes {
          diluted
          pigmentColor
          coatColor
          coatType
          mask
        }
      }
      lociCombinations {
        e {
          key
          value
        }
        a {
          key
          value
        }
        k {
          key
          value
        }
        d {
          key
          value
        }
        b {
          key
          value
        }
      }
      sireLocus {
        e
        a
        k
        d
        b
      }
      damLocus {
        e
        a
        k
        d
        b
      }
    }
    sire {
      id
      name
      callName
      handle
      profileImageUrl
      avatarColorIndex
      traits {
        roundedCoiPercent
      }
    }
    dam {
      id
      name
      callName
      handle
      profileImageUrl
      avatarColorIndex
      traits {
        roundedCoiPercent
      }
    }
  }
}
    ${HealthResultFieldsFragmentDoc}`;

/**
 * __useGetPredictionForPairPredictorQuery__
 *
 * To run a query within a React component, call `useGetPredictionForPairPredictorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPredictionForPairPredictorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPredictionForPairPredictorQuery({
 *   variables: {
 *      sirePetNum: // value for 'sirePetNum'
 *      damPetNum: // value for 'damPetNum'
 *   },
 * });
 */
export function useGetPredictionForPairPredictorQuery(baseOptions: Apollo.QueryHookOptions<GetPredictionForPairPredictorQuery, GetPredictionForPairPredictorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPredictionForPairPredictorQuery, GetPredictionForPairPredictorQueryVariables>(GetPredictionForPairPredictorDocument, options);
      }
export function useGetPredictionForPairPredictorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPredictionForPairPredictorQuery, GetPredictionForPairPredictorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPredictionForPairPredictorQuery, GetPredictionForPairPredictorQueryVariables>(GetPredictionForPairPredictorDocument, options);
        }
export type GetPredictionForPairPredictorQueryHookResult = ReturnType<typeof useGetPredictionForPairPredictorQuery>;
export type GetPredictionForPairPredictorLazyQueryHookResult = ReturnType<typeof useGetPredictionForPairPredictorLazyQuery>;
export type GetPredictionForPairPredictorQueryResult = Apollo.QueryResult<GetPredictionForPairPredictorQuery, GetPredictionForPairPredictorQueryVariables>;
export const GetBreederFacingBreedsDocument = gql`
    query GetBreederFacingBreeds {
  breederFacingBreeds {
    displayName
    ancestryLabel
  }
}
    `;

/**
 * __useGetBreederFacingBreedsQuery__
 *
 * To run a query within a React component, call `useGetBreederFacingBreedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBreederFacingBreedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBreederFacingBreedsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBreederFacingBreedsQuery(baseOptions?: Apollo.QueryHookOptions<GetBreederFacingBreedsQuery, GetBreederFacingBreedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBreederFacingBreedsQuery, GetBreederFacingBreedsQueryVariables>(GetBreederFacingBreedsDocument, options);
      }
export function useGetBreederFacingBreedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBreederFacingBreedsQuery, GetBreederFacingBreedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBreederFacingBreedsQuery, GetBreederFacingBreedsQueryVariables>(GetBreederFacingBreedsDocument, options);
        }
export type GetBreederFacingBreedsQueryHookResult = ReturnType<typeof useGetBreederFacingBreedsQuery>;
export type GetBreederFacingBreedsLazyQueryHookResult = ReturnType<typeof useGetBreederFacingBreedsLazyQuery>;
export type GetBreederFacingBreedsQueryResult = Apollo.QueryResult<GetBreederFacingBreedsQuery, GetBreederFacingBreedsQueryVariables>;
export const GetPetInfoByUuidDocument = gql`
    query GetPetInfoByUuid($petUuid: String!) {
  me {
    pets(filters: {petUuid: $petUuid}) {
      id
      petNum
      name
      dateOfBirth
      ancestry {
        breeds {
          name
          percentage
        }
      }
    }
  }
}
    `;

/**
 * __useGetPetInfoByUuidQuery__
 *
 * To run a query within a React component, call `useGetPetInfoByUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPetInfoByUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPetInfoByUuidQuery({
 *   variables: {
 *      petUuid: // value for 'petUuid'
 *   },
 * });
 */
export function useGetPetInfoByUuidQuery(baseOptions: Apollo.QueryHookOptions<GetPetInfoByUuidQuery, GetPetInfoByUuidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPetInfoByUuidQuery, GetPetInfoByUuidQueryVariables>(GetPetInfoByUuidDocument, options);
      }
export function useGetPetInfoByUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPetInfoByUuidQuery, GetPetInfoByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPetInfoByUuidQuery, GetPetInfoByUuidQueryVariables>(GetPetInfoByUuidDocument, options);
        }
export type GetPetInfoByUuidQueryHookResult = ReturnType<typeof useGetPetInfoByUuidQuery>;
export type GetPetInfoByUuidLazyQueryHookResult = ReturnType<typeof useGetPetInfoByUuidLazyQuery>;
export type GetPetInfoByUuidQueryResult = Apollo.QueryResult<GetPetInfoByUuidQuery, GetPetInfoByUuidQueryVariables>;
export const ActivateHowDidYouHearMutationDocument = gql`
    mutation ActivateHowDidYouHearMutation($input: ActivateHowDidYouHearInput!) {
  activateKit {
    activateHowDidYouHear(input: $input)
  }
}
    `;
export type ActivateHowDidYouHearMutationMutationFn = Apollo.MutationFunction<ActivateHowDidYouHearMutation, ActivateHowDidYouHearMutationVariables>;

/**
 * __useActivateHowDidYouHearMutation__
 *
 * To run a mutation, you first call `useActivateHowDidYouHearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateHowDidYouHearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateHowDidYouHearMutation, { data, loading, error }] = useActivateHowDidYouHearMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateHowDidYouHearMutation(baseOptions?: Apollo.MutationHookOptions<ActivateHowDidYouHearMutation, ActivateHowDidYouHearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateHowDidYouHearMutation, ActivateHowDidYouHearMutationVariables>(ActivateHowDidYouHearMutationDocument, options);
      }
export type ActivateHowDidYouHearMutationHookResult = ReturnType<typeof useActivateHowDidYouHearMutation>;
export type ActivateHowDidYouHearMutationMutationResult = Apollo.MutationResult<ActivateHowDidYouHearMutation>;
export type ActivateHowDidYouHearMutationMutationOptions = Apollo.BaseMutationOptions<ActivateHowDidYouHearMutation, ActivateHowDidYouHearMutationVariables>;
export const ActivatedQualtricsSurveyDocument = gql`
    query ActivatedQualtricsSurvey($petNum: Int!) {
  me {
    pets(filters: {petNum: $petNum}) {
      name
      surveys {
        surveyTemplateId
        surveyUrl
      }
    }
  }
}
    `;

/**
 * __useActivatedQualtricsSurveyQuery__
 *
 * To run a query within a React component, call `useActivatedQualtricsSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivatedQualtricsSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivatedQualtricsSurveyQuery({
 *   variables: {
 *      petNum: // value for 'petNum'
 *   },
 * });
 */
export function useActivatedQualtricsSurveyQuery(baseOptions: Apollo.QueryHookOptions<ActivatedQualtricsSurveyQuery, ActivatedQualtricsSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivatedQualtricsSurveyQuery, ActivatedQualtricsSurveyQueryVariables>(ActivatedQualtricsSurveyDocument, options);
      }
export function useActivatedQualtricsSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivatedQualtricsSurveyQuery, ActivatedQualtricsSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivatedQualtricsSurveyQuery, ActivatedQualtricsSurveyQueryVariables>(ActivatedQualtricsSurveyDocument, options);
        }
export type ActivatedQualtricsSurveyQueryHookResult = ReturnType<typeof useActivatedQualtricsSurveyQuery>;
export type ActivatedQualtricsSurveyLazyQueryHookResult = ReturnType<typeof useActivatedQualtricsSurveyLazyQuery>;
export type ActivatedQualtricsSurveyQueryResult = Apollo.QueryResult<ActivatedQualtricsSurveyQuery, ActivatedQualtricsSurveyQueryVariables>;
export const GetPetsEligibleForKitActivationDocument = gql`
    mutation GetPetsEligibleForKitActivation($boxKeyOrSwabCode: String!) {
  activateKit {
    activateBoxKeyOrSwabCode(boxKeyOrSwabCode: $boxKeyOrSwabCode) {
      pets {
        petNum
        name
        handle
      }
      boxKeyOrSwabCode
      productSkuPrefix
      isVetAffiliate
    }
  }
}
    `;
export type GetPetsEligibleForKitActivationMutationFn = Apollo.MutationFunction<GetPetsEligibleForKitActivationMutation, GetPetsEligibleForKitActivationMutationVariables>;

/**
 * __useGetPetsEligibleForKitActivationMutation__
 *
 * To run a mutation, you first call `useGetPetsEligibleForKitActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPetsEligibleForKitActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPetsEligibleForKitActivationMutation, { data, loading, error }] = useGetPetsEligibleForKitActivationMutation({
 *   variables: {
 *      boxKeyOrSwabCode: // value for 'boxKeyOrSwabCode'
 *   },
 * });
 */
export function useGetPetsEligibleForKitActivationMutation(baseOptions?: Apollo.MutationHookOptions<GetPetsEligibleForKitActivationMutation, GetPetsEligibleForKitActivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetPetsEligibleForKitActivationMutation, GetPetsEligibleForKitActivationMutationVariables>(GetPetsEligibleForKitActivationDocument, options);
      }
export type GetPetsEligibleForKitActivationMutationHookResult = ReturnType<typeof useGetPetsEligibleForKitActivationMutation>;
export type GetPetsEligibleForKitActivationMutationResult = Apollo.MutationResult<GetPetsEligibleForKitActivationMutation>;
export type GetPetsEligibleForKitActivationMutationOptions = Apollo.BaseMutationOptions<GetPetsEligibleForKitActivationMutation, GetPetsEligibleForKitActivationMutationVariables>;
export const ActivateKitWithPetDocument = gql`
    mutation ActivateKitWithPet($boxKeyOrSwabCode: String!, $petNum: Int!, $surveyId: String!, $practiceId: String) {
  activateKit {
    activateSelectDog(
      boxKeyOrSwabCode: $boxKeyOrSwabCode
      petNum: $petNum
      practiceId: $practiceId
    ) {
      pet {
        petNum
        name
        id
        dateOfBirth
        profileImageUrl
        avatarColorIndex
        surveyUrlBySurveyId(surveyId: $surveyId)
        genotype {
          breedMix {
            breedName
            ancestryLabel
          }
        }
      }
      boxKey
      swabCode
      testType
    }
  }
}
    `;
export type ActivateKitWithPetMutationFn = Apollo.MutationFunction<ActivateKitWithPetMutation, ActivateKitWithPetMutationVariables>;

/**
 * __useActivateKitWithPetMutation__
 *
 * To run a mutation, you first call `useActivateKitWithPetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateKitWithPetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateKitWithPetMutation, { data, loading, error }] = useActivateKitWithPetMutation({
 *   variables: {
 *      boxKeyOrSwabCode: // value for 'boxKeyOrSwabCode'
 *      petNum: // value for 'petNum'
 *      surveyId: // value for 'surveyId'
 *      practiceId: // value for 'practiceId'
 *   },
 * });
 */
export function useActivateKitWithPetMutation(baseOptions?: Apollo.MutationHookOptions<ActivateKitWithPetMutation, ActivateKitWithPetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateKitWithPetMutation, ActivateKitWithPetMutationVariables>(ActivateKitWithPetDocument, options);
      }
export type ActivateKitWithPetMutationHookResult = ReturnType<typeof useActivateKitWithPetMutation>;
export type ActivateKitWithPetMutationResult = Apollo.MutationResult<ActivateKitWithPetMutation>;
export type ActivateKitWithPetMutationOptions = Apollo.BaseMutationOptions<ActivateKitWithPetMutation, ActivateKitWithPetMutationVariables>;
export const ActivateContributeToResearchMutationDocument = gql`
    mutation ActivateContributeToResearchMutation($input: ActivateContributeToResearchInput!) {
  activateKit {
    activateContributeToResearch(input: $input)
  }
}
    `;
export type ActivateContributeToResearchMutationMutationFn = Apollo.MutationFunction<ActivateContributeToResearchMutation, ActivateContributeToResearchMutationVariables>;

/**
 * __useActivateContributeToResearchMutation__
 *
 * To run a mutation, you first call `useActivateContributeToResearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateContributeToResearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateContributeToResearchMutation, { data, loading, error }] = useActivateContributeToResearchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateContributeToResearchMutation(baseOptions?: Apollo.MutationHookOptions<ActivateContributeToResearchMutation, ActivateContributeToResearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateContributeToResearchMutation, ActivateContributeToResearchMutationVariables>(ActivateContributeToResearchMutationDocument, options);
      }
export type ActivateContributeToResearchMutationHookResult = ReturnType<typeof useActivateContributeToResearchMutation>;
export type ActivateContributeToResearchMutationMutationResult = Apollo.MutationResult<ActivateContributeToResearchMutation>;
export type ActivateContributeToResearchMutationMutationOptions = Apollo.BaseMutationOptions<ActivateContributeToResearchMutation, ActivateContributeToResearchMutationVariables>;
export const GetKitActivationPageInfoDocument = gql`
    query getKitActivationPageInfo {
  identifiableBreeds {
    displayName
    ancestryLabel
  }
  me {
    howHeardAboutUs
  }
}
    `;

/**
 * __useGetKitActivationPageInfoQuery__
 *
 * To run a query within a React component, call `useGetKitActivationPageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKitActivationPageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKitActivationPageInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKitActivationPageInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetKitActivationPageInfoQuery, GetKitActivationPageInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKitActivationPageInfoQuery, GetKitActivationPageInfoQueryVariables>(GetKitActivationPageInfoDocument, options);
      }
export function useGetKitActivationPageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKitActivationPageInfoQuery, GetKitActivationPageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKitActivationPageInfoQuery, GetKitActivationPageInfoQueryVariables>(GetKitActivationPageInfoDocument, options);
        }
export type GetKitActivationPageInfoQueryHookResult = ReturnType<typeof useGetKitActivationPageInfoQuery>;
export type GetKitActivationPageInfoLazyQueryHookResult = ReturnType<typeof useGetKitActivationPageInfoLazyQuery>;
export type GetKitActivationPageInfoQueryResult = Apollo.QueryResult<GetKitActivationPageInfoQuery, GetKitActivationPageInfoQueryVariables>;
export const UpdatePetDocument = gql`
    mutation UpdatePet($updateFields: PetUpdateInput!, $queryFields: PetQueryInput!) {
  pet {
    updatePet(updateFields: $updateFields, queryFields: $queryFields) {
      adultWeightLbs
    }
  }
}
    `;
export type UpdatePetMutationFn = Apollo.MutationFunction<UpdatePetMutation, UpdatePetMutationVariables>;

/**
 * __useUpdatePetMutation__
 *
 * To run a mutation, you first call `useUpdatePetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePetMutation, { data, loading, error }] = useUpdatePetMutation({
 *   variables: {
 *      updateFields: // value for 'updateFields'
 *      queryFields: // value for 'queryFields'
 *   },
 * });
 */
export function useUpdatePetMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePetMutation, UpdatePetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePetMutation, UpdatePetMutationVariables>(UpdatePetDocument, options);
      }
export type UpdatePetMutationHookResult = ReturnType<typeof useUpdatePetMutation>;
export type UpdatePetMutationResult = Apollo.MutationResult<UpdatePetMutation>;
export type UpdatePetMutationOptions = Apollo.BaseMutationOptions<UpdatePetMutation, UpdatePetMutationVariables>;
export const PetResultsDocument = gql`
    query PetResults($petNum: Int!) {
  me {
    id
    petCount
    petByPetNum(petNum: $petNum) {
      id
      isPrimaryOwnerBreeder
      ...SummaryPagePetFragment
      ...PetTrackingFragment
      ...PetCardFragment
      ...ResearchPageContainerPetFragment
      ...HealthPagePetFragment
      ...NutritionPageFragment
      ...PetResultsSubPagePetFragment
      ...BreedAndAncestryPageFragment
      ...HealthConditionPagePetFragment
      ...TraitsPagePetFragment
      healthResultsState
    }
    ...SummaryPageUserFragment
    ...PetResultsSubPageUserFragment
    ...NutritionPageUserFragment
    ...BreedAndAncestryPageUserFragment
    ...TraitsPageUserFragment
  }
}
    ${SummaryPagePetFragmentDoc}
${PetTrackingFragmentDoc}
${PetCardFragmentDoc}
${ResearchPageContainerPetFragmentDoc}
${HealthPagePetFragmentDoc}
${NutritionPageFragmentDoc}
${PetResultsSubPagePetFragmentDoc}
${BreedAndAncestryPageFragmentDoc}
${HealthConditionPagePetFragmentDoc}
${TraitsPagePetFragmentDoc}
${SummaryPageUserFragmentDoc}
${PetResultsSubPageUserFragmentDoc}
${NutritionPageUserFragmentDoc}
${BreedAndAncestryPageUserFragmentDoc}
${TraitsPageUserFragmentDoc}`;

/**
 * __usePetResultsQuery__
 *
 * To run a query within a React component, call `usePetResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePetResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetResultsQuery({
 *   variables: {
 *      petNum: // value for 'petNum'
 *   },
 * });
 */
export function usePetResultsQuery(baseOptions: Apollo.QueryHookOptions<PetResultsQuery, PetResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PetResultsQuery, PetResultsQueryVariables>(PetResultsDocument, options);
      }
export function usePetResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PetResultsQuery, PetResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PetResultsQuery, PetResultsQueryVariables>(PetResultsDocument, options);
        }
export type PetResultsQueryHookResult = ReturnType<typeof usePetResultsQuery>;
export type PetResultsLazyQueryHookResult = ReturnType<typeof usePetResultsLazyQuery>;
export type PetResultsQueryResult = Apollo.QueryResult<PetResultsQuery, PetResultsQueryVariables>;
export const SurveyProgressDocument = gql`
    query surveyProgress($petNum: Int) {
  me {
    id
    pets(filters: {petNum: $petNum}) {
      id
      surveys {
        id
        surveyProgress
      }
    }
  }
}
    `;

/**
 * __useSurveyProgressQuery__
 *
 * To run a query within a React component, call `useSurveyProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyProgressQuery({
 *   variables: {
 *      petNum: // value for 'petNum'
 *   },
 * });
 */
export function useSurveyProgressQuery(baseOptions?: Apollo.QueryHookOptions<SurveyProgressQuery, SurveyProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyProgressQuery, SurveyProgressQueryVariables>(SurveyProgressDocument, options);
      }
export function useSurveyProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyProgressQuery, SurveyProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyProgressQuery, SurveyProgressQueryVariables>(SurveyProgressDocument, options);
        }
export type SurveyProgressQueryHookResult = ReturnType<typeof useSurveyProgressQuery>;
export type SurveyProgressLazyQueryHookResult = ReturnType<typeof useSurveyProgressLazyQuery>;
export type SurveyProgressQueryResult = Apollo.QueryResult<SurveyProgressQuery, SurveyProgressQueryVariables>;
export const PetParentDashboardDocument = gql`
    query petParentDashboard($pagination: Pagination, $filters: PetFilters) {
  me {
    ...PetParentDashboardContainerFragment
    featureFlags {
      showPetParentDashboard
    }
    ...FooterUserFragment
  }
}
    ${PetParentDashboardContainerFragmentDoc}
${FooterUserFragmentDoc}`;

/**
 * __usePetParentDashboardQuery__
 *
 * To run a query within a React component, call `usePetParentDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePetParentDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetParentDashboardQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePetParentDashboardQuery(baseOptions?: Apollo.QueryHookOptions<PetParentDashboardQuery, PetParentDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PetParentDashboardQuery, PetParentDashboardQueryVariables>(PetParentDashboardDocument, options);
      }
export function usePetParentDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PetParentDashboardQuery, PetParentDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PetParentDashboardQuery, PetParentDashboardQueryVariables>(PetParentDashboardDocument, options);
        }
export type PetParentDashboardQueryHookResult = ReturnType<typeof usePetParentDashboardQuery>;
export type PetParentDashboardLazyQueryHookResult = ReturnType<typeof usePetParentDashboardLazyQuery>;
export type PetParentDashboardQueryResult = Apollo.QueryResult<PetParentDashboardQuery, PetParentDashboardQueryVariables>;
export const GetHealthConditionDetailsDocument = gql`
    query GetHealthConditionDetails($filters: HealthConditionDetailsFilter!) {
  healthConditionDetails(filters: $filters) {
    ...HealthConditionDetailsFragment
  }
}
    ${HealthConditionDetailsFragmentDoc}`;

/**
 * __useGetHealthConditionDetailsQuery__
 *
 * To run a query within a React component, call `useGetHealthConditionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHealthConditionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHealthConditionDetailsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetHealthConditionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetHealthConditionDetailsQuery, GetHealthConditionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHealthConditionDetailsQuery, GetHealthConditionDetailsQueryVariables>(GetHealthConditionDetailsDocument, options);
      }
export function useGetHealthConditionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHealthConditionDetailsQuery, GetHealthConditionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHealthConditionDetailsQuery, GetHealthConditionDetailsQueryVariables>(GetHealthConditionDetailsDocument, options);
        }
export type GetHealthConditionDetailsQueryHookResult = ReturnType<typeof useGetHealthConditionDetailsQuery>;
export type GetHealthConditionDetailsLazyQueryHookResult = ReturnType<typeof useGetHealthConditionDetailsLazyQuery>;
export type GetHealthConditionDetailsQueryResult = Apollo.QueryResult<GetHealthConditionDetailsQuery, GetHealthConditionDetailsQueryVariables>;
export const GetHealthConditionDocument = gql`
    query GetHealthCondition($petNum: Int!, $filters: HealthFilter!) {
  me {
    id
    petByPetNum(petNum: $petNum) {
      id
      health(filters: $filters) {
        results {
          id
          isPawsitResult
          ...MonogenicConditionPageFragment
          ...PolygenicConditionPageFragment
        }
      }
    }
  }
}
    ${MonogenicConditionPageFragmentDoc}
${PolygenicConditionPageFragmentDoc}`;

/**
 * __useGetHealthConditionQuery__
 *
 * To run a query within a React component, call `useGetHealthConditionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHealthConditionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHealthConditionQuery({
 *   variables: {
 *      petNum: // value for 'petNum'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetHealthConditionQuery(baseOptions: Apollo.QueryHookOptions<GetHealthConditionQuery, GetHealthConditionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHealthConditionQuery, GetHealthConditionQueryVariables>(GetHealthConditionDocument, options);
      }
export function useGetHealthConditionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHealthConditionQuery, GetHealthConditionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHealthConditionQuery, GetHealthConditionQueryVariables>(GetHealthConditionDocument, options);
        }
export type GetHealthConditionQueryHookResult = ReturnType<typeof useGetHealthConditionQuery>;
export type GetHealthConditionLazyQueryHookResult = ReturnType<typeof useGetHealthConditionLazyQuery>;
export type GetHealthConditionQueryResult = Apollo.QueryResult<GetHealthConditionQuery, GetHealthConditionQueryVariables>;
export const SubmitNutritionRecommendationRequestDocument = gql`
    mutation SubmitNutritionRecommendationRequest($nutritionInput: NutritionRecommendationInput!) {
  pet {
    submitNutritionRecommendationRequest(nutritionInput: $nutritionInput) {
      foodRecommendations {
        image
        productKey
        productName
        type
        url
        recommendedDailyVolume {
          decimal
          fraction
        }
      }
      ingredients {
        name
        description
      }
      nutrients {
        name
      }
      weight
      benefit
      birthday
      ageCategory
      description
      bodyCondition
      breedSize
      dailyEnergyRequirement
      activityLevel
    }
  }
}
    `;
export type SubmitNutritionRecommendationRequestMutationFn = Apollo.MutationFunction<SubmitNutritionRecommendationRequestMutation, SubmitNutritionRecommendationRequestMutationVariables>;

/**
 * __useSubmitNutritionRecommendationRequestMutation__
 *
 * To run a mutation, you first call `useSubmitNutritionRecommendationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitNutritionRecommendationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitNutritionRecommendationRequestMutation, { data, loading, error }] = useSubmitNutritionRecommendationRequestMutation({
 *   variables: {
 *      nutritionInput: // value for 'nutritionInput'
 *   },
 * });
 */
export function useSubmitNutritionRecommendationRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitNutritionRecommendationRequestMutation, SubmitNutritionRecommendationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitNutritionRecommendationRequestMutation, SubmitNutritionRecommendationRequestMutationVariables>(SubmitNutritionRecommendationRequestDocument, options);
      }
export type SubmitNutritionRecommendationRequestMutationHookResult = ReturnType<typeof useSubmitNutritionRecommendationRequestMutation>;
export type SubmitNutritionRecommendationRequestMutationResult = Apollo.MutationResult<SubmitNutritionRecommendationRequestMutation>;
export type SubmitNutritionRecommendationRequestMutationOptions = Apollo.BaseMutationOptions<SubmitNutritionRecommendationRequestMutation, SubmitNutritionRecommendationRequestMutationVariables>;
export const SaveNutritionInputDataDocument = gql`
    mutation SaveNutritionInputData($nutritionDataInput: SaveNutritionDataInput!) {
  pet {
    saveNutritionInputData(nutritionDataInput: $nutritionDataInput) {
      sessionId
    }
  }
}
    `;
export type SaveNutritionInputDataMutationFn = Apollo.MutationFunction<SaveNutritionInputDataMutation, SaveNutritionInputDataMutationVariables>;

/**
 * __useSaveNutritionInputDataMutation__
 *
 * To run a mutation, you first call `useSaveNutritionInputDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNutritionInputDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNutritionInputDataMutation, { data, loading, error }] = useSaveNutritionInputDataMutation({
 *   variables: {
 *      nutritionDataInput: // value for 'nutritionDataInput'
 *   },
 * });
 */
export function useSaveNutritionInputDataMutation(baseOptions?: Apollo.MutationHookOptions<SaveNutritionInputDataMutation, SaveNutritionInputDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNutritionInputDataMutation, SaveNutritionInputDataMutationVariables>(SaveNutritionInputDataDocument, options);
      }
export type SaveNutritionInputDataMutationHookResult = ReturnType<typeof useSaveNutritionInputDataMutation>;
export type SaveNutritionInputDataMutationResult = Apollo.MutationResult<SaveNutritionInputDataMutation>;
export type SaveNutritionInputDataMutationOptions = Apollo.BaseMutationOptions<SaveNutritionInputDataMutation, SaveNutritionInputDataMutationVariables>;
export const UpdateEmailPreferencesDocument = gql`
    mutation UpdateEmailPreferences($preferences: EmailPreferencesInput!) {
  user {
    updateUserEmailPreferences(preferences: $preferences) {
      ...EmailPreferencesFragment
    }
  }
}
    ${EmailPreferencesFragmentDoc}`;
export type UpdateEmailPreferencesMutationFn = Apollo.MutationFunction<UpdateEmailPreferencesMutation, UpdateEmailPreferencesMutationVariables>;

/**
 * __useUpdateEmailPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateEmailPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailPreferencesMutation, { data, loading, error }] = useUpdateEmailPreferencesMutation({
 *   variables: {
 *      preferences: // value for 'preferences'
 *   },
 * });
 */
export function useUpdateEmailPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailPreferencesMutation, UpdateEmailPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailPreferencesMutation, UpdateEmailPreferencesMutationVariables>(UpdateEmailPreferencesDocument, options);
      }
export type UpdateEmailPreferencesMutationHookResult = ReturnType<typeof useUpdateEmailPreferencesMutation>;
export type UpdateEmailPreferencesMutationResult = Apollo.MutationResult<UpdateEmailPreferencesMutation>;
export type UpdateEmailPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateEmailPreferencesMutation, UpdateEmailPreferencesMutationVariables>;
export const UserSettingsDocument = gql`
    query UserSettings {
  me {
    id
    ...EmailPreferencesUserFragment
  }
}
    ${EmailPreferencesUserFragmentDoc}`;

/**
 * __useUserSettingsQuery__
 *
 * To run a query within a React component, call `useUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSettingsQuery(baseOptions?: Apollo.QueryHookOptions<UserSettingsQuery, UserSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSettingsQuery, UserSettingsQueryVariables>(UserSettingsDocument, options);
      }
export function useUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSettingsQuery, UserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSettingsQuery, UserSettingsQueryVariables>(UserSettingsDocument, options);
        }
export type UserSettingsQueryHookResult = ReturnType<typeof useUserSettingsQuery>;
export type UserSettingsLazyQueryHookResult = ReturnType<typeof useUserSettingsLazyQuery>;
export type UserSettingsQueryResult = Apollo.QueryResult<UserSettingsQuery, UserSettingsQueryVariables>;
export const AddNewPatientDocument = gql`
    mutation AddNewPatient($patient: NewPatientInput!) {
  vet {
    addNewPatient(patient: $patient) {
      petNum
    }
  }
}
    `;
export type AddNewPatientMutationFn = Apollo.MutationFunction<AddNewPatientMutation, AddNewPatientMutationVariables>;

/**
 * __useAddNewPatientMutation__
 *
 * To run a mutation, you first call `useAddNewPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewPatientMutation, { data, loading, error }] = useAddNewPatientMutation({
 *   variables: {
 *      patient: // value for 'patient'
 *   },
 * });
 */
export function useAddNewPatientMutation(baseOptions?: Apollo.MutationHookOptions<AddNewPatientMutation, AddNewPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewPatientMutation, AddNewPatientMutationVariables>(AddNewPatientDocument, options);
      }
export type AddNewPatientMutationHookResult = ReturnType<typeof useAddNewPatientMutation>;
export type AddNewPatientMutationResult = Apollo.MutationResult<AddNewPatientMutation>;
export type AddNewPatientMutationOptions = Apollo.BaseMutationOptions<AddNewPatientMutation, AddNewPatientMutationVariables>;
export const UpdatePatientDocument = gql`
    mutation UpdatePatient($patient: UpdatePatientInput!) {
  vet {
    updatePatient(patient: $patient) {
      petNum
    }
  }
}
    `;
export type UpdatePatientMutationFn = Apollo.MutationFunction<UpdatePatientMutation, UpdatePatientMutationVariables>;

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMutation, { data, loading, error }] = useUpdatePatientMutation({
 *   variables: {
 *      patient: // value for 'patient'
 *   },
 * });
 */
export function useUpdatePatientMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientMutation, UpdatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientMutation, UpdatePatientMutationVariables>(UpdatePatientDocument, options);
      }
export type UpdatePatientMutationHookResult = ReturnType<typeof useUpdatePatientMutation>;
export type UpdatePatientMutationResult = Apollo.MutationResult<UpdatePatientMutation>;
export type UpdatePatientMutationOptions = Apollo.BaseMutationOptions<UpdatePatientMutation, UpdatePatientMutationVariables>;
export const ActivateSwabDocument = gql`
    mutation ActivateSwab($activationDetails: ActivateSwabInput!) {
  pet {
    activateSwab(activationDetails: $activationDetails) {
      swabSummary {
        swabCode
      }
    }
  }
}
    `;
export type ActivateSwabMutationFn = Apollo.MutationFunction<ActivateSwabMutation, ActivateSwabMutationVariables>;

/**
 * __useActivateSwabMutation__
 *
 * To run a mutation, you first call `useActivateSwabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSwabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSwabMutation, { data, loading, error }] = useActivateSwabMutation({
 *   variables: {
 *      activationDetails: // value for 'activationDetails'
 *   },
 * });
 */
export function useActivateSwabMutation(baseOptions?: Apollo.MutationHookOptions<ActivateSwabMutation, ActivateSwabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateSwabMutation, ActivateSwabMutationVariables>(ActivateSwabDocument, options);
      }
export type ActivateSwabMutationHookResult = ReturnType<typeof useActivateSwabMutation>;
export type ActivateSwabMutationResult = Apollo.MutationResult<ActivateSwabMutation>;
export type ActivateSwabMutationOptions = Apollo.BaseMutationOptions<ActivateSwabMutation, ActivateSwabMutationVariables>;
export const VetDashboardInfoDocument = gql`
    query VetDashboardInfo {
  me {
    id
    practice {
      id: practiceId
      practiceId
      name
      createdAt
      practiceUsers {
        id
        name
        email
        isDVM
      }
      swabsOrderedCount
      petActivationCount
      practicePetCount
      onboardingChecklist {
        placeFirstOrder
        testFirstPatient
        receiveFirstResults
        assignStaffChampion
        talkAboutGeneticTesting
        learnToUseDashboard
        connectWithSuccessManager
      }
      onboardingMetadata {
        hasFewPatientsAndSomeAllClearResults
        hasFewPatientsAndSomeNotableOrAtRiskResults
      }
    }
  }
}
    `;

/**
 * __useVetDashboardInfoQuery__
 *
 * To run a query within a React component, call `useVetDashboardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVetDashboardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVetDashboardInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useVetDashboardInfoQuery(baseOptions?: Apollo.QueryHookOptions<VetDashboardInfoQuery, VetDashboardInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VetDashboardInfoQuery, VetDashboardInfoQueryVariables>(VetDashboardInfoDocument, options);
      }
export function useVetDashboardInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VetDashboardInfoQuery, VetDashboardInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VetDashboardInfoQuery, VetDashboardInfoQueryVariables>(VetDashboardInfoDocument, options);
        }
export type VetDashboardInfoQueryHookResult = ReturnType<typeof useVetDashboardInfoQuery>;
export type VetDashboardInfoLazyQueryHookResult = ReturnType<typeof useVetDashboardInfoLazyQuery>;
export type VetDashboardInfoQueryResult = Apollo.QueryResult<VetDashboardInfoQuery, VetDashboardInfoQueryVariables>;
export const ListPracticePetsDocument = gql`
    query ListPracticePets($pagination: Pagination, $filters: PetFilters, $sort: PetSort) {
  me {
    id
    petCount(filters: $filters)
    pets(pagination: $pagination, filters: $filters, sort: $sort) {
      ...ListPracticePetFragment
    }
  }
}
    ${ListPracticePetFragmentDoc}`;

/**
 * __useListPracticePetsQuery__
 *
 * To run a query within a React component, call `useListPracticePetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPracticePetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPracticePetsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListPracticePetsQuery(baseOptions?: Apollo.QueryHookOptions<ListPracticePetsQuery, ListPracticePetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPracticePetsQuery, ListPracticePetsQueryVariables>(ListPracticePetsDocument, options);
      }
export function useListPracticePetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPracticePetsQuery, ListPracticePetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPracticePetsQuery, ListPracticePetsQueryVariables>(ListPracticePetsDocument, options);
        }
export type ListPracticePetsQueryHookResult = ReturnType<typeof useListPracticePetsQuery>;
export type ListPracticePetsLazyQueryHookResult = ReturnType<typeof useListPracticePetsLazyQuery>;
export type ListPracticePetsQueryResult = Apollo.QueryResult<ListPracticePetsQuery, ListPracticePetsQueryVariables>;
export const ReleasePetToClientDocument = gql`
    mutation ReleasePetToClient($vetPatient: ReleasePetToClientInput!) {
  vet {
    releasePetToClient(vetPatient: $vetPatient) {
      ...PracticePetCardFragment
    }
  }
}
    ${PracticePetCardFragmentDoc}`;
export type ReleasePetToClientMutationFn = Apollo.MutationFunction<ReleasePetToClientMutation, ReleasePetToClientMutationVariables>;

/**
 * __useReleasePetToClientMutation__
 *
 * To run a mutation, you first call `useReleasePetToClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleasePetToClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releasePetToClientMutation, { data, loading, error }] = useReleasePetToClientMutation({
 *   variables: {
 *      vetPatient: // value for 'vetPatient'
 *   },
 * });
 */
export function useReleasePetToClientMutation(baseOptions?: Apollo.MutationHookOptions<ReleasePetToClientMutation, ReleasePetToClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleasePetToClientMutation, ReleasePetToClientMutationVariables>(ReleasePetToClientDocument, options);
      }
export type ReleasePetToClientMutationHookResult = ReturnType<typeof useReleasePetToClientMutation>;
export type ReleasePetToClientMutationResult = Apollo.MutationResult<ReleasePetToClientMutation>;
export type ReleasePetToClientMutationOptions = Apollo.BaseMutationOptions<ReleasePetToClientMutation, ReleasePetToClientMutationVariables>;
export const DeletePatientNoteDocument = gql`
    mutation DeletePatientNote($noteToDelete: DeleteVetPatientNoteInput!) {
  vet {
    deletePatientNote(noteToDelete: $noteToDelete) {
      ...PracticePetCardFragment
    }
  }
}
    ${PracticePetCardFragmentDoc}`;
export type DeletePatientNoteMutationFn = Apollo.MutationFunction<DeletePatientNoteMutation, DeletePatientNoteMutationVariables>;

/**
 * __useDeletePatientNoteMutation__
 *
 * To run a mutation, you first call `useDeletePatientNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatientNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePatientNoteMutation, { data, loading, error }] = useDeletePatientNoteMutation({
 *   variables: {
 *      noteToDelete: // value for 'noteToDelete'
 *   },
 * });
 */
export function useDeletePatientNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeletePatientNoteMutation, DeletePatientNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePatientNoteMutation, DeletePatientNoteMutationVariables>(DeletePatientNoteDocument, options);
      }
export type DeletePatientNoteMutationHookResult = ReturnType<typeof useDeletePatientNoteMutation>;
export type DeletePatientNoteMutationResult = Apollo.MutationResult<DeletePatientNoteMutation>;
export type DeletePatientNoteMutationOptions = Apollo.BaseMutationOptions<DeletePatientNoteMutation, DeletePatientNoteMutationVariables>;
export const UpdatePatientCaseDocument = gql`
    mutation UpdatePatientCase($formInformationToSubmit: UpdatePatientCaseInput!) {
  vet {
    updatePatientCase(patientCase: $formInformationToSubmit) {
      ...PracticePetCardFragment
    }
  }
}
    ${PracticePetCardFragmentDoc}`;
export type UpdatePatientCaseMutationFn = Apollo.MutationFunction<UpdatePatientCaseMutation, UpdatePatientCaseMutationVariables>;

/**
 * __useUpdatePatientCaseMutation__
 *
 * To run a mutation, you first call `useUpdatePatientCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientCaseMutation, { data, loading, error }] = useUpdatePatientCaseMutation({
 *   variables: {
 *      formInformationToSubmit: // value for 'formInformationToSubmit'
 *   },
 * });
 */
export function useUpdatePatientCaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientCaseMutation, UpdatePatientCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientCaseMutation, UpdatePatientCaseMutationVariables>(UpdatePatientCaseDocument, options);
      }
export type UpdatePatientCaseMutationHookResult = ReturnType<typeof useUpdatePatientCaseMutation>;
export type UpdatePatientCaseMutationResult = Apollo.MutationResult<UpdatePatientCaseMutation>;
export type UpdatePatientCaseMutationOptions = Apollo.BaseMutationOptions<UpdatePatientCaseMutation, UpdatePatientCaseMutationVariables>;
export const UpdatePracticeOnboardingChecklistStatusDocument = gql`
    mutation UpdatePracticeOnboardingChecklistStatus($formInformationToSubmit: UpdatePracticeOnboardingChecklistInput!) {
  vet {
    updatePracticeOnboardingChecklistStatus(checklistItem: $formInformationToSubmit) {
      ...OnboardingChecklistStatusFragment
    }
  }
}
    ${OnboardingChecklistStatusFragmentDoc}`;
export type UpdatePracticeOnboardingChecklistStatusMutationFn = Apollo.MutationFunction<UpdatePracticeOnboardingChecklistStatusMutation, UpdatePracticeOnboardingChecklistStatusMutationVariables>;

/**
 * __useUpdatePracticeOnboardingChecklistStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePracticeOnboardingChecklistStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePracticeOnboardingChecklistStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePracticeOnboardingChecklistStatusMutation, { data, loading, error }] = useUpdatePracticeOnboardingChecklistStatusMutation({
 *   variables: {
 *      formInformationToSubmit: // value for 'formInformationToSubmit'
 *   },
 * });
 */
export function useUpdatePracticeOnboardingChecklistStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePracticeOnboardingChecklistStatusMutation, UpdatePracticeOnboardingChecklistStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePracticeOnboardingChecklistStatusMutation, UpdatePracticeOnboardingChecklistStatusMutationVariables>(UpdatePracticeOnboardingChecklistStatusDocument, options);
      }
export type UpdatePracticeOnboardingChecklistStatusMutationHookResult = ReturnType<typeof useUpdatePracticeOnboardingChecklistStatusMutation>;
export type UpdatePracticeOnboardingChecklistStatusMutationResult = Apollo.MutationResult<UpdatePracticeOnboardingChecklistStatusMutation>;
export type UpdatePracticeOnboardingChecklistStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePracticeOnboardingChecklistStatusMutation, UpdatePracticeOnboardingChecklistStatusMutationVariables>;
export const GetPetUuidDocument = gql`
    query GetPetUuid($petNum: Int!) {
  me {
    id
    petByPetNum(petNum: $petNum) {
      id
    }
  }
}
    `;

/**
 * __useGetPetUuidQuery__
 *
 * To run a query within a React component, call `useGetPetUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPetUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPetUuidQuery({
 *   variables: {
 *      petNum: // value for 'petNum'
 *   },
 * });
 */
export function useGetPetUuidQuery(baseOptions: Apollo.QueryHookOptions<GetPetUuidQuery, GetPetUuidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPetUuidQuery, GetPetUuidQueryVariables>(GetPetUuidDocument, options);
      }
export function useGetPetUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPetUuidQuery, GetPetUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPetUuidQuery, GetPetUuidQueryVariables>(GetPetUuidDocument, options);
        }
export type GetPetUuidQueryHookResult = ReturnType<typeof useGetPetUuidQuery>;
export type GetPetUuidLazyQueryHookResult = ReturnType<typeof useGetPetUuidLazyQuery>;
export type GetPetUuidQueryResult = Apollo.QueryResult<GetPetUuidQuery, GetPetUuidQueryVariables>;
export const GetGeneticStatsSectionDataDocument = gql`
    query getGeneticStatsSectionData($petNum: Int!) {
  me {
    id
    petByPetNum(petNum: $petNum) {
      id
      ...GeneticStatsSectionFragment
    }
  }
}
    ${GeneticStatsSectionFragmentDoc}`;

/**
 * __useGetGeneticStatsSectionDataQuery__
 *
 * To run a query within a React component, call `useGetGeneticStatsSectionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneticStatsSectionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneticStatsSectionDataQuery({
 *   variables: {
 *      petNum: // value for 'petNum'
 *   },
 * });
 */
export function useGetGeneticStatsSectionDataQuery(baseOptions: Apollo.QueryHookOptions<GetGeneticStatsSectionDataQuery, GetGeneticStatsSectionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneticStatsSectionDataQuery, GetGeneticStatsSectionDataQueryVariables>(GetGeneticStatsSectionDataDocument, options);
      }
export function useGetGeneticStatsSectionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneticStatsSectionDataQuery, GetGeneticStatsSectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneticStatsSectionDataQuery, GetGeneticStatsSectionDataQueryVariables>(GetGeneticStatsSectionDataDocument, options);
        }
export type GetGeneticStatsSectionDataQueryHookResult = ReturnType<typeof useGetGeneticStatsSectionDataQuery>;
export type GetGeneticStatsSectionDataLazyQueryHookResult = ReturnType<typeof useGetGeneticStatsSectionDataLazyQuery>;
export type GetGeneticStatsSectionDataQueryResult = Apollo.QueryResult<GetGeneticStatsSectionDataQuery, GetGeneticStatsSectionDataQueryVariables>;
export const GetLocationsForPetDocument = gql`
    query GetLocationsForPet($petNum: Int!) {
  me {
    id
    petByPetNum(petNum: $petNum) {
      id
      petNum
      locations {
        born {
          addressInput
        }
        from {
          addressInput
        }
        live {
          addressInput
        }
      }
    }
  }
}
    `;

/**
 * __useGetLocationsForPetQuery__
 *
 * To run a query within a React component, call `useGetLocationsForPetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsForPetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsForPetQuery({
 *   variables: {
 *      petNum: // value for 'petNum'
 *   },
 * });
 */
export function useGetLocationsForPetQuery(baseOptions: Apollo.QueryHookOptions<GetLocationsForPetQuery, GetLocationsForPetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsForPetQuery, GetLocationsForPetQueryVariables>(GetLocationsForPetDocument, options);
      }
export function useGetLocationsForPetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsForPetQuery, GetLocationsForPetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsForPetQuery, GetLocationsForPetQueryVariables>(GetLocationsForPetDocument, options);
        }
export type GetLocationsForPetQueryHookResult = ReturnType<typeof useGetLocationsForPetQuery>;
export type GetLocationsForPetLazyQueryHookResult = ReturnType<typeof useGetLocationsForPetLazyQuery>;
export type GetLocationsForPetQueryResult = Apollo.QueryResult<GetLocationsForPetQuery, GetLocationsForPetQueryVariables>;
export const UpdatePetLocationsDocument = gql`
    mutation UpdatePetLocations($petLocations: UpdatePetLocationsInput!) {
  pet {
    updatePetLocations(petLocations: $petLocations) {
      id
    }
  }
}
    `;
export type UpdatePetLocationsMutationFn = Apollo.MutationFunction<UpdatePetLocationsMutation, UpdatePetLocationsMutationVariables>;

/**
 * __useUpdatePetLocationsMutation__
 *
 * To run a mutation, you first call `useUpdatePetLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePetLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePetLocationsMutation, { data, loading, error }] = useUpdatePetLocationsMutation({
 *   variables: {
 *      petLocations: // value for 'petLocations'
 *   },
 * });
 */
export function useUpdatePetLocationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePetLocationsMutation, UpdatePetLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePetLocationsMutation, UpdatePetLocationsMutationVariables>(UpdatePetLocationsDocument, options);
      }
export type UpdatePetLocationsMutationHookResult = ReturnType<typeof useUpdatePetLocationsMutation>;
export type UpdatePetLocationsMutationResult = Apollo.MutationResult<UpdatePetLocationsMutation>;
export type UpdatePetLocationsMutationOptions = Apollo.BaseMutationOptions<UpdatePetLocationsMutation, UpdatePetLocationsMutationVariables>;
export const GetPetResultsNavDataDocument = gql`
    query getPetResultsNavData($petNum: Int!) {
  me {
    id
    petByPetNum(petNum: $petNum) {
      id
      ...PetResultsNavFragment
    }
  }
}
    ${PetResultsNavFragmentDoc}`;

/**
 * __useGetPetResultsNavDataQuery__
 *
 * To run a query within a React component, call `useGetPetResultsNavDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPetResultsNavDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPetResultsNavDataQuery({
 *   variables: {
 *      petNum: // value for 'petNum'
 *   },
 * });
 */
export function useGetPetResultsNavDataQuery(baseOptions: Apollo.QueryHookOptions<GetPetResultsNavDataQuery, GetPetResultsNavDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPetResultsNavDataQuery, GetPetResultsNavDataQueryVariables>(GetPetResultsNavDataDocument, options);
      }
export function useGetPetResultsNavDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPetResultsNavDataQuery, GetPetResultsNavDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPetResultsNavDataQuery, GetPetResultsNavDataQueryVariables>(GetPetResultsNavDataDocument, options);
        }
export type GetPetResultsNavDataQueryHookResult = ReturnType<typeof useGetPetResultsNavDataQuery>;
export type GetPetResultsNavDataLazyQueryHookResult = ReturnType<typeof useGetPetResultsNavDataLazyQuery>;
export type GetPetResultsNavDataQueryResult = Apollo.QueryResult<GetPetResultsNavDataQuery, GetPetResultsNavDataQueryVariables>;
export const GetProfileDataSettingsDataDocument = gql`
    query getProfileDataSettingsData($petNum: Int!) {
  me {
    id
    ...ProfileDataSettingsCardUserFragment
    petByPetNum(petNum: $petNum) {
      id
      ...ProfileDataSettingsCardFragment
    }
  }
}
    ${ProfileDataSettingsCardUserFragmentDoc}
${ProfileDataSettingsCardFragmentDoc}`;

/**
 * __useGetProfileDataSettingsDataQuery__
 *
 * To run a query within a React component, call `useGetProfileDataSettingsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileDataSettingsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileDataSettingsDataQuery({
 *   variables: {
 *      petNum: // value for 'petNum'
 *   },
 * });
 */
export function useGetProfileDataSettingsDataQuery(baseOptions: Apollo.QueryHookOptions<GetProfileDataSettingsDataQuery, GetProfileDataSettingsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileDataSettingsDataQuery, GetProfileDataSettingsDataQueryVariables>(GetProfileDataSettingsDataDocument, options);
      }
export function useGetProfileDataSettingsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileDataSettingsDataQuery, GetProfileDataSettingsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileDataSettingsDataQuery, GetProfileDataSettingsDataQueryVariables>(GetProfileDataSettingsDataDocument, options);
        }
export type GetProfileDataSettingsDataQueryHookResult = ReturnType<typeof useGetProfileDataSettingsDataQuery>;
export type GetProfileDataSettingsDataLazyQueryHookResult = ReturnType<typeof useGetProfileDataSettingsDataLazyQuery>;
export type GetProfileDataSettingsDataQueryResult = Apollo.QueryResult<GetProfileDataSettingsDataQuery, GetProfileDataSettingsDataQueryVariables>;
export const GetVeterinaryInformationForPetDocument = gql`
    query GetVeterinaryInformationForPet($petNum: Int!) {
  me {
    id
    petByPetNum(petNum: $petNum) {
      id
      petNum
      embarkMayContactVet
      practiceLocation {
        name
        placeId
        formattedAddress
      }
    }
  }
}
    `;

/**
 * __useGetVeterinaryInformationForPetQuery__
 *
 * To run a query within a React component, call `useGetVeterinaryInformationForPetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVeterinaryInformationForPetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVeterinaryInformationForPetQuery({
 *   variables: {
 *      petNum: // value for 'petNum'
 *   },
 * });
 */
export function useGetVeterinaryInformationForPetQuery(baseOptions: Apollo.QueryHookOptions<GetVeterinaryInformationForPetQuery, GetVeterinaryInformationForPetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVeterinaryInformationForPetQuery, GetVeterinaryInformationForPetQueryVariables>(GetVeterinaryInformationForPetDocument, options);
      }
export function useGetVeterinaryInformationForPetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVeterinaryInformationForPetQuery, GetVeterinaryInformationForPetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVeterinaryInformationForPetQuery, GetVeterinaryInformationForPetQueryVariables>(GetVeterinaryInformationForPetDocument, options);
        }
export type GetVeterinaryInformationForPetQueryHookResult = ReturnType<typeof useGetVeterinaryInformationForPetQuery>;
export type GetVeterinaryInformationForPetLazyQueryHookResult = ReturnType<typeof useGetVeterinaryInformationForPetLazyQuery>;
export type GetVeterinaryInformationForPetQueryResult = Apollo.QueryResult<GetVeterinaryInformationForPetQuery, GetVeterinaryInformationForPetQueryVariables>;
export const UpdateVetPracticeDetailsDocument = gql`
    mutation UpdateVetPracticeDetails($vetPracticeDetails: VetPracticeDetailsInput!) {
  pet {
    updateVetPracticeDetails(vetPracticeDetails: $vetPracticeDetails)
  }
}
    `;
export type UpdateVetPracticeDetailsMutationFn = Apollo.MutationFunction<UpdateVetPracticeDetailsMutation, UpdateVetPracticeDetailsMutationVariables>;

/**
 * __useUpdateVetPracticeDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateVetPracticeDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVetPracticeDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVetPracticeDetailsMutation, { data, loading, error }] = useUpdateVetPracticeDetailsMutation({
 *   variables: {
 *      vetPracticeDetails: // value for 'vetPracticeDetails'
 *   },
 * });
 */
export function useUpdateVetPracticeDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVetPracticeDetailsMutation, UpdateVetPracticeDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVetPracticeDetailsMutation, UpdateVetPracticeDetailsMutationVariables>(UpdateVetPracticeDetailsDocument, options);
      }
export type UpdateVetPracticeDetailsMutationHookResult = ReturnType<typeof useUpdateVetPracticeDetailsMutation>;
export type UpdateVetPracticeDetailsMutationResult = Apollo.MutationResult<UpdateVetPracticeDetailsMutation>;
export type UpdateVetPracticeDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateVetPracticeDetailsMutation, UpdateVetPracticeDetailsMutationVariables>;
export const GetPetForShareResultsWithVetDocument = gql`
    query GetPetForShareResultsWithVet($petNum: Int!) {
  me {
    id
    petByPetNum(petNum: $petNum) {
      ...ShareResultsWithVetFragment
    }
  }
}
    ${ShareResultsWithVetFragmentDoc}`;

/**
 * __useGetPetForShareResultsWithVetQuery__
 *
 * To run a query within a React component, call `useGetPetForShareResultsWithVetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPetForShareResultsWithVetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPetForShareResultsWithVetQuery({
 *   variables: {
 *      petNum: // value for 'petNum'
 *   },
 * });
 */
export function useGetPetForShareResultsWithVetQuery(baseOptions: Apollo.QueryHookOptions<GetPetForShareResultsWithVetQuery, GetPetForShareResultsWithVetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPetForShareResultsWithVetQuery, GetPetForShareResultsWithVetQueryVariables>(GetPetForShareResultsWithVetDocument, options);
      }
export function useGetPetForShareResultsWithVetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPetForShareResultsWithVetQuery, GetPetForShareResultsWithVetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPetForShareResultsWithVetQuery, GetPetForShareResultsWithVetQueryVariables>(GetPetForShareResultsWithVetDocument, options);
        }
export type GetPetForShareResultsWithVetQueryHookResult = ReturnType<typeof useGetPetForShareResultsWithVetQuery>;
export type GetPetForShareResultsWithVetLazyQueryHookResult = ReturnType<typeof useGetPetForShareResultsWithVetLazyQuery>;
export type GetPetForShareResultsWithVetQueryResult = Apollo.QueryResult<GetPetForShareResultsWithVetQuery, GetPetForShareResultsWithVetQueryVariables>;
export const GetAllBreedsDocument = gql`
    query GetAllBreeds {
  allBreeds {
    displayName
    ancestryLabel
  }
  identifiableBreeds {
    displayName
    ancestryLabel
  }
  designerBreeds {
    displayName
    ancestryLabel
  }
}
    `;

/**
 * __useGetAllBreedsQuery__
 *
 * To run a query within a React component, call `useGetAllBreedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBreedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBreedsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllBreedsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllBreedsQuery, GetAllBreedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBreedsQuery, GetAllBreedsQueryVariables>(GetAllBreedsDocument, options);
      }
export function useGetAllBreedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBreedsQuery, GetAllBreedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBreedsQuery, GetAllBreedsQueryVariables>(GetAllBreedsDocument, options);
        }
export type GetAllBreedsQueryHookResult = ReturnType<typeof useGetAllBreedsQuery>;
export type GetAllBreedsLazyQueryHookResult = ReturnType<typeof useGetAllBreedsLazyQuery>;
export type GetAllBreedsQueryResult = Apollo.QueryResult<GetAllBreedsQuery, GetAllBreedsQueryVariables>;
export const AddFeedbackDocument = gql`
    mutation AddFeedback($feedback: FeedbackInput!) {
  user {
    addFeedback(feedback: $feedback)
  }
}
    `;
export type AddFeedbackMutationFn = Apollo.MutationFunction<AddFeedbackMutation, AddFeedbackMutationVariables>;

/**
 * __useAddFeedbackMutation__
 *
 * To run a mutation, you first call `useAddFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeedbackMutation, { data, loading, error }] = useAddFeedbackMutation({
 *   variables: {
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useAddFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<AddFeedbackMutation, AddFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFeedbackMutation, AddFeedbackMutationVariables>(AddFeedbackDocument, options);
      }
export type AddFeedbackMutationHookResult = ReturnType<typeof useAddFeedbackMutation>;
export type AddFeedbackMutationResult = Apollo.MutationResult<AddFeedbackMutation>;
export type AddFeedbackMutationOptions = Apollo.BaseMutationOptions<AddFeedbackMutation, AddFeedbackMutationVariables>;
export const ShowFeedbackDocument = gql`
    query ShowFeedback($page: String!, $variant: String, $petUuid: String) {
  me {
    id
    shouldShowFeedback(page: $page, variant: $variant, petUuid: $petUuid)
  }
}
    `;

/**
 * __useShowFeedbackQuery__
 *
 * To run a query within a React component, call `useShowFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowFeedbackQuery({
 *   variables: {
 *      page: // value for 'page'
 *      variant: // value for 'variant'
 *      petUuid: // value for 'petUuid'
 *   },
 * });
 */
export function useShowFeedbackQuery(baseOptions: Apollo.QueryHookOptions<ShowFeedbackQuery, ShowFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShowFeedbackQuery, ShowFeedbackQueryVariables>(ShowFeedbackDocument, options);
      }
export function useShowFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShowFeedbackQuery, ShowFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShowFeedbackQuery, ShowFeedbackQueryVariables>(ShowFeedbackDocument, options);
        }
export type ShowFeedbackQueryHookResult = ReturnType<typeof useShowFeedbackQuery>;
export type ShowFeedbackLazyQueryHookResult = ReturnType<typeof useShowFeedbackLazyQuery>;
export type ShowFeedbackQueryResult = Apollo.QueryResult<ShowFeedbackQuery, ShowFeedbackQueryVariables>;
export const GetFooterDataDocument = gql`
    query getFooterData($petNum: Int!, $shouldLoadPet: Boolean!) {
  me {
    id
    ...FooterUserFragment
    petByPetNum(petNum: $petNum) @include(if: $shouldLoadPet) {
      id
      ...FooterPetFragment
    }
  }
}
    ${FooterUserFragmentDoc}
${FooterPetFragmentDoc}`;

/**
 * __useGetFooterDataQuery__
 *
 * To run a query within a React component, call `useGetFooterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFooterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFooterDataQuery({
 *   variables: {
 *      petNum: // value for 'petNum'
 *      shouldLoadPet: // value for 'shouldLoadPet'
 *   },
 * });
 */
export function useGetFooterDataQuery(baseOptions: Apollo.QueryHookOptions<GetFooterDataQuery, GetFooterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFooterDataQuery, GetFooterDataQueryVariables>(GetFooterDataDocument, options);
      }
export function useGetFooterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFooterDataQuery, GetFooterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFooterDataQuery, GetFooterDataQueryVariables>(GetFooterDataDocument, options);
        }
export type GetFooterDataQueryHookResult = ReturnType<typeof useGetFooterDataQuery>;
export type GetFooterDataLazyQueryHookResult = ReturnType<typeof useGetFooterDataLazyQuery>;
export type GetFooterDataQueryResult = Apollo.QueryResult<GetFooterDataQuery, GetFooterDataQueryVariables>;
export const UpdateProfileDataSettingsDocument = gql`
    mutation UpdateProfileDataSettings($petNum: Int!, $preferences: PetPreferencesInput!) {
  pet {
    updatePetPreferences(petNum: $petNum, preferences: $preferences) {
      id
      preferences {
        shareCareResourcesSurveys
        shareCareResourcesProfileAndResults
      }
    }
  }
}
    `;
export type UpdateProfileDataSettingsMutationFn = Apollo.MutationFunction<UpdateProfileDataSettingsMutation, UpdateProfileDataSettingsMutationVariables>;

/**
 * __useUpdateProfileDataSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateProfileDataSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileDataSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileDataSettingsMutation, { data, loading, error }] = useUpdateProfileDataSettingsMutation({
 *   variables: {
 *      petNum: // value for 'petNum'
 *      preferences: // value for 'preferences'
 *   },
 * });
 */
export function useUpdateProfileDataSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileDataSettingsMutation, UpdateProfileDataSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileDataSettingsMutation, UpdateProfileDataSettingsMutationVariables>(UpdateProfileDataSettingsDocument, options);
      }
export type UpdateProfileDataSettingsMutationHookResult = ReturnType<typeof useUpdateProfileDataSettingsMutation>;
export type UpdateProfileDataSettingsMutationResult = Apollo.MutationResult<UpdateProfileDataSettingsMutation>;
export type UpdateProfileDataSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateProfileDataSettingsMutation, UpdateProfileDataSettingsMutationVariables>;
export const ShareResultsWithVetDocument = gql`
    mutation ShareResultsWithVet($shareResultsWithVetInput: ShareResultsWithVetInput!) {
  pet {
    shareResultsWithVet(shareResultsWithVetInput: $shareResultsWithVetInput)
  }
}
    `;
export type ShareResultsWithVetMutationFn = Apollo.MutationFunction<ShareResultsWithVetMutation, ShareResultsWithVetMutationVariables>;

/**
 * __useShareResultsWithVetMutation__
 *
 * To run a mutation, you first call `useShareResultsWithVetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareResultsWithVetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareResultsWithVetMutation, { data, loading, error }] = useShareResultsWithVetMutation({
 *   variables: {
 *      shareResultsWithVetInput: // value for 'shareResultsWithVetInput'
 *   },
 * });
 */
export function useShareResultsWithVetMutation(baseOptions?: Apollo.MutationHookOptions<ShareResultsWithVetMutation, ShareResultsWithVetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareResultsWithVetMutation, ShareResultsWithVetMutationVariables>(ShareResultsWithVetDocument, options);
      }
export type ShareResultsWithVetMutationHookResult = ReturnType<typeof useShareResultsWithVetMutation>;
export type ShareResultsWithVetMutationResult = Apollo.MutationResult<ShareResultsWithVetMutation>;
export type ShareResultsWithVetMutationOptions = Apollo.BaseMutationOptions<ShareResultsWithVetMutation, ShareResultsWithVetMutationVariables>;